export default {
    street: 
    
    [
      {
        "code": "ML1",
        "ward_code": "ML",
        "ward": "Mỹ Long",
        "street": "Nguyễn Trãi",
        "street_code": "NT",
        "street_2": "Suốt đường",
        "street_type": 1,
        "price": 45
      },
      {
        "code": "ML2",
        "ward_code": "ML",
        "ward": "Mỹ Long",
        "street": "Hai Bà Trưng",
        "street_code": "HBT",
        "street_2": "Nguyễn Trãi - Ngô Gia Tự",
        "street_type": 1,
        "price": 45
      },
      {
        "code": "ML3",
        "ward_code": "ML",
        "ward": "Mỹ Long",
        "street": "Nguyễn Huệ",
        "street_code": "NH",
        "street_2": "Suốt đường",
        "street_type": 1,
        "price": 45
      },
      {
        "code": "ML4A",
        "ward_code": "ML",
        "ward": "Mỹ Long",
        "street": "Hùng Vương",
        "street_code": "HV",
        "street_2": "Ngô Gia Tự - Lý Thái Tổ - Cầu Cái Sơn",
        "street_type": 1,
        "price": 32.5
      },
      {
        "code": "ML5",
        "ward_code": "ML",
        "ward": "Mỹ Long",
        "street": "Ngô Gia Tự",
        "street_code": "NGT",
        "street_2": "Suốt đường",
        "street_type": 1,
        "price": 39
      },
      {
        "code": "ML6",
        "ward_code": "ML",
        "ward": "Mỹ Long",
        "street": "Phan Đình Phùng",
        "street_code": "PĐP",
        "street_2": "Suốt đường",
        "street_type": 1,
        "price": 35
      },
      {
        "code": "ML7",
        "ward_code": "ML",
        "ward": "Mỹ Long",
        "street": "Lý Thái Tổ",
        "street_code": "LTT",
        "street_2": "Suốt đường",
        "street_type": 1,
        "price": 32.5
      },
      {
        "code": "ML8",
        "ward_code": "ML",
        "ward": "Mỹ Long",
        "street": "Ngô Thời Nhậm",
        "street_code": "NTN",
        "street_2": "Suốt đường",
        "street_type": 1,
        "price": 32.5
      },
      {
        "code": "ML9A",
        "ward_code": "ML",
        "ward": "Mỹ Long",
        "street": "Điện Biên Phủ",
        "street_code": "ĐBP",
        "street_2": "Nguyễn Trãi - Lý Thái Tổ - Lê Thánh Tôn",
        "street_type": 1,
        "price": 24.7
      },
      {
        "code": "ML10",
        "ward_code": "ML",
        "ward": "Mỹ Long",
        "street": "Nguyễn Văn Cưng",
        "street_code": "NVC",
        "street_2": "Suốt đường",
        "street_type": 1,
        "price": 32.5
      },
      {
        "code": "ML11",
        "ward_code": "ML",
        "ward": "Mỹ Long",
        "street": "Lý Tự Trọng",
        "street_code": "LTT",
        "street_2": "Suốt đường Lý Tự Trọng",
        "street_type": 1,
        "price": 26
      },
      {
        "code": "ML12",
        "ward_code": "ML",
        "ward": "Mỹ Long",
        "street": "Nguyễn Thị Minh Khai",
        "street_code": "NTMK",
        "street_2": "Suốt đường",
        "street_type": 1,
        "price": 26
      },
      {
        "code": "ML13",
        "ward_code": "ML",
        "ward": "Mỹ Long",
        "street": "Thi Sách",
        "street_code": "TS",
        "street_2": "Nguyễn Trãi - Trần Nhật Duật",
        "street_type": 1,
        "price": 22.7
      },
      {
        "code": "ML14",
        "ward_code": "ML",
        "ward": "Mỹ Long",
        "street": "Trần Hưng Đạo",
        "street_code": "THĐ",
        "street_2": "Cầu Cái Sơn - Cầu Hoàng Diệu",
        "street_type": 1,
        "price": 30
      },
      {
        "code": "ML15",
        "ward_code": "ML",
        "ward": "Mỹ Long",
        "street": "Lê Thị Nhiên",
        "street_code": "LTN",
        "street_2": "Suốt đường",
        "street_type": 1,
        "price": 20
      },
      {
        "code": "ML16A",
        "ward_code": "ML",
        "ward": "Mỹ Long",
        "street": "Thoại Ngọc Hầu",
        "street_code": "TNH",
        "street_2": "Nguyễn Trãi - Lý Thái Tổ - Cầu Cái Sơn",
        "street_type": 1,
        "price": 21.5
      },
      {
        "code": "ML17",
        "ward_code": "ML",
        "ward": "Mỹ Long",
        "street": "Lê Minh Ngươn",
        "street_code": "LMN",
        "street_2": "Nguyễn Trãi - Cầu Duy Tân",
        "street_type": 1,
        "price": 22.7
      },
      {
        "code": "ML18",
        "ward_code": "ML",
        "ward": "Mỹ Long",
        "street": "Bạch Đằng",
        "street_code": "BĐ",
        "street_2": "Suốt đường",
        "street_type": 1,
        "price": 21.45
      },
      {
        "code": "ML19",
        "ward_code": "ML",
        "ward": "Mỹ Long",
        "street": "Phạm Hồng Thái",
        "street_code": "PHT",
        "street_2": "Suốt đường",
        "street_type": 1,
        "price": 15.6
      },
      {
        "code": "ML20",
        "ward_code": "ML",
        "ward": "Mỹ Long",
        "street": "Phan Chu Trinh",
        "street_code": "PCT",
        "street_2": "Suốt đường",
        "street_type": 1,
        "price": 15.6
      },
      {
        "code": "ML21",
        "ward_code": "ML",
        "ward": "Mỹ Long",
        "street": "Phan Thành Long",
        "street_code": "PTL",
        "street_2": "Suốt đường",
        "street_type": 1,
        "price": 15.6
      },
      {
        "code": "ML22",
        "ward_code": "ML",
        "ward": "Mỹ Long",
        "street": "Đoàn Văn Phối",
        "street_code": "ĐVP",
        "street_2": "Suốt đường",
        "street_type": 1,
        "price": 15.6
      },
      {
        "code": "ML23",
        "ward_code": "ML",
        "ward": "Mỹ Long",
        "street": "Lương Văn Cù",
        "street_code": "LVC",
        "street_2": "Suốt đường",
        "street_type": 1,
        "price": 19.5
      },
      {
        "code": "ML24",
        "ward_code": "ML",
        "ward": "Mỹ Long",
        "street": "Huỳnh Thị Hưởng",
        "street_code": "HTH",
        "street_2": "Suốt đường",
        "street_type": 1,
        "price": 19.5
      },
      {
        "code": "ML25",
        "ward_code": "ML",
        "ward": "Mỹ Long",
        "street": "Chu Văn An",
        "street_code": "CVA",
        "street_2": "Suốt đường",
        "street_type": 1,
        "price": 22.7
      },
      {
        "code": "ML26A",
        "ward_code": "ML",
        "ward": "Mỹ Long",
        "street": "Kim Đồng",
        "street_code": "KĐ",
        "street_2": "Nguyễn Trãi - Lý Thái Tổ - Nguyễn Bỉnh Khiêm",
        "street_type": 1,
        "price": 18.2
      },
      {
        "code": "ML27",
        "ward_code": "ML",
        "ward": "Mỹ Long",
        "street": "Nguyễn Đình Chiểu",
        "street_code": "NĐC",
        "street_2": "Suốt đường",
        "street_type": 1,
        "price": 12
      },
      {
        "code": "ML28",
        "ward_code": "ML",
        "ward": "Mỹ Long",
        "street": "Huỳnh Văn Hây",
        "street_code": "HVH",
        "street_2": "Suốt đường",
        "street_type": 1,
        "price": 12
      },
      {
        "code": "ML29",
        "ward_code": "ML",
        "ward": "Mỹ Long",
        "street": "Tản Đà",
        "street_code": "TĐ",
        "street_2": "Suốt đường",
        "street_type": 1,
        "price": 19.5
      },
      {
        "code": "ML30",
        "ward_code": "ML",
        "ward": "Mỹ Long",
        "street": "Trần Nguyên Hãn",
        "street_code": "TNH",
        "street_2": "Suốt đường",
        "street_type": 1,
        "price": 19.5
      },
      {
        "code": "ML31",
        "ward_code": "ML",
        "ward": "Mỹ Long",
        "street": "Trần Nhật Duật",
        "street_code": "TND",
        "street_2": "Suốt đường",
        "street_type": 1,
        "price": 16.9
      },
      {
        "code": "ML32",
        "ward_code": "ML",
        "ward": "Mỹ Long",
        "street": "Đặng Dung",
        "street_code": "ĐD",
        "street_2": "Hùng Vương - Thoại Ngọc Hầu",
        "street_type": 1,
        "price": 19.5
      },
      {
        "code": "ML33",
        "ward_code": "ML",
        "ward": "Mỹ Long",
        "street": "Châu Thị Tế",
        "street_code": "CTT",
        "street_2": "Suốt đường",
        "street_type": 1,
        "price": 16.9
      },
      {
        "code": "ML34",
        "ward_code": "ML",
        "ward": "Mỹ Long",
        "street": "Đặng Dung Nối Dài",
        "street_code": "ĐDND",
        "street_2": "Điện Biên Phủ - Kim Đồng",
        "street_type": 1,
        "price": 16.9
      },
      {
        "code": "ML35",
        "ward_code": "ML",
        "ward": "Mỹ Long",
        "street": "Nam Đặng Dung",
        "street_code": "NĐD",
        "street_2": "Suốt đường",
        "street_type": 1,
        "price": 16.3
      },
      {
        "code": "ML36",
        "ward_code": "ML",
        "ward": "Mỹ Long",
        "street": "Phan Huy Chú",
        "street_code": "PHC",
        "street_2": "Suốt đường",
        "street_type": 1,
        "price": 15
      },
      {
        "code": "ML37",
        "ward_code": "ML",
        "ward": "Mỹ Long",
        "street": "Nguyễn Văn Sừng",
        "street_code": "NVS",
        "street_2": "Suốt đường",
        "street_type": 2,
        "price": 10
      },
      {
        "code": "ML38",
        "ward_code": "ML",
        "ward": "Mỹ Long",
        "street": "Nguyễn Bỉnh Khiêm",
        "street_code": "NBK",
        "street_2": "Suốt đường",
        "street_type": 2,
        "price": 12.35
      },
      {
        "code": "ML39",
        "ward_code": "ML",
        "ward": "Mỹ Long",
        "street": "Lê Văn Hưu",
        "street_code": "LVH",
        "street_2": "Suốt đường",
        "street_type": 2,
        "price": 13
      },
      {
        "code": "ML40",
        "ward_code": "ML",
        "ward": "Mỹ Long",
        "street": "Hồ Xuân Hương",
        "street_code": "HXH",
        "street_2": "Suốt đường",
        "street_type": 2,
        "price": 10.4
      },
      {
        "code": "ML41",
        "ward_code": "ML",
        "ward": "Mỹ Long",
        "street": "Nguyễn Phi Khanh",
        "street_code": "NPK",
        "street_2": "Suốt đường",
        "street_type": 2,
        "price": 11.7
      },
      {
        "code": "ML42",
        "ward_code": "ML",
        "ward": "Mỹ Long",
        "street": "Trần Hữu Trang",
        "street_code": "THT",
        "street_2": "Suốt đường",
        "street_type": 2,
        "price": 11.7
      },
      {
        "code": "ML43",
        "ward_code": "ML",
        "ward": "Mỹ Long",
        "street": "Cống Quỳnh",
        "street_code": "CQ",
        "street_2": "Suốt đường",
        "street_type": 2,
        "price": 11.7
      },
      {
        "code": "ML44",
        "ward_code": "ML",
        "ward": "Mỹ Long",
        "street": "Hẻm cặp Ngân Hàng Công Thương",
        "street_code": "HNHCT",
        "street_2": "Lý Thái Tổ - Cuối hẻm",
        "street_type": 2,
        "price": 9
      },
      {
        "code": "ML45",
        "ward_code": "ML",
        "ward": "Mỹ Long",
        "street": "Hẻm đường Châu Thị Tế",
        "street_code": "HCTT",
        "street_2": "Châu Thị Tế - Hùng Vương",
        "street_type": 2,
        "price": 8
      },
      {
        "code": "ML46",
        "ward_code": "ML",
        "ward": "Mỹ Long",
        "street": "Lê Thánh Tôn",
        "street_code": "LTT",
        "street_2": "Điện Biên Phủ - Cuối hàng rào cung Thiếu nhi",
        "street_type": 3,
        "price": 5
      },
      {
        "code": "ML47",
        "ward_code": "ML",
        "ward": "Mỹ Long",
        "street": "Lương Thế Vinh",
        "street_code": "LTV",
        "street_2": "Suốt đường",
        "street_type": 3,
        "price": 7
      },
      {
        "code": "ML48",
        "ward_code": "ML",
        "ward": "Mỹ Long",
        "street": "Đường dự định Cặp Công An phường Mỹ Long",
        "street_code": "ĐCCAML",
        "street_2": "Nam Đặng Dung - Dãy khu dân cư đường Lý Thái Tổ",
        "street_type": 3,
        "price": 7
      },
      {
        "code": "ML49",
        "ward_code": "ML",
        "ward": "Mỹ Long",
        "street": "Đường Liên Tổ Khóm Phó Quế",
        "street_code": "ĐLTKPQ",
        "street_2": "Lương Thế Vinh - Đuôi cồn Phó Quế",
        "street_type": 3,
        "price": 5
      },
      {
        "code": "ML50",
        "ward_code": "ML",
        "ward": "Mỹ Long",
        "street": "Đường Cặp Rạch Cái Sơn",
        "street_code": "ĐCRCS",
        "street_2": "Trần Hưng Đạo - Hùng Vương",
        "street_type": 3,
        "price": 4
      },
      {
        "code": "ML51",
        "ward_code": "ML",
        "ward": "Mỹ Long",
        "street": "Kè Sông Hậu",
        "street_code": "KSH",
        "street_2": "Suốt đường",
        "street_type": 3,
        "price": 5
      },
      {
        "code": "ML52",
        "ward_code": "ML",
        "ward": "Mỹ Long",
        "street": "Khu Phú Cường PLAZA",
        "street_code": "KPCPLAZA",
        "street_2": "Lô nền/căn hộ trong dự án",
        "street_type": null,
        "price": null
      },
      {
        "code": "ML53",
        "ward_code": "ML",
        "ward": "Mỹ Long",
        "street": "Khu Tây Sông Hậu GĐ3",
        "street_code": "KTSHGĐ3",
        "street_2": "Các đường chưa đặt tên thuộc KDT Diomond GD3",
        "street_type": null,
        "price": null
      },
      {
        "code": "MB1",
        "ward_code": "MB",
        "ward": "Mỹ Bình",
        "street": "Tôn Đức Thắng",
        "street_code": "TĐT",
        "street_2": "Suốt đường",
        "street_type": 1,
        "price": 30
      },
      {
        "code": "MB2",
        "ward_code": "MB",
        "ward": "Mỹ Bình",
        "street": "Nguyễn Thái Học",
        "street_code": "NTH",
        "street_2": "Suốt đường",
        "street_type": 1,
        "price": 20
      },
      {
        "code": "MB3",
        "ward_code": "MB",
        "ward": "Mỹ Bình",
        "street": "Châu Văn Liêm",
        "street_code": "CVL",
        "street_2": "Suốt đường",
        "street_type": 1,
        "price": 15
      },
      {
        "code": "MB4",
        "ward_code": "MB",
        "ward": "Mỹ Bình",
        "street": "Trần Hưng Đạo",
        "street_code": "THĐ",
        "street_2": "Suốt đường",
        "street_type": 1,
        "price": 30
      },
      {
        "code": "MB5",
        "ward_code": "MB",
        "ward": "Mỹ Bình",
        "street": "Lê Lợi",
        "street_code": "LL",
        "street_2": "Suốt đường",
        "street_type": 1,
        "price": 15
      },
      {
        "code": "MB6",
        "ward_code": "MB",
        "ward": "Mỹ Bình",
        "street": "Lý Thường Kiệt",
        "street_code": "LTK",
        "street_2": "Suốt đường",
        "street_type": 1,
        "price": 15
      },
      {
        "code": "MB7",
        "ward_code": "MB",
        "ward": "Mỹ Bình",
        "street": "Lê Hồng Phong",
        "street_code": "LHP",
        "street_2": "Suốt đường",
        "street_type": 1,
        "price": 20
      },
      {
        "code": "MB8",
        "ward_code": "MB",
        "ward": "Mỹ Bình",
        "street": "Lê Triệu Kiết",
        "street_code": "LTK",
        "street_2": "Suốt đường",
        "street_type": 1,
        "price": 15
      },
      {
        "code": "MB9",
        "ward_code": "MB",
        "ward": "Mỹ Bình",
        "street": "Trần Quốc Toản",
        "street_code": "TQT",
        "street_2": "Suốt đường",
        "street_type": 2,
        "price": 13
      },
      {
        "code": "MB10",
        "ward_code": "MB",
        "ward": "Mỹ Bình",
        "street": "Đinh Tiên Hoàng",
        "street_code": "ĐTH",
        "street_2": "Suốt đường",
        "street_type": 2,
        "price": 13
      },
      {
        "code": "MB11",
        "ward_code": "MB",
        "ward": "Mỹ Bình",
        "street": "Ngô Quyền",
        "street_code": "NQ",
        "street_2": "Suốt đường",
        "street_type": 2,
        "price": 13
      },
      {
        "code": "MB12",
        "ward_code": "MB",
        "ward": "Mỹ Bình",
        "street": "Thủ Khoa Nghĩa",
        "street_code": "TKN",
        "street_2": "Lý Thường Kiệt - Phan Bá Vành",
        "street_type": 2,
        "price": 10
      },
      {
        "code": "MB13",
        "ward_code": "MB",
        "ward": "Mỹ Bình",
        "street": "Thủ Khoa Huân",
        "street_code": "TKH",
        "street_2": "Nguyễn Thái Ngọc - Ngọc Hân",
        "street_type": 2,
        "price": 10
      },
      {
        "code": "MB14",
        "ward_code": "MB",
        "ward": "Mỹ Bình",
        "street": "Phan Bá Vành",
        "street_code": "PBV",
        "street_2": "Tôn Đức Thắng - Thủ Khoa Huân",
        "street_type": 2,
        "price": 10
      },
      {
        "code": "MB15",
        "ward_code": "MB",
        "ward": "Mỹ Bình",
        "street": "Ngọc Hân",
        "street_code": "NH",
        "street_2": "Trần Hưng Đạo - Thủ Khoa Nghĩa",
        "street_type": 2,
        "price": 10
      },
      {
        "code": "MB16",
        "ward_code": "MB",
        "ward": "Mỹ Bình",
        "street": "Lê Văn Nhung",
        "street_code": "LVN",
        "street_2": "Trần Hưng Đạo - Nguyễn Thái Học",
        "street_type": 2,
        "price": 10
      },
      {
        "code": "MB17",
        "ward_code": "MB",
        "ward": "Mỹ Bình",
        "street": "Nguyễn Du",
        "street_code": "ND",
        "street_2": "Suốt đường",
        "street_type": 2,
        "price": 13
      },
      {
        "code": "MB18",
        "ward_code": "MB",
        "ward": "Mỹ Bình",
        "street": "Yết Kiêu",
        "street_code": "YK",
        "street_2": "Suốt tuyến",
        "street_type": 2,
        "price": 15
      },
      {
        "code": "MB19",
        "ward_code": "MB",
        "ward": "Mỹ Bình",
        "street": "Nguyễn Cư Trinh",
        "street_code": "NCT",
        "street_2": "Lý Thường Kiệt - Lê Hồng Phong",
        "street_type": 2,
        "price": 13
      },
      {
        "code": "MB20",
        "ward_code": "MB",
        "ward": "Mỹ Bình",
        "street": "Đường Bờ Kè Lê Văn Nhung",
        "street_code": "ĐBKLVN",
        "street_2": "Đường cặp bờ kè rạch Long Xuyên và các đường đấu nối với đường Lê Văn Nhung",
        "street_type": 2,
        "price": 10
      },
      {
        "code": "MB21",
        "ward_code": "MB",
        "ward": "Mỹ Bình",
        "street": "Khu phức hợp Sân Vận Động TT",
        "street_code": "KSVĐTT",
        "street_2": "Các đường nội bộ trong khu phức hợp sân vận động TT",
        "street_type": 2,
        "price": 10
      },
      {
        "code": "MB22",
        "ward_code": "MB",
        "ward": "Mỹ Bình",
        "street": "các Đường Nhánh Khu Hành Chính Tỉnh",
        "street_code": "ĐNKHCT",
        "street_2": "Nguyễn Thái Học - Lê Lai - Lý Thường Kiệt",
        "street_type": 3,
        "price": 5
      },
      {
        "code": "MB23",
        "ward_code": "MB",
        "ward": "Mỹ Bình",
        "street": "Lê Lai",
        "street_code": "LL",
        "street_2": "Suốt đường",
        "street_type": 3,
        "price": 9.1
      },
      {
        "code": "MB24",
        "ward_code": "MB",
        "ward": "Mỹ Bình",
        "street": "Phùng Hưng",
        "street_code": "PH",
        "street_2": "Suốt đường",
        "street_type": 3,
        "price": 9.1
      },
      {
        "code": "MB25",
        "ward_code": "MB",
        "ward": "Mỹ Bình",
        "street": "Hoàng Văn Thụ",
        "street_code": "HVT",
        "street_2": "Suốt đường",
        "street_type": 3,
        "price": 9.1
      },
      {
        "code": "MB26",
        "ward_code": "MB",
        "ward": "Mỹ Bình",
        "street": "La Sơn Phu Tử",
        "street_code": "LSPT",
        "street_2": "Lý Thường Kiệt - Lê Hồng Phong",
        "street_type": 3,
        "price": 9.1
      },
      {
        "code": "MB27",
        "ward_code": "MB",
        "ward": "Mỹ Bình",
        "street": "Khúc Thừa Dụ",
        "street_code": "KTD",
        "street_2": "Suốt đường",
        "street_type": 3,
        "price": 7
      },
      {
        "code": "MB28",
        "ward_code": "MB",
        "ward": "Mỹ Bình",
        "street": "Nguyễn Xí",
        "street_code": "NX",
        "street_2": "Suốt đường",
        "street_type": 3,
        "price": 6.5
      },
      {
        "code": "MB29",
        "ward_code": "MB",
        "ward": "Mỹ Bình",
        "street": "Lê Sát",
        "street_code": "LS",
        "street_2": "Suốt đường",
        "street_type": 3,
        "price": 6.5
      },
      {
        "code": "MB30",
        "ward_code": "MB",
        "ward": "Mỹ Bình",
        "street": "Phạm Văn Xảo",
        "street_code": "PVX",
        "street_2": "Suốt đường",
        "street_type": 3,
        "price": 6.5
      },
      {
        "code": "MB31",
        "ward_code": "MB",
        "ward": "Mỹ Bình",
        "street": "Cô Giang",
        "street_code": "CG",
        "street_2": "Suốt đường",
        "street_type": 3,
        "price": 6.5
      },
      {
        "code": "MB32",
        "ward_code": "MB",
        "ward": "Mỹ Bình",
        "street": "Cô Bắc",
        "street_code": "CB",
        "street_2": "Suốt đường",
        "street_type": 3,
        "price": 6.5
      },
      {
        "code": "MB33",
        "ward_code": "MB",
        "ward": "Mỹ Bình",
        "street": "Nguyễn Đăng Sơn",
        "street_code": "NĐS",
        "street_2": "Suốt đường",
        "street_type": 3,
        "price": 9.1
      },
      {
        "code": "MB34",
        "ward_code": "MB",
        "ward": "Mỹ Bình",
        "street": "Lê Quý Đôn",
        "street_code": "LQĐ",
        "street_2": "Suốt đường",
        "street_type": 3,
        "price": 9.1
      },
      {
        "code": "MB35",
        "ward_code": "MB",
        "ward": "Mỹ Bình",
        "street": "Lê Văn Nhung",
        "street_code": "LVN",
        "street_2": "Nguyễn Thái Học - Lê Hồng Phong",
        "street_type": 3,
        "price": 4.5
      },
      {
        "code": "MB36",
        "ward_code": "MB",
        "ward": "Mỹ Bình",
        "street": "Hẻm 141",
        "street_code": "H141",
        "street_2": "Nguyễn Thái Học - Yết Kiêu",
        "street_type": 3,
        "price": 4
      },
      {
        "code": "MB37",
        "ward_code": "MB",
        "ward": "Mỹ Bình",
        "street": "Hẻm tổ 10 Ngô Quyền",
        "street_code": "H10NQ",
        "street_2": "Suốt hẻm",
        "street_type": 3,
        "price": 4.5
      },
      {
        "code": "MB38",
        "ward_code": "MB",
        "ward": "Mỹ Bình",
        "street": "Đường Bờ Kè Nguyễn Du",
        "street_code": "ĐBKND",
        "street_2": "Suốt đường",
        "street_type": 3,
        "price": 6
      },
      {
        "code": "MB39",
        "ward_code": "MB",
        "ward": "Mỹ Bình",
        "street": "Đường Vòng Yết Kiêu",
        "street_code": "ĐVYK",
        "street_2": "Nguyễn Xí - Lê Văn Nhung",
        "street_type": 4,
        "price": 6.5
      },
      {
        "code": "MB40",
        "ward_code": "MB",
        "ward": "Mỹ Bình",
        "street": "Hẻm Bạch Hổ",
        "street_code": "HBH",
        "street_2": "Tôn Đức Thắng - Lê Triệu Kiết",
        "street_type": 4,
        "price": 4
      },
      {
        "code": "MB41",
        "ward_code": "MB",
        "ward": "Mỹ Bình",
        "street": "Hẻm Huỳnh Thanh",
        "street_code": "HHT",
        "street_2": "Suốt hẻm",
        "street_type": 4,
        "price": 5.2
      },
      {
        "code": "MB42",
        "ward_code": "MB",
        "ward": "Mỹ Bình",
        "street": "Hẻm Hòa Bình",
        "street_code": "HHB",
        "street_2": "Suốt hẻm",
        "street_type": 4,
        "price": 5
      },
      {
        "code": "MB43",
        "ward_code": "MB",
        "ward": "Mỹ Bình",
        "street": "Hẻm Tổ 1 Trần Hưng Đạo - Ngô Quyền",
        "street_code": "HT1THĐNQ",
        "street_2": "Suốt hẻm",
        "street_type": 4,
        "price": 4
      },
      {
        "code": "MB44",
        "ward_code": "MB",
        "ward": "Mỹ Bình",
        "street": "Hẻm 2 Yết Kiêu - Cô Bắc - Cô Giang",
        "street_code": "H2YKCBCG",
        "street_2": "Suốt hẻm",
        "street_type": 4,
        "price": 5
      },
      {
        "code": "MB45",
        "ward_code": "MB",
        "ward": "Mỹ Bình",
        "street": "Lê Văn Nhung",
        "street_code": "LVN",
        "street_2": "Lê Hồng Phong - Cầu Nguyễn Trung Trực",
        "street_type": 4,
        "price": 2.5
      },
      {
        "code": "MB46",
        "ward_code": "MB",
        "ward": "Mỹ Bình",
        "street": "Chung Cư MARINA",
        "street_code": "CCMARINA",
        "street_2": "Các căn hộ trong chung cư",
        "street_type": null,
        "price": null
      },
      {
        "code": "MP1A",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Trần Hưng Đạo",
        "street_code": "THĐ",
        "street_2": "Cầu Cái Sơn - Cầu Tầm Bót - Phạm Cự Lượng",
        "street_type": 1,
        "price": 25
      },
      {
        "code": "MP2",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Lý Thái Tổ",
        "street_code": "LTT",
        "street_2": "Suốt đường Lý Thái Tổ",
        "street_type": 1,
        "price": 25
      },
      {
        "code": "MP3",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Đường Số 1 Lý Thái Tổ (nối dài)",
        "street_code": "ĐS1LTT",
        "street_2": "Đường số 1",
        "street_type": 1,
        "price": 15
      },
      {
        "code": "MP4",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Đường Số 2 Lý Thái Tổ (nối dài)",
        "street_code": "ĐS2LTT",
        "street_2": "Đường số 2",
        "street_type": 1,
        "price": 15
      },
      {
        "code": "MP5",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Đường Số 3 Lý Thái Tổ (nối dài)",
        "street_code": "ĐS3LTT",
        "street_2": "Đường số 3",
        "street_type": 1,
        "price": 15
      },
      {
        "code": "MP6",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Đường Số 4 Lý Thái Tổ (nối dài)",
        "street_code": "ĐS4LTT",
        "street_2": "Đường số 4",
        "street_type": 1,
        "price": 15
      },
      {
        "code": "MP7",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Đường Số 5 Lý Thái Tổ (nối dài)",
        "street_code": "ĐS5LTT",
        "street_2": "Đường số 5",
        "street_type": 1,
        "price": 15
      },
      {
        "code": "MP8",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Đường Số 6 Lý Thái Tổ (nối dài)",
        "street_code": "ĐS6LTT",
        "street_2": "Đường số 6",
        "street_type": 1,
        "price": 15
      },
      {
        "code": "MP9",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Đường Cổng ra Bến Xe Cũ",
        "street_code": "ĐCBXC",
        "street_2": "Trần Hưng Đạo - cuối đường",
        "street_type": 1,
        "price": 12
      },
      {
        "code": "MP10",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Hùng Vương",
        "street_code": "HV",
        "street_2": "Rạch Cái Sơn - Tô Hiến Thành",
        "street_type": 1,
        "price": 15
      },
      {
        "code": "MP11",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Tô Hiến Thành",
        "street_code": "THT",
        "street_2": "Trần Hưng Đạo - Hùng Vương nối dài",
        "street_type": 3,
        "price": 7.2
      },
      {
        "code": "MP12",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Đường Kênh Đào",
        "street_code": "ĐKĐ",
        "street_2": "Trần Hưng Đạo - Cầu Kênh Đào",
        "street_type": 3,
        "price": 7.2
      },
      {
        "code": "MP13",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Nguyễn Văn Linh",
        "street_code": "NVL",
        "street_2": "Ung Văn Khiêm - Cuối ranh khu dân cư Tiến Đạt",
        "street_type": 3,
        "price": 8
      },
      {
        "code": "MP14",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Phạm Cự Lượng",
        "street_code": "PCL",
        "street_2": "Suốt đường",
        "street_type": 3,
        "price": 10
      },
      {
        "code": "MP15",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Ung Văn Khiêm",
        "street_code": "UVK",
        "street_2": "Suốt đường",
        "street_type": 3,
        "price": 10
      },
      {
        "code": "MP16",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Triệu Quang Phục",
        "street_code": "TQP",
        "street_2": "Suốt đường",
        "street_type": 3,
        "price": 8
      },
      {
        "code": "MP17A",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Đường đối diện nhà lồng Chợ Mỹ Phước",
        "street_code": "ĐCMP",
        "street_2": "Đường số 08 và Đường số 05",
        "street_type": 3,
        "price": 7
      },
      {
        "code": "MP18",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Đường Không Tên Tây Sông Hậu",
        "street_code": "ĐKTTSH",
        "street_2": "Các đường nội bộ chưa đặt tên [Diamond city]",
        "street_type": 3,
        "price": 7
      },
      {
        "code": "MP19",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Đường Số 1 Tây Sông Hậu",
        "street_code": "ĐS1TSH",
        "street_2": "Tái định cư TSH",
        "street_type": 3,
        "price": 7
      },
      {
        "code": "MP20",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Đường Số 2 Tây Sông Hậu",
        "street_code": "ĐS2TSH",
        "street_2": "Tái định cư TSH",
        "street_type": 3,
        "price": 7
      },
      {
        "code": "MP21",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Đường Số 3 Tây Sông Hậu",
        "street_code": "ĐS3TSH",
        "street_2": "Tái định cư TSH",
        "street_type": 3,
        "price": 7
      },
      {
        "code": "MP22",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Tô Vĩnh Diện",
        "street_code": "TVD",
        "street_2": "ĐƯỜNG TRONG KDC XẺO TRÔM 1, 2",
        "street_type": 4,
        "price": 4
      },
      {
        "code": "MP23",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Trường Chinh",
        "street_code": "TC",
        "street_2": "ĐƯỜNG TRONG KDC XẺO TRÔM 1, 2",
        "street_type": 4,
        "price": 4
      },
      {
        "code": "MP24",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Hà Huy Tập",
        "street_code": "HHT",
        "street_2": "ĐƯỜNG TRONG KDC XẺO TRÔM 1, 2",
        "street_type": 4,
        "price": 4
      },
      {
        "code": "MP25",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Nguyễn Tất Thành",
        "street_code": "NTT",
        "street_2": "ĐƯỜNG TRONG KDC XẺO TRÔM 1, 2",
        "street_type": 4,
        "price": 4
      },
      {
        "code": "MP26",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Đốc Binh Là",
        "street_code": "ĐBL",
        "street_2": "ĐƯỜNG TRONG KDC XẺO TRÔM 1, 2",
        "street_type": 4,
        "price": 4
      },
      {
        "code": "MP27",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Trần Phú",
        "street_code": "TP",
        "street_2": "ĐƯỜNG TRONG KDC XẺO TRÔM 1, 2",
        "street_type": 4,
        "price": 4
      },
      {
        "code": "MP28",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Phan Đăng Lưu",
        "street_code": "PĐL",
        "street_2": "ĐƯỜNG TRONG KDC XẺO TRÔM 1, 2",
        "street_type": 4,
        "price": 4
      },
      {
        "code": "MP29",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Lê Duẩn",
        "street_code": "LD",
        "street_2": "ĐƯỜNG TRONG KDC XẺO TRÔM 1, 2",
        "street_type": 4,
        "price": 4
      },
      {
        "code": "MP30",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Tô Hiệu",
        "street_code": "TH",
        "street_2": "ĐƯỜNG TRONG KDC XẺO TRÔM 1, 2",
        "street_type": 4,
        "price": 4
      },
      {
        "code": "MP31",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Phạm Thiều",
        "street_code": "PT",
        "street_2": "ĐƯỜNG TRONG KDC XẺO TRÔM 1, 2",
        "street_type": 4,
        "price": 4
      },
      {
        "code": "MP32",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Nguyễn Hữu Thọ",
        "street_code": "NHT",
        "street_2": "ĐƯỜNG TRONG KDC XẺO TRÔM 1, 2",
        "street_type": 4,
        "price": 4
      },
      {
        "code": "MP33",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Cù Chính Lan",
        "street_code": "CCL",
        "street_2": "ĐƯỜNG TRONG KDC XẺO TRÔM 1, 2",
        "street_type": 4,
        "price": 4
      },
      {
        "code": "MP34",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Nguyễn Phong Sắc",
        "street_code": "NPS",
        "street_2": "ĐƯỜNG TRONG KDC XẺO TRÔM 1, 2",
        "street_type": 4,
        "price": 4
      },
      {
        "code": "MP35",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Hà Huy Giáp",
        "street_code": "HHG",
        "street_2": "ĐƯỜNG TRONG KDC XẺO TRÔM 1, 2",
        "street_type": 4,
        "price": 4
      },
      {
        "code": "MP36",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Võ Văn Tần",
        "street_code": "VVT",
        "street_2": "ĐƯỜNG TRONG KDC XẺO TRÔM 1, 2",
        "street_type": 4,
        "price": 4
      },
      {
        "code": "MP37",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Việt Bắc",
        "street_code": "VB",
        "street_2": "ĐƯỜNG TRONG KDC XẺO TRÔM 1, 2",
        "street_type": 4,
        "price": 4
      },
      {
        "code": "MP38",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Ba Son",
        "street_code": "BS",
        "street_2": "ĐƯỜNG TRONG KDC XẺO TRÔM 1, 2",
        "street_type": 4,
        "price": 4
      },
      {
        "code": "MP39",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Hắc Hải",
        "street_code": "HH",
        "street_2": "ĐƯỜNG TRONG KDC XẺO TRÔM 1, 2",
        "street_type": 4,
        "price": 4
      },
      {
        "code": "MP40",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Nguyễn Đức Cảnh",
        "street_code": "NĐC",
        "street_2": "ĐƯỜNG TRONG KDC XẺO TRÔM 1, 2",
        "street_type": 4,
        "price": 4
      },
      {
        "code": "MP41",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Phùng Chí Kiên",
        "street_code": "PCK",
        "street_2": "ĐƯỜNG TRONG KDC XẺO TRÔM 1, 2",
        "street_type": 4,
        "price": 4
      },
      {
        "code": "MP42",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Trần Huy Liệu",
        "street_code": "THL",
        "street_2": "ĐƯỜNG TRONG KDC XẺO TRÔM 1, 2",
        "street_type": 4,
        "price": 4
      },
      {
        "code": "MP43",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Đặng Thai Mai",
        "street_code": "ĐTM",
        "street_2": "ĐƯỜNG TRONG KDC XẺO TRÔM 1, 2",
        "street_type": 4,
        "price": 4
      },
      {
        "code": "MP44",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Lưu Hữu Phước",
        "street_code": "LHP",
        "street_2": "ĐƯỜNG TRONG KDC XẺO TRÔM 1, 2",
        "street_type": 4,
        "price": 4
      },
      {
        "code": "MP45",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Côn Đảo",
        "street_code": "CĐ",
        "street_2": "ĐƯỜNG TRONG KDC XẺO TRÔM 1, 2",
        "street_type": 4,
        "price": 4
      },
      {
        "code": "MP46",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "AÂu Dương Lân",
        "street_code": "ADL",
        "street_2": "ĐƯỜNG TRONG KDC XẺO TRÔM 1, 2",
        "street_type": 4,
        "price": 4
      },
      {
        "code": "MP47",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Đường Còn Lại trong Kdc Xẻo Trôm 1,2",
        "street_code": "ĐCLKXT12",
        "street_2": "Các đường còn lại chưa có tên trong KDC Xẻo Trôm 1,2",
        "street_type": 4,
        "price": 4
      },
      {
        "code": "MP48",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Thoại Ngọc Hầu",
        "street_code": "TNH",
        "street_2": "Suốt đường",
        "street_type": 4,
        "price": 3.5
      },
      {
        "code": "MP49",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Khu dân cư Xẻo Chanh",
        "street_code": "KXC",
        "street_2": "Cầu Kênh Đào - Hết khu dân cư, các đường nội bộ",
        "street_type": 4,
        "price": 3.5
      },
      {
        "code": "MP50",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Khu dân cư 36 Nên",
        "street_code": "K36N",
        "street_2": "Các đường trong KDC",
        "street_type": 4,
        "price": 3.5
      },
      {
        "code": "MP51",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Phạm Ngũ Lão",
        "street_code": "PNL",
        "street_2": "Suốt đường",
        "street_type": 4,
        "price": 5.5
      },
      {
        "code": "MP52",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Đường Cặp Rạch Cái Sơn",
        "street_code": "ĐCRCS",
        "street_2": "Trần Hưng Đạo – Trường DH An Giang - Sông Hậu",
        "street_type": 4,
        "price": 2.5
      },
      {
        "code": "MP54",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Đường Cặp Rạch Tầm Bót",
        "street_code": "ĐCRTB",
        "street_2": "Sông Hậu – Rạch Mương Khai",
        "street_type": 4,
        "price": 2.5
      },
      {
        "code": "MP55",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Hẻm 1 tiếp giáp Trần Hưng Đạo",
        "street_code": "H1THĐ",
        "street_2": "Suốt hẻm",
        "street_type": 4,
        "price": 3
      },
      {
        "code": "MP56",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Hẻm 2 tiếp giáp Trần Hưng Đạo",
        "street_code": "H2THĐ",
        "street_2": "Suốt hẻm",
        "street_type": 4,
        "price": null
      },
      {
        "code": "MP57",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Đường Cặp Rạch Xẻo Chanh",
        "street_code": "ĐCRXC",
        "street_2": "Rạch Cái Sơn - Rạch Tầm Bót",
        "street_type": 4,
        "price": 2
      },
      {
        "code": "MP58",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Đường Cặp Rạch Ba Đá",
        "street_code": "ĐCRBĐ",
        "street_2": "Phạm Cự Lượng - Rạch Tầm Bót",
        "street_type": 4,
        "price": 2.5
      },
      {
        "code": "MP59",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Đường Cặp Rạch Xẻo Thoại",
        "street_code": "ĐCRXT",
        "street_2": "Rạch Tầm Bót - Rạch Ba Đá",
        "street_type": 4,
        "price": 2.5
      },
      {
        "code": "MP60",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Hồ Tùng Mậu",
        "street_code": "HTM",
        "street_2": "ĐƯỜNG TRONG KDC XẺO TRÔM 4, 5",
        "street_type": 4,
        "price": 4
      },
      {
        "code": "MP61",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Huỳnh Tấn Phát",
        "street_code": "HTP",
        "street_2": "ĐƯỜNG TRONG KDC XẺO TRÔM 4, 5",
        "street_type": 4,
        "price": 4
      },
      {
        "code": "MP62",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Võ Duy Dương",
        "street_code": "VDD",
        "street_2": "ĐƯỜNG TRONG KDC XẺO TRÔM 4, 5",
        "street_type": 4,
        "price": 4
      },
      {
        "code": "MP63",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Hoàng Quốc Việt",
        "street_code": "HQV",
        "street_2": "ĐƯỜNG TRONG KDC XẺO TRÔM 4, 5",
        "street_type": 4,
        "price": 4
      },
      {
        "code": "MP64",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Võ Hoành",
        "street_code": "VH",
        "street_2": "ĐƯỜNG TRONG KDC XẺO TRÔM 4, 5",
        "street_type": 4,
        "price": 4
      },
      {
        "code": "MP65",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Dương Bá Trạc",
        "street_code": "DBT",
        "street_2": "ĐƯỜNG TRONG KDC XẺO TRÔM 4, 5",
        "street_type": 4,
        "price": 4
      },
      {
        "code": "MP66",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Nguyễn Thượng Khách",
        "street_code": "NTK",
        "street_2": "ĐƯỜNG TRONG KDC XẺO TRÔM 4, 5",
        "street_type": 4,
        "price": 4
      },
      {
        "code": "MP67",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Lê Văn Lương",
        "street_code": "LVL",
        "street_2": "ĐƯỜNG TRONG KDC XẺO TRÔM 4, 5",
        "street_type": 4,
        "price": 4
      },
      {
        "code": "MP68",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Phạm Văn Đồng",
        "street_code": "PVĐ",
        "street_2": "ĐƯỜNG TRONG KDC XẺO TRÔM 4, 5",
        "street_type": 4,
        "price": 4
      },
      {
        "code": "MP69",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Nguyễn Lương Bằng",
        "street_code": "NLB",
        "street_2": "ĐƯỜNG TRONG KDC XẺO TRÔM 4, 5",
        "street_type": 4,
        "price": 4
      },
      {
        "code": "MP70",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Đường Còn Lại trong Kdc Xẻo Trôm 4,5",
        "street_code": "ĐCLKXT45",
        "street_2": "Các đường còn lại chưa có tên trong KDC Xẻo Trôm 4,5",
        "street_type": 4,
        "price": 4
      },
      {
        "code": "MP71",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Đường Cặp Kênh Đào",
        "street_code": "ĐCKĐ",
        "street_2": "Khu dân cư Xẻo Trôm 4 - Rạch Mương Khai",
        "street_type": 4,
        "price": 1.5
      },
      {
        "code": "MP72",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Đường Cặp Rạch Gừa",
        "street_code": "ĐCRG",
        "street_2": "Trần Hưng Đạo - Khu đô thị mới Tây Sông Hậu",
        "street_type": 4,
        "price": 2.5
      },
      {
        "code": "MP73",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Đường Cặp Rạch Mương Khai",
        "street_code": "ĐCRMK",
        "street_2": "Giáp phường Mỹ Hòa",
        "street_type": 4,
        "price": 1.5
      },
      {
        "code": "MP74",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Dương Bạch Mai",
        "street_code": "DBM",
        "street_2": "KHU TÁI ĐỊNH CƯ ĐẠI HỌC AN GIANG",
        "street_type": 4,
        "price": 5
      },
      {
        "code": "MP75",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Trịnh Đình Thảo",
        "street_code": "TĐT",
        "street_2": "KHU TÁI ĐỊNH CƯ ĐẠI HỌC AN GIANG",
        "street_type": 4,
        "price": 5
      },
      {
        "code": "MP76",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Đào Duy Anh",
        "street_code": "ĐDA",
        "street_2": "KHU TÁI ĐỊNH CƯ ĐẠI HỌC AN GIANG",
        "street_type": 4,
        "price": 5
      },
      {
        "code": "MP77",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Lương Định Của",
        "street_code": "LĐC",
        "street_2": "KHU TÁI ĐỊNH CƯ ĐẠI HỌC AN GIANG",
        "street_type": 4,
        "price": 5
      },
      {
        "code": "MP78",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Tôn Thất Tùng",
        "street_code": "TTT",
        "street_2": "KHU TÁI ĐỊNH CƯ ĐẠI HỌC AN GIANG",
        "street_type": 4,
        "price": 5
      },
      {
        "code": "MP79",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Phạm Ngọc Thạch",
        "street_code": "PNT",
        "street_2": "KHU TÁI ĐỊNH CƯ ĐẠI HỌC AN GIANG",
        "street_type": 4,
        "price": 5
      },
      {
        "code": "MP80",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Hoàng Văn Thái",
        "street_code": "HVT",
        "street_2": "KHU DÂN CƯ TIẾN ĐẠT",
        "street_type": 4,
        "price": 5
      },
      {
        "code": "MP81",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Nguyễn Thị Định",
        "street_code": "NTĐ",
        "street_2": "KHU DÂN CƯ TIẾN ĐẠT",
        "street_type": 4,
        "price": 5
      },
      {
        "code": "MP82",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Trần Văn Trà",
        "street_code": "TVT",
        "street_2": "KHU DÂN CƯ TIẾN ĐẠT",
        "street_type": 4,
        "price": 5
      },
      {
        "code": "MP83",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Nguyễn Chí Thanh",
        "street_code": "NCT",
        "street_2": "KHU DÂN CƯ TIẾN ĐẠT",
        "street_type": 4,
        "price": 5
      },
      {
        "code": "MP84",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Nguyễn Khánh Toàn",
        "street_code": "NKT",
        "street_2": "KHU DÂN CƯ TIẾN ĐẠT",
        "street_type": 4,
        "price": 5
      },
      {
        "code": "MP85",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Lê Thị Riêng",
        "street_code": "LTR",
        "street_2": "KHU DÂN CƯ TIẾN ĐẠT",
        "street_type": 4,
        "price": 5
      },
      {
        "code": "MP86",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Hồ Hảo Hớn",
        "street_code": "HHH",
        "street_2": "KHU DÂN CƯ TIẾN ĐẠT",
        "street_type": 4,
        "price": 5
      },
      {
        "code": "MP87",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Nguyễn Văn Trỗi",
        "street_code": "NVT",
        "street_2": "KHU DÂN CƯ TIẾN ĐẠT",
        "street_type": 4,
        "price": 5
      },
      {
        "code": "MP88",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Nguyễn Minh Hồng",
        "street_code": "NMH",
        "street_2": "KHU DÂN CƯ TIẾN ĐẠT",
        "street_type": 4,
        "price": 5
      },
      {
        "code": "MP89",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Lê Anh Xuân",
        "street_code": "LAX",
        "street_2": "KHU DÂN CƯ TIẾN ĐẠT",
        "street_type": 4,
        "price": 5
      },
      {
        "code": "MP90",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Hoàng Lê Kha",
        "street_code": "HLK",
        "street_2": "KHU DÂN CƯ TIẾN ĐẠT",
        "street_type": 4,
        "price": 5
      },
      {
        "code": "MP91",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Nguyễn Bình",
        "street_code": "NB",
        "street_2": "KHU DÂN CƯ TIẾN ĐẠT",
        "street_type": 4,
        "price": 5
      },
      {
        "code": "MP92",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Huỳnh Văn Nghệ",
        "street_code": "HVN",
        "street_2": "KHU DÂN CƯ TIẾN ĐẠT",
        "street_type": 4,
        "price": 5
      },
      {
        "code": "MP93",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Lê Trọng Tấn",
        "street_code": "LTT",
        "street_2": "KHU DÂN CƯ TIẾN ĐẠT",
        "street_type": 4,
        "price": 6
      },
      {
        "code": "MP94",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Đường Số 5 Tây Đại Học",
        "street_code": "ĐS5TĐH",
        "street_2": "Khu dân cư Tây Đại Học",
        "street_type": 4,
        "price": 5
      },
      {
        "code": "MP95",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Đường Số 6 Tây Đại Học",
        "street_code": "ĐS6TĐH",
        "street_2": "Khu dân cư Tây Đại Học",
        "street_type": 4,
        "price": 5
      },
      {
        "code": "MP96",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Đường Số 7 Tây Đại Học",
        "street_code": "ĐS7TĐH",
        "street_2": "Khu dân cư Tây Đại Học",
        "street_type": 4,
        "price": 5
      },
      {
        "code": "MP97",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Đường Số 8 Tây Đại Học",
        "street_code": "ĐS8TĐH",
        "street_2": "Khu dân cư Tây Đại Học",
        "street_type": 4,
        "price": 5
      },
      {
        "code": "MP98",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Đường Số 9 Tây Đại Học",
        "street_code": "ĐS9TĐH",
        "street_2": "Khu dân cư Tây Đại Học",
        "street_type": 4,
        "price": 5
      },
      {
        "code": "MP99",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Đường Số 10 Tây Đại Học",
        "street_code": "ĐS10TĐH",
        "street_2": "Khu dân cư Tây Đại Học",
        "street_type": 4,
        "price": 5
      },
      {
        "code": "MP100",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Đường Số 11 Tây Đại Học",
        "street_code": "ĐS11TĐH",
        "street_2": "Khu dân cư Tây Đại Học",
        "street_type": 4,
        "price": 5
      },
      {
        "code": "MP101",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Đường Số 12 Tây Đại Học",
        "street_code": "ĐS12TĐH",
        "street_2": "Khu dân cư Tây Đại Học",
        "street_type": 4,
        "price": 5
      },
      {
        "code": "MP102",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Đường Cặp Bệnh Viện Đa Khoa",
        "street_code": "ĐCBVĐK",
        "street_2": "Ung Văn Khiêm - Dương Bạch Mai",
        "street_type": 4,
        "price": 3.5
      },
      {
        "code": "MP103",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Khu dân cư Hai Vót",
        "street_code": "KHV",
        "street_2": "Rạch Xẻo Chanh - hết ranh KDC",
        "street_type": 4,
        "price": 2
      },
      {
        "code": "MP104A",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "các Đường còn lại xung quanh Kdc Chợ Mỹ Phước",
        "street_code": "ĐKCMP",
        "street_2": "Đường số 06, 07, 08",
        "street_type": 4,
        "price": 5
      },
      {
        "code": "MP105",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "các Đường Không Tên kdc Nam Tầm Bót",
        "street_code": "ĐKTNTB",
        "street_2": "Các đường trong KDC Nam Tầm Bót chưa đặt tên",
        "street_type": 4,
        "price": 2
      },
      {
        "code": "MP105A",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Đường Số 1 Nam Tầm Bót",
        "street_code": "ĐS1NTB",
        "street_2": "KDC Nam Tầm Bót",
        "street_type": null,
        "price": null
      },
      {
        "code": "MP105B",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Đường Số 2 Nam Tầm Bót",
        "street_code": "ĐS2NTB",
        "street_2": "KDC Nam Tầm Bót",
        "street_type": null,
        "price": null
      },
      {
        "code": "MP105C",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Đường Số 3 Nam Tầm Bót",
        "street_code": "ĐS3NTB",
        "street_2": "KDC Nam Tầm Bót",
        "street_type": null,
        "price": null
      },
      {
        "code": "MP105D",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Đường Số 4 Nam Tầm Bót",
        "street_code": "ĐS4NTB",
        "street_2": "KDC Nam Tầm Bót",
        "street_type": null,
        "price": null
      },
      {
        "code": "MP105E",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Đường Số 5Nam Tầm Bót",
        "street_code": "ĐS5NTB",
        "street_2": "KDC Nam Tầm Bót",
        "street_type": null,
        "price": null
      },
      {
        "code": "MP106",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Kdc Sở Kế Hoạch Đầu Tư",
        "street_code": "KSKHĐT",
        "street_2": "Các đường trong KDC",
        "street_type": 4,
        "price": 2
      },
      {
        "code": "MP107",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Kdc Tỉnh Đoàn",
        "street_code": "KTĐ",
        "street_2": "Các đường trong KDC",
        "street_type": 4,
        "price": 2
      },
      {
        "code": "MP108",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Kdc AB",
        "street_code": "KAB",
        "street_2": "Các đường trong KDC",
        "street_type": 4,
        "price": 2
      },
      {
        "code": "MP109",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Kdc Cặp Rạch Xẻo Thoại",
        "street_code": "KCRXT",
        "street_2": "Các đường trong KDC",
        "street_type": 4,
        "price": 2
      },
      {
        "code": "MP110",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Kdc Cặp Rạch Ba Đá",
        "street_code": "KCRBĐ",
        "street_2": "Các đường trong KDC",
        "street_type": 4,
        "price": 2
      },
      {
        "code": "MP111",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Kdc Hẻm 8 Kỳ",
        "street_code": "KH8K",
        "street_2": "Đường chính",
        "street_type": 4,
        "price": 2
      },
      {
        "code": "MP112",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Đường Kênh Đào Nối Dài XT3",
        "street_code": "ĐKĐNDXT3",
        "street_2": "KDC Xẻo Trôm 3 - ACC",
        "street_type": null,
        "price": null
      },
      {
        "code": "MP112A",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Đường Số 1 XT3",
        "street_code": "ĐS1XT3",
        "street_2": "KDC Xẻo Trôm 3 - ACC",
        "street_type": null,
        "price": null
      },
      {
        "code": "MP112B",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Đường Số 2 XT3",
        "street_code": "ĐS2XT3",
        "street_2": "KDC Xẻo Trôm 3 - ACC",
        "street_type": null,
        "price": null
      },
      {
        "code": "MP112C",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Đường Số 3 XT3",
        "street_code": "ĐS3XT3",
        "street_2": "KDC Xẻo Trôm 3 - ACC",
        "street_type": null,
        "price": null
      },
      {
        "code": "MP112D",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Đường Số 4 XT3",
        "street_code": "ĐS4XT3",
        "street_2": "KDC Xẻo Trôm 3 - ACC",
        "street_type": null,
        "price": null
      },
      {
        "code": "MP112E",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Đường Số 5 XT3",
        "street_code": "ĐS5XT3",
        "street_2": "KDC Xẻo Trôm 3 - ACC",
        "street_type": null,
        "price": null
      },
      {
        "code": "MP112F",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Đường Số 6 XT3",
        "street_code": "ĐS6XT3",
        "street_2": "KDC Xẻo Trôm 3 - ACC",
        "street_type": null,
        "price": null
      },
      {
        "code": "MP112G",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Đường Số 7 XT3",
        "street_code": "ĐS7XT3",
        "street_2": "KDC Xẻo Trôm 3 - ACC",
        "street_type": null,
        "price": null
      },
      {
        "code": "MP112H",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Đường Số 8 XT3",
        "street_code": "ĐS8XT3",
        "street_2": "KDC Xẻo Trôm 3 - ACC",
        "street_type": null,
        "price": null
      },
      {
        "code": "MP112I",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Đường Số 9 XT3",
        "street_code": "ĐS9XT3",
        "street_2": "KDC Xẻo Trôm 3 - ACC",
        "street_type": null,
        "price": null
      },
      {
        "code": "MP112J",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Đường Số 10 XT3",
        "street_code": "ĐS10XT3",
        "street_2": "KDC Xẻo Trôm 3 - ACC",
        "street_type": null,
        "price": null
      },
      {
        "code": "MP112K",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Đường Số 11 XT3",
        "street_code": "ĐS11XT3",
        "street_2": "KDC Xẻo Trôm 3 - ACC",
        "street_type": null,
        "price": null
      },
      {
        "code": "MP112L",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Đường D15 XT3",
        "street_code": "ĐD15XT3",
        "street_2": "KDC Xẻo Trôm 3 - ACC",
        "street_type": null,
        "price": null
      },
      {
        "code": "MP113",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Đường Không Tên Tây Đại Học 2",
        "street_code": "ĐKTTĐH2",
        "street_2": "Đường trong Tây đại học GD2 chưa đặt tên",
        "street_type": null,
        "price": null
      },
      {
        "code": "MP113A",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Đường Số 3 Tây Đại Học 2",
        "street_code": "ĐS3TĐH2",
        "street_2": "Khu Tây Đại học GD2",
        "street_type": null,
        "price": null
      },
      {
        "code": "MP113B",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Đường Số 4 Tây Đại Học 2",
        "street_code": "ĐS4TĐH2",
        "street_2": "Khu Tây Đại học GD2",
        "street_type": null,
        "price": null
      },
      {
        "code": "MP113C",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Đường Số 5 Tây Đại Học 2",
        "street_code": "ĐS5TĐH2",
        "street_2": "Khu Tây Đại học GD2",
        "street_type": null,
        "price": null
      },
      {
        "code": "MP113D",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Đường Số 9 Tây Đại Học 2",
        "street_code": "ĐS9TĐH2",
        "street_2": "Khu Tây Đại học GD2",
        "street_type": null,
        "price": null
      },
      {
        "code": "MP113E",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Đường Số 12 Tây Đại Học 2",
        "street_code": "ĐS12TĐH2",
        "street_2": "Khu Tây Đại học GD2",
        "street_type": null,
        "price": null
      },
      {
        "code": "MP113F",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Lý Thái Tổ Nối Dài Tây Đại Học 2",
        "street_code": "LTTNDTĐH2",
        "street_2": "Khu Tây Đại học GD2",
        "street_type": null,
        "price": null
      },
      {
        "code": "MP113G",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Đường Số 1 Tây Đại Học 2",
        "street_code": "ĐS1TĐH2",
        "street_2": "Khu Tây Đại học GD2",
        "street_type": null,
        "price": null
      },
      {
        "code": "MP113H",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Đường Số 2 Tây Đại Học 2",
        "street_code": "ĐS2TĐH2",
        "street_2": "Khu Tây Đại học GD2",
        "street_type": null,
        "price": null
      },
      {
        "code": "MP113I",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Đường Số 13 Tây Đại Học 2",
        "street_code": "ĐS13TĐH2",
        "street_2": "Khu Tây Đại học GD2",
        "street_type": null,
        "price": null
      },
      {
        "code": "MP113J",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Đường Số 14 Tây Đại Học 2",
        "street_code": "ĐS14TĐH2",
        "street_2": "Khu Tây Đại học GD2",
        "street_type": null,
        "price": null
      },
      {
        "code": "MP113K",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Đường Số 15 Tây Đại Học 2",
        "street_code": "ĐS15TĐH2",
        "street_2": "Khu Tây Đại học GD2",
        "street_type": null,
        "price": null
      },
      {
        "code": "MP113L",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Lê Trọng Tấn Tây Đại Học 2",
        "street_code": "LTTTĐH2",
        "street_2": "Khu Tây Đại học GD2",
        "street_type": null,
        "price": null
      },
      {
        "code": "MP114",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Đường Số 1 Tây Đại Học",
        "street_code": "ĐS1TĐH",
        "street_2": "Khu dân cư Tây Đại Học",
        "street_type": null,
        "price": null
      },
      {
        "code": "MP115",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Chung Cư ACC",
        "street_code": "CCACC",
        "street_2": "Các căn hộ trong chung cư",
        "street_type": null,
        "price": null
      },
      {
        "code": "MP116",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Đường Số 10 TSH2",
        "street_code": "ĐS10TSH2",
        "street_2": "KĐT Tây Sông Hậu GD2",
        "street_type": null,
        "price": null
      },
      {
        "code": "MP117",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Đường Số 10A TSH2",
        "street_code": "ĐS10ATSH2",
        "street_2": "KĐT Tây Sông Hậu GD2",
        "street_type": null,
        "price": null
      },
      {
        "code": "MP118",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Đường Số 10B TSH2",
        "street_code": "ĐS10BTSH2",
        "street_2": "KĐT Tây Sông Hậu GD2",
        "street_type": null,
        "price": null
      },
      {
        "code": "MP119",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Đường Số 11A TSH2",
        "street_code": "ĐS11ATSH2",
        "street_2": "KĐT Tây Sông Hậu GD2",
        "street_type": null,
        "price": null
      },
      {
        "code": "MP120",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Đường Số 11B TSH2",
        "street_code": "ĐS11BTSH2",
        "street_2": "KĐT Tây Sông Hậu GD2",
        "street_type": null,
        "price": null
      },
      {
        "code": "MP121",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Đường Số 11C TSH2",
        "street_code": "ĐS11CTSH2",
        "street_2": "KĐT Tây Sông Hậu GD2",
        "street_type": null,
        "price": null
      },
      {
        "code": "MP122",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Đường Số 11D TSH2",
        "street_code": "ĐS11DTSH2",
        "street_2": "KĐT Tây Sông Hậu GD2",
        "street_type": null,
        "price": null
      },
      {
        "code": "MP123",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Đường Số 11E TSH2",
        "street_code": "ĐS11ETSH2",
        "street_2": "KĐT Tây Sông Hậu GD2",
        "street_type": null,
        "price": null
      },
      {
        "code": "MP124",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Đường Số 11F TSH2",
        "street_code": "ĐS11FTSH2",
        "street_2": "KĐT Tây Sông Hậu GD2",
        "street_type": null,
        "price": null
      },
      {
        "code": "MP125",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Đường Số 12 TSH2",
        "street_code": "ĐS12TSH2",
        "street_2": "KĐT Tây Sông Hậu GD2",
        "street_type": null,
        "price": null
      },
      {
        "code": "MP126",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Đường Số 12A TSH2",
        "street_code": "ĐS12ATSH2",
        "street_2": "KĐT Tây Sông Hậu GD2",
        "street_type": null,
        "price": null
      },
      {
        "code": "MP127",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Đường Số 12B TSH2",
        "street_code": "ĐS12BTSH2",
        "street_2": "KĐT Tây Sông Hậu GD2",
        "street_type": null,
        "price": null
      },
      {
        "code": "MP128",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Đường Số 13 TSH2",
        "street_code": "ĐS13TSH2",
        "street_2": "KĐT Tây Sông Hậu GD2",
        "street_type": null,
        "price": null
      },
      {
        "code": "MP129",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Đường Số 14 TSH2",
        "street_code": "ĐS14TSH2",
        "street_2": "KĐT Tây Sông Hậu GD2",
        "street_type": null,
        "price": null
      },
      {
        "code": "MP130",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Đường Số 14A TSH2",
        "street_code": "ĐS14ATSH2",
        "street_2": "KĐT Tây Sông Hậu GD2",
        "street_type": null,
        "price": null
      },
      {
        "code": "MP131",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Đường Số 14B TSH2",
        "street_code": "ĐS14BTSH2",
        "street_2": "KĐT Tây Sông Hậu GD2",
        "street_type": null,
        "price": null
      },
      {
        "code": "MP132",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Đường Số 14C TSH2",
        "street_code": "ĐS14CTSH2",
        "street_2": "KĐT Tây Sông Hậu GD2",
        "street_type": null,
        "price": null
      },
      {
        "code": "MP133",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Đường Số 14D TSH2",
        "street_code": "ĐS14DTSH2",
        "street_2": "KĐT Tây Sông Hậu GD2",
        "street_type": null,
        "price": null
      },
      {
        "code": "MP134",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Đường Số 15 TSH2",
        "street_code": "ĐS15TSH2",
        "street_2": "KĐT Tây Sông Hậu GD2",
        "street_type": null,
        "price": null
      },
      {
        "code": "MP135",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Đường Số 16 TSH2",
        "street_code": "ĐS16TSH2",
        "street_2": "KĐT Tây Sông Hậu GD2",
        "street_type": null,
        "price": null
      },
      {
        "code": "MP136",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Đường Số 16A TSH2",
        "street_code": "ĐS16ATSH2",
        "street_2": "KĐT Tây Sông Hậu GD2",
        "street_type": null,
        "price": null
      },
      {
        "code": "MP137",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Đường Số 16B TSH2",
        "street_code": "ĐS16BTSH2",
        "street_2": "KĐT Tây Sông Hậu GD2",
        "street_type": null,
        "price": null
      },
      {
        "code": "MP138",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Đường Số 4 Tây Sông Hậu",
        "street_code": "ĐS4TSH",
        "street_2": "KĐT Tây Sông Hậu GD1",
        "street_type": null,
        "price": null
      },
      {
        "code": "MP139",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Đường Số 5 Tây Sông Hậu",
        "street_code": "ĐS5TSH",
        "street_2": "KĐT Tây Sông Hậu GD1",
        "street_type": null,
        "price": null
      },
      {
        "code": "MP140",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Đường Số 5A Tây Sông Hậu",
        "street_code": "ĐS5ATSH",
        "street_2": "KĐT Tây Sông Hậu GD1",
        "street_type": null,
        "price": null
      },
      {
        "code": "MP141",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Đường Số 5B Tây Sông Hậu",
        "street_code": "ĐS5BTSH",
        "street_2": "KĐT Tây Sông Hậu GD1",
        "street_type": null,
        "price": null
      },
      {
        "code": "MP142",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Đường Số 5C Tây Sông Hậu",
        "street_code": "ĐS5CTSH",
        "street_2": "KĐT Tây Sông Hậu GD1",
        "street_type": null,
        "price": null
      },
      {
        "code": "MP143",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Đường Số 5D Tây Sông Hậu",
        "street_code": "ĐS5DTSH",
        "street_2": "KĐT Tây Sông Hậu GD1",
        "street_type": null,
        "price": null
      },
      {
        "code": "MP144",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Đường Số 5E Tây Sông Hậu",
        "street_code": "ĐS5ETSH",
        "street_2": "KĐT Tây Sông Hậu GD1",
        "street_type": null,
        "price": null
      },
      {
        "code": "MP145",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Đường Số 5F Tây Sông Hậu",
        "street_code": "ĐS5FTSH",
        "street_2": "KĐT Tây Sông Hậu GD1",
        "street_type": null,
        "price": null
      },
      {
        "code": "MP146",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Đường Số 5G Tây Sông Hậu",
        "street_code": "ĐS5GTSH",
        "street_2": "KĐT Tây Sông Hậu GD1",
        "street_type": null,
        "price": null
      },
      {
        "code": "MP147",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Đường Số 5H Tây Sông Hậu",
        "street_code": "ĐS5HTSH",
        "street_2": "KĐT Tây Sông Hậu GD1",
        "street_type": null,
        "price": null
      },
      {
        "code": "MP148",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Đường Số 6 Tây Sông Hậu",
        "street_code": "ĐS6TSH",
        "street_2": "KĐT Tây Sông Hậu GD1",
        "street_type": null,
        "price": null
      },
      {
        "code": "MP149",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Đường Số 7 Tây Sông Hậu",
        "street_code": "ĐS7TSH",
        "street_2": "KĐT Tây Sông Hậu GD1",
        "street_type": null,
        "price": null
      },
      {
        "code": "MP150",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Đường Số 8 Tây Sông Hậu",
        "street_code": "ĐS8TSH",
        "street_2": "KĐT Tây Sông Hậu GD1",
        "street_type": null,
        "price": null
      },
      {
        "code": "MP151",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Đường Tránh Long Xuyên - Mỹ Phước",
        "street_code": "ĐTLXMP",
        "street_2": "Đường Tránh Long Xuyên đoạn qua phường Mỹ Phước",
        "street_type": null,
        "price": null
      },
      {
        "code": "MP152",
        "ward_code": "MP",
        "ward": "Mỹ Phước",
        "street": "Đường Số 9 Tây Sông Hậu",
        "street_code": "ĐS9TSH",
        "street_2": "KĐT Tây Sông Hậu GD1",
        "street_type": null,
        "price": null
      },
      {
        "code": "MH1",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "Đường Tỉnh Lộ 943",
        "street_code": "ĐTL943",
        "street_2": "Cầu ông Mạnh - ranh Phú Hòa",
        "street_type": 1,
        "price": 15
      },
      {
        "code": "MH2",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "Nguyễn Thái Học (nối dài)",
        "street_code": "NTH",
        "street_2": "Cầu tạm Nguyến Thái Học - cuối dự án Golden",
        "street_type": 3,
        "price": 11.8
      },
      {
        "code": "MH3",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "Bùi Văn Danh",
        "street_code": "BVD",
        "street_2": "Cầu Ông Mạnh - Cầu tạm Nguyễn Thái Học",
        "street_type": 3,
        "price": 7
      },
      {
        "code": "MH5",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "Nguyễn Hoàng",
        "street_code": "NH",
        "street_2": "Suốt đường",
        "street_type": 3,
        "price": 11.4
      },
      {
        "code": "MH6",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "Khu tái định cư Vịnh Trà",
        "street_code": "KVT",
        "street_2": "Các đường trong KDC tái định cư TTHC TPLX",
        "street_type": 3,
        "price": 8
      },
      {
        "code": "MH7A",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "các Đường Không Tên khu Golden City",
        "street_code": "ĐKTGC",
        "street_2": "Các đường chưa đặt tên trong Golden City",
        "street_type": null,
        "price": 10.8
      },
      {
        "code": "MH8",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "Trần Quang Diệu Nối Dài",
        "street_code": "TQDND",
        "street_2": "Đường Trần Quang Diệu nối dài",
        "street_type": 4,
        "price": 3
      },
      {
        "code": "MH9",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "Đường Số 3 BHHH",
        "street_code": "ĐS3BHHH",
        "street_2": "Đường trong KDC BẮC HÀ HOÀNG HỔ",
        "street_type": 4,
        "price": 1.8
      },
      {
        "code": "MH10",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "Đường Số 4 BHHH",
        "street_code": "ĐS4BHHH",
        "street_2": "Đường trong KDC BẮC HÀ HOÀNG HỔ",
        "street_type": 4,
        "price": 1.8
      },
      {
        "code": "MH11",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "Đường Số 5 BHHH",
        "street_code": "ĐS5BHHH",
        "street_2": "Đường trong KDC BẮC HÀ HOÀNG HỔ",
        "street_type": 4,
        "price": 1.8
      },
      {
        "code": "MH12",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "Đường Số 6 BHHH",
        "street_code": "ĐS6BHHH",
        "street_2": "Đường trong KDC BẮC HÀ HOÀNG HỔ",
        "street_type": 4,
        "price": 1.8
      },
      {
        "code": "MH13",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "Đường Số 6A BHHH",
        "street_code": "ĐS6ABHHH",
        "street_2": "Đường trong KDC BẮC HÀ HOÀNG HỔ",
        "street_type": 4,
        "price": 1.8
      },
      {
        "code": "MH14",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "Đường Số 6B BHHH",
        "street_code": "ĐS6BBHHH",
        "street_2": "Đường trong KDC BẮC HÀ HOÀNG HỔ",
        "street_type": 4,
        "price": 1.8
      },
      {
        "code": "MH15",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "Đường Số 7 BHHH",
        "street_code": "ĐS7BHHH",
        "street_2": "Đường trong KDC BẮC HÀ HOÀNG HỔ",
        "street_type": 4,
        "price": 1.8
      },
      {
        "code": "MH16",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "Đường Số 7A BHHH",
        "street_code": "ĐS7ABHHH",
        "street_2": "Đường trong KDC BẮC HÀ HOÀNG HỔ",
        "street_type": 4,
        "price": 1.8
      },
      {
        "code": "MH17",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "Đường Số 7B BHHH",
        "street_code": "ĐS7BBHHH",
        "street_2": "Đường trong KDC BẮC HÀ HOÀNG HỔ",
        "street_type": 4,
        "price": 1.8
      },
      {
        "code": "MH18",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "Đường Số 8 BHHH",
        "street_code": "ĐS8BHHH",
        "street_2": "Đường trong KDC BẮC HÀ HOÀNG HỔ",
        "street_type": 4,
        "price": 2.4
      },
      {
        "code": "MH19",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "Đường Số 9 BHHH",
        "street_code": "ĐS9BHHH",
        "street_2": "Đường trong KDC BẮC HÀ HOÀNG HỔ",
        "street_type": 4,
        "price": 1.8
      },
      {
        "code": "MH20",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "Đường Số 10 BHHH",
        "street_code": "ĐS10BHHH",
        "street_2": "Đường trong KDC BẮC HÀ HOÀNG HỔ",
        "street_type": 4,
        "price": 1.8
      },
      {
        "code": "MH21",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "Đường Số 11 BHHH",
        "street_code": "ĐS11BHHH",
        "street_2": "Đường trong KDC BẮC HÀ HOÀNG HỔ",
        "street_type": 4,
        "price": 2.4
      },
      {
        "code": "MH22",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "Đường Số 12 BHHH",
        "street_code": "ĐS12BHHH",
        "street_2": "Đường trong KDC BẮC HÀ HOÀNG HỔ",
        "street_type": 4,
        "price": 2.4
      },
      {
        "code": "MH23A",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "Bùi Văn Danh",
        "street_code": "BVD",
        "street_2": "Nguyễn Thái Học - Ngã 3 Mương Điểm",
        "street_type": 4,
        "price": 2.5
      },
      {
        "code": "MH24",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "Đường thuộc Kdc Hẻm Tường Vi",
        "street_code": "ĐKHTV",
        "street_2": "Các đường thuộc KDC Tây Khánh 4 (hẻm Tường Vi)",
        "street_type": 4,
        "price": 1.5
      },
      {
        "code": "MH25",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "Đường thuộc Kdc Tây Khánh 3 (vượt lũ)",
        "street_code": "ĐKTK3",
        "street_2": "Các đường thuộc KDC Tây Khánh 3 (vượt lũ)",
        "street_type": 4,
        "price": 1.5
      },
      {
        "code": "MH26",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "Đường Cặp Rạch OÔng Mạnh",
        "street_code": "ĐCROM",
        "street_2": "Cầu sắt rạch Ông Mạnh - Nhà máy Ba Tấu",
        "street_type": 4,
        "price": 1.6
      },
      {
        "code": "MH27A",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "Đường Cặp Rạch Mương Điểm",
        "street_code": "ĐCRMĐ",
        "street_2": "Đường tỉnh 943 vô cặp rạch",
        "street_type": 4,
        "price": 1.5
      },
      {
        "code": "MH28A",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "Đường Cặp Rạch Mương Khai Lớn",
        "street_code": "ĐCRMKL",
        "street_2": "Đường tỉnh 943 vô cặp rạch",
        "street_type": 4,
        "price": 1.5
      },
      {
        "code": "MH29A",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "Đường Mương Cạn",
        "street_code": "ĐMC",
        "street_2": "Mương lộ 943 vô Cầu Lâm Trường",
        "street_type": 4,
        "price": 1.5
      },
      {
        "code": "MH30",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "Đường Số 2 Kdc Bà Bầu",
        "street_code": "ĐS2KBB",
        "street_2": "Đoạn giáp phường Đông Xuyên",
        "street_type": 4,
        "price": 1.5
      },
      {
        "code": "MH31A",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "Đường Cặp Rạch Long Xuyên",
        "street_code": "ĐCRLX",
        "street_2": "Cầu Mương Lạng - cầu Bằng Tăng",
        "street_type": 4,
        "price": 1.5
      },
      {
        "code": "MH32",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "Đường Cặp Rạch Mương Khai Nhỏ",
        "street_code": "ĐCRMKN",
        "street_2": "Đường tỉnh 943 - KDC Nguyễn Thanh Bình",
        "street_type": 4,
        "price": 1.5
      },
      {
        "code": "MH33",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "Hẻm tổ 6;7;8;12 Tây Khánh 4",
        "street_code": "H67812TK4",
        "street_2": "Tất cả các đường",
        "street_type": 4,
        "price": 1.5
      },
      {
        "code": "MH34",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "Hẻm 11 Tây Khánh 4",
        "street_code": "H11TK4",
        "street_2": "Suốt đường",
        "street_type": 4,
        "price": 1.5
      },
      {
        "code": "MH35",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "Hẻm 13 Rạch Bằng Lăng",
        "street_code": "H13RBL",
        "street_2": "Suốt đường",
        "street_type": 4,
        "price": 1.5
      },
      {
        "code": "MH36",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "Hẻm 21, 22, 23",
        "street_code": "H212223",
        "street_2": "Suốt đường",
        "street_type": 4,
        "price": 1.5
      },
      {
        "code": "MH37A",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "Hẻm Cặp Rạch Oông Mạnh",
        "street_code": "HCROM",
        "street_2": "Bắc: Đường tỉnh 943 – Rạch Long Xuyên",
        "street_type": 4,
        "price": 1.5
      },
      {
        "code": "MH38",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "các Đường Không Tên trong Kdc Thiên Lộc",
        "street_code": "ĐKTKTL",
        "street_2": "Các đường chưa có tên trong KDC Thiên Lộc",
        "street_type": 4,
        "price": 3
      },
      {
        "code": "MH39",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "Đường nhựa khóm Tây Khánh 5",
        "street_code": "ĐTK5",
        "street_2": "Đường tỉnh 943 - phường Mỹ Phước",
        "street_type": 4,
        "price": 1.5
      },
      {
        "code": "MH40",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "Đường Số 1 LGV",
        "street_code": "ĐS1LGV",
        "street_2": "Đường trong KDC làng giáo viên Đại học",
        "street_type": 4,
        "price": 1.5
      },
      {
        "code": "MH41",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "Đường Số 2 LGV",
        "street_code": "ĐS2LGV",
        "street_2": "Đường trong KDC làng giáo viên Đại học",
        "street_type": 4,
        "price": 1.5
      },
      {
        "code": "MH42",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "Đường Số 3 LGV",
        "street_code": "ĐS3LGV",
        "street_2": "Đường trong KDC làng giáo viên Đại học",
        "street_type": 4,
        "price": 1.5
      },
      {
        "code": "MH43",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "Đường Số 4 LGV",
        "street_code": "ĐS4LGV",
        "street_2": "Đường trong KDC làng giáo viên Đại học",
        "street_type": 4,
        "price": 1.5
      },
      {
        "code": "MH44",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "Đường Số 5 LGV",
        "street_code": "ĐS5LGV",
        "street_2": "Đường trong KDC làng giáo viên Đại học",
        "street_type": 4,
        "price": 1.5
      },
      {
        "code": "MH45",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "Đường Số 6 LGV",
        "street_code": "ĐS6LGV",
        "street_2": "Đường trong KDC làng giáo viên Đại học",
        "street_type": 4,
        "price": 1.5
      },
      {
        "code": "MH46",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "Đường Số 7 LGV",
        "street_code": "ĐS7LGV",
        "street_2": "Đường trong KDC làng giáo viên Đại học",
        "street_type": 4,
        "price": 1.5
      },
      {
        "code": "MH47",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "Đường Số 8 LGV",
        "street_code": "ĐS8LGV",
        "street_2": "Đường trong KDC làng giáo viên Đại học",
        "street_type": 4,
        "price": 1.5
      },
      {
        "code": "MH48",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "Đường Số 9 LGV",
        "street_code": "ĐS9LGV",
        "street_2": "Đường trong KDC làng giáo viên Đại học",
        "street_type": 4,
        "price": 1.5
      },
      {
        "code": "MH49",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "Đường Số 10 LGV",
        "street_code": "ĐS10LGV",
        "street_2": "Đường trong KDC làng giáo viên Đại học",
        "street_type": 4,
        "price": 1.5
      },
      {
        "code": "MH50",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "Đường Số 11 LGV",
        "street_code": "ĐS11LGV",
        "street_2": "Đường trong KDC làng giáo viên Đại học",
        "street_type": 4,
        "price": 1.5
      },
      {
        "code": "MH51",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "Hẻm AẤp Chiến Lược",
        "street_code": "HACL",
        "street_2": "Tỉnh Lộ 943 - Nguyễn Thái Học",
        "street_type": 4,
        "price": 1.5
      },
      {
        "code": "MH52",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "Đường Cặp Rạch Bằng Tăng",
        "street_code": "ĐCRBT",
        "street_2": "Đường tỉnh 943 - rạch Mương Khai Lớn",
        "street_type": 4,
        "price": 1.5
      },
      {
        "code": "MH53",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "Đường Cặp Rạch Bằng Lăng",
        "street_code": "ĐCRBL",
        "street_2": "Tỉnh Lộ 943 - Bùi Văn Danh",
        "street_type": 4,
        "price": 1.5
      },
      {
        "code": "MH54",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "Đường Cặp Rạch Mương Tắc",
        "street_code": "ĐCRMT",
        "street_2": "Trại giam - rạch Ông Mạnh",
        "street_type": 4,
        "price": 1.5
      },
      {
        "code": "MH55",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "Đường Mương Xã",
        "street_code": "ĐMX",
        "street_2": "Suốt đường",
        "street_type": 4,
        "price": 1
      },
      {
        "code": "MH56",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "Đường Mương Bà Hai",
        "street_code": "ĐMBH",
        "street_2": "Suốt đường",
        "street_type": 4,
        "price": 1
      },
      {
        "code": "MH57",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "Đường Mương Cui",
        "street_code": "ĐMC",
        "street_2": "Suốt đường",
        "street_type": 4,
        "price": 1
      },
      {
        "code": "MH58",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "Đường Mương Thầy Phó",
        "street_code": "ĐMTP",
        "street_2": "Suốt đường",
        "street_type": 4,
        "price": 1
      },
      {
        "code": "MH59",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "Đường Cặp Rạch Mương Hội",
        "street_code": "ĐCRMH",
        "street_2": "Rạch Bằng Tăng - Tờ BĐ 45 thửa 293",
        "street_type": 4,
        "price": 1
      },
      {
        "code": "MH60",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "Khu dân cư Nguyễn Văn Ngọc",
        "street_code": "KNVN",
        "street_2": "Các đường trong KDC",
        "street_type": 4,
        "price": 2
      },
      {
        "code": "MH61",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "Khu dân cư Trương Hoàng Sơn",
        "street_code": "KTHS",
        "street_2": "Các đường trong KDC",
        "street_type": 4,
        "price": 2
      },
      {
        "code": "MH62",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "Khu dân cư Huỳnh Thanh Liêm",
        "street_code": "KHTL",
        "street_2": "Các đường trong KDC",
        "street_type": 4,
        "price": 1.5
      },
      {
        "code": "MH63",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "Khu dân cư Nguyễn Thanh Bình",
        "street_code": "KNTB",
        "street_2": "Các đường trong KDC",
        "street_type": 4,
        "price": 1.5
      },
      {
        "code": "MH64",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "Khu dân cư Đỗ Quang Thiệt",
        "street_code": "KĐQT",
        "street_2": "Các đường trong KDC",
        "street_type": 4,
        "price": 1.5
      },
      {
        "code": "MH65",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "Khu dân cư Sở VHTT và DL",
        "street_code": "KSVHTTDL",
        "street_2": "Các đường trong KDC",
        "street_type": 4,
        "price": 1.5
      },
      {
        "code": "MH66",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "Khu dân cư giáp Nhà Máy Xử Lý Nước Thải",
        "street_code": "KNMXLNT",
        "street_2": "Các đường trong KDC",
        "street_type": 4,
        "price": 1.5
      },
      {
        "code": "MH67",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "Khu dân cư Nguyễn Ngọc Ni",
        "street_code": "KNNN",
        "street_2": "Các đường trong KDC",
        "street_type": 4,
        "price": 2
      },
      {
        "code": "MH68",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "các Đường Không Tên thuộc kdc Làng Giáo Viên",
        "street_code": "ĐKTLGV",
        "street_2": "Các đường chưa đặt tên khu dân cư Làng Giáo Viên",
        "street_type": 4,
        "price": null
      },
      {
        "code": "MH69",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "Trần Cảnh",
        "street_code": "TC",
        "street_2": "Đoạn trong",
        "street_type": 4,
        "price": 3
      },
      {
        "code": "MH70",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "Chung Cư NHO",
        "street_code": "CCNHO",
        "street_2": "Các căn hộ trong Chung cư First Home - NHO",
        "street_type": null,
        "price": null
      },
      {
        "code": "MH71",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "các Đường Không Tên thuộc kdc Tây Khánh 8",
        "street_code": "ĐKTTK8",
        "street_2": "Tất cả các đường chưa đặt tên khu Tây Khánh 8",
        "street_type": 4,
        "price": 1.5
      },
      {
        "code": "MH71A",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "Đường Số 1 TK8A",
        "street_code": "ĐS1TK8A",
        "street_2": "KDC Tây Khánh 8",
        "street_type": null,
        "price": null
      },
      {
        "code": "MH71B",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "Đường Số 2 TK8A",
        "street_code": "ĐS2TK8A",
        "street_2": "KDC Tây Khánh 8",
        "street_type": null,
        "price": null
      },
      {
        "code": "MH71C",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "Đường Số 3 TK8A",
        "street_code": "ĐS3TK8A",
        "street_2": "KDC Tây Khánh 8",
        "street_type": null,
        "price": null
      },
      {
        "code": "MH71D",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "Đường Số 4 TK8A",
        "street_code": "ĐS4TK8A",
        "street_2": "KDC Tây Khánh 8",
        "street_type": null,
        "price": null
      },
      {
        "code": "MH71E",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "Đường Số 5 TK8A",
        "street_code": "ĐS5TK8A",
        "street_2": "KDC Tây Khánh 8",
        "street_type": null,
        "price": null
      },
      {
        "code": "MH71F",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "Đường Số 6 TK8A",
        "street_code": "ĐS6TK8A",
        "street_2": "KDC Tây Khánh 8",
        "street_type": null,
        "price": null
      },
      {
        "code": "MH71G",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "Đường Số 7 TK8A",
        "street_code": "ĐS7TK8A",
        "street_2": "KDC Tây Khánh 8",
        "street_type": null,
        "price": null
      },
      {
        "code": "MH71H",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "Đường Số 8 TK8A",
        "street_code": "ĐS8TK8A",
        "street_2": "KDC Tây Khánh 8",
        "street_type": null,
        "price": null
      },
      {
        "code": "MH71I",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "Đường Số 9 TK8A",
        "street_code": "ĐS9TK8A",
        "street_2": "KDC Tây Khánh 8",
        "street_type": null,
        "price": null
      },
      {
        "code": "MH71J",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "Đường Số 1 TK8B",
        "street_code": "ĐS1TK8B",
        "street_2": "KDC Tây Khánh 8",
        "street_type": null,
        "price": null
      },
      {
        "code": "MH71K",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "Đường Số 2 TK8B",
        "street_code": "ĐS2TK8B",
        "street_2": "KDC Tây Khánh 8",
        "street_type": null,
        "price": null
      },
      {
        "code": "MH71L",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "Đường Số 3 TK8B",
        "street_code": "ĐS3TK8B",
        "street_2": "KDC Tây Khánh 8",
        "street_type": null,
        "price": null
      },
      {
        "code": "MH71M",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "Đường Số 4 TK8B",
        "street_code": "ĐS4TK8B",
        "street_2": "KDC Tây Khánh 8",
        "street_type": null,
        "price": null
      },
      {
        "code": "MH71N",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "Đường Số 5 TK8B",
        "street_code": "ĐS5TK8B",
        "street_2": "KDC Tây Khánh 8",
        "street_type": null,
        "price": null
      },
      {
        "code": "MH71O",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "Đường Số 6 TK8B",
        "street_code": "ĐS6TK8B",
        "street_2": "KDC Tây Khánh 8",
        "street_type": null,
        "price": null
      },
      {
        "code": "MH72",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "Đường Số 15 BHHH",
        "street_code": "ĐS15BHHH",
        "street_2": "Đường trong KDC BẮC HÀ HOÀNG HỔ",
        "street_type": 4,
        "price": 2.4
      },
      {
        "code": "MH73",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "Đường N1 LGV1",
        "street_code": "ĐN1LGV1",
        "street_2": "KDC Làng giáo viên Mở rộng 1",
        "street_type": null,
        "price": null
      },
      {
        "code": "MH74",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "Đường N2 LGV1",
        "street_code": "ĐN2LGV1",
        "street_2": "KDC Làng giáo viên Mở rộng 1",
        "street_type": null,
        "price": null
      },
      {
        "code": "MH75",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "Đường N3 LGV1",
        "street_code": "ĐN3LGV1",
        "street_2": "KDC Làng giáo viên Mở rộng 1",
        "street_type": null,
        "price": null
      },
      {
        "code": "MH76",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "Đường N4 LGV1",
        "street_code": "ĐN4LGV1",
        "street_2": "KDC Làng giáo viên Mở rộng 1",
        "street_type": null,
        "price": null
      },
      {
        "code": "MH77",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "Đường D1 LGV1",
        "street_code": "ĐD1LGV1",
        "street_2": "KDC Làng giáo viên Mở rộng 1",
        "street_type": null,
        "price": null
      },
      {
        "code": "MH78",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "Đường D2 LGV1",
        "street_code": "ĐD2LGV1",
        "street_2": "KDC Làng giáo viên Mở rộng 1",
        "street_type": null,
        "price": null
      },
      {
        "code": "MH79",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "Đường D3 LGV1",
        "street_code": "ĐD3LGV1",
        "street_2": "KDC Làng giáo viên Mở rộng 1",
        "street_type": null,
        "price": null
      },
      {
        "code": "MH80",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "Đường D4 LGV1",
        "street_code": "ĐD4LGV1",
        "street_2": "KDC Làng giáo viên Mở rộng 1",
        "street_type": null,
        "price": null
      },
      {
        "code": "MH81",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "Đường D5 LGV1",
        "street_code": "ĐD5LGV1",
        "street_2": "KDC Làng giáo viên Mở rộng 1",
        "street_type": null,
        "price": null
      },
      {
        "code": "MH82",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "Đường D5A LGV1",
        "street_code": "ĐD5ALGV1",
        "street_2": "KDC Làng giáo viên Mở rộng 1",
        "street_type": null,
        "price": null
      },
      {
        "code": "MH83",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "Đường D6 LGV1",
        "street_code": "ĐD6LGV1",
        "street_2": "KDC Làng giáo viên Mở rộng 1",
        "street_type": null,
        "price": null
      },
      {
        "code": "MH84",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "Đường D7 LGV1",
        "street_code": "ĐD7LGV1",
        "street_2": "KDC Làng giáo viên Mở rộng 1",
        "street_type": null,
        "price": null
      },
      {
        "code": "MH85",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "Đường N5 LGV2",
        "street_code": "ĐN5LGV2",
        "street_2": "KDC Làng giáo viên Mở rộng 2",
        "street_type": null,
        "price": null
      },
      {
        "code": "MH86",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "Đường N6 LGV2",
        "street_code": "ĐN6LGV2",
        "street_2": "KDC Làng giáo viên Mở rộng 2",
        "street_type": null,
        "price": null
      },
      {
        "code": "MH87",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "Đường N7 LGV2",
        "street_code": "ĐN7LGV2",
        "street_2": "KDC Làng giáo viên Mở rộng 2",
        "street_type": null,
        "price": null
      },
      {
        "code": "MH88",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "Đường N8 LGV2",
        "street_code": "ĐN8LGV2",
        "street_2": "KDC Làng giáo viên Mở rộng 2",
        "street_type": null,
        "price": null
      },
      {
        "code": "MH89",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "Đường N9 LGV2",
        "street_code": "ĐN9LGV2",
        "street_2": "KDC Làng giáo viên Mở rộng 2",
        "street_type": null,
        "price": null
      },
      {
        "code": "MH90",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "Tuyến D1 GC",
        "street_code": "TD1GC",
        "street_2": "KĐT Golden City",
        "street_type": null,
        "price": null
      },
      {
        "code": "MH91",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "Tuyến D2 GC",
        "street_code": "TD2GC",
        "street_2": "KĐT Golden City",
        "street_type": null,
        "price": null
      },
      {
        "code": "MH92",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "Tuyến D3B GC",
        "street_code": "TD3BGC",
        "street_2": "KĐT Golden City",
        "street_type": null,
        "price": null
      },
      {
        "code": "MH93",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "Tuyến D4 GC",
        "street_code": "TD4GC",
        "street_2": "KĐT Golden City",
        "street_type": null,
        "price": null
      },
      {
        "code": "MH94",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "Tuyến D5B GC",
        "street_code": "TD5BGC",
        "street_2": "KĐT Golden City",
        "street_type": null,
        "price": null
      },
      {
        "code": "MH95",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "Tuyến D6 GC",
        "street_code": "TD6GC",
        "street_2": "KĐT Golden City",
        "street_type": null,
        "price": null
      },
      {
        "code": "MH96",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "Tuyến D7 GC",
        "street_code": "TD7GC",
        "street_2": "KĐT Golden City",
        "street_type": null,
        "price": null
      },
      {
        "code": "MH97",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "Tuyến N1 GC",
        "street_code": "TN1GC",
        "street_2": "KĐT Golden City",
        "street_type": null,
        "price": null
      },
      {
        "code": "MH98",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "Tuyến N2A GC",
        "street_code": "TN2AGC",
        "street_2": "KĐT Golden City",
        "street_type": null,
        "price": null
      },
      {
        "code": "MH99",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "Tuyến N2B GC",
        "street_code": "TN2BGC",
        "street_2": "KĐT Golden City",
        "street_type": null,
        "price": null
      },
      {
        "code": "MH100",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "Tuyến N3A GC",
        "street_code": "TN3AGC",
        "street_2": "KĐT Golden City",
        "street_type": null,
        "price": null
      },
      {
        "code": "MH101",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "Tuyến N3B GC",
        "street_code": "TN3BGC",
        "street_2": "KĐT Golden City",
        "street_type": null,
        "price": null
      },
      {
        "code": "MH102",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "Tuyến N4 GC",
        "street_code": "TN4GC",
        "street_2": "KĐT Golden City",
        "street_type": null,
        "price": null
      },
      {
        "code": "MH103",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "Tuyến N6A GC",
        "street_code": "TN6AGC",
        "street_2": "KĐT Golden City",
        "street_type": null,
        "price": null
      },
      {
        "code": "MH104",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "Tuyến N6B GC",
        "street_code": "TN6BGC",
        "street_2": "KĐT Golden City",
        "street_type": null,
        "price": null
      },
      {
        "code": "MH105",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "Tuyến N7 GC",
        "street_code": "TN7GC",
        "street_2": "KĐT Golden City",
        "street_type": null,
        "price": null
      },
      {
        "code": "MH106",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "Tuyến N8A GC",
        "street_code": "TN8AGC",
        "street_2": "KĐT Golden City",
        "street_type": null,
        "price": null
      },
      {
        "code": "MH107",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "Tuyến N8B GC",
        "street_code": "TN8BGC",
        "street_2": "KĐT Golden City",
        "street_type": null,
        "price": null
      },
      {
        "code": "MH108",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "Tuyến N9 GC",
        "street_code": "TN9GC",
        "street_2": "KĐT Golden City",
        "street_type": null,
        "price": null
      },
      {
        "code": "MH109",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "Tuyến N10A GC2",
        "street_code": "TN10AGC2",
        "street_2": "KĐT Golden City GD2",
        "street_type": null,
        "price": null
      },
      {
        "code": "MH110",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "Tuyến N10B GC2",
        "street_code": "TN10BGC2",
        "street_2": "KĐT Golden City GD2",
        "street_type": null,
        "price": null
      },
      {
        "code": "MH111",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "Tuyến N11 GC2",
        "street_code": "TN11GC2",
        "street_2": "KĐT Golden City GD2",
        "street_type": null,
        "price": null
      },
      {
        "code": "MH112",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "Tuyến N12 GC2",
        "street_code": "TN12GC2",
        "street_2": "KĐT Golden City GD2",
        "street_type": null,
        "price": null
      },
      {
        "code": "MH113",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "Tuyến N15 GC2",
        "street_code": "TN15GC2",
        "street_2": "KĐT Golden City GD2",
        "street_type": null,
        "price": null
      },
      {
        "code": "MH114",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "Đường Số 2 GC",
        "street_code": "ĐS2GC",
        "street_2": "KĐT Golden City",
        "street_type": null,
        "price": null
      },
      {
        "code": "MH115",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "Đường Số 21 GC",
        "street_code": "ĐS21GC",
        "street_2": "KĐT Golden City",
        "street_type": null,
        "price": null
      },
      {
        "code": "MH116",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "Đường Số 22 GC",
        "street_code": "ĐS22GC",
        "street_2": "KĐT Golden City",
        "street_type": null,
        "price": null
      },
      {
        "code": "MH117",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "Đường Số 23 GC",
        "street_code": "ĐS23GC",
        "street_2": "KĐT Golden City",
        "street_type": null,
        "price": null
      },
      {
        "code": "MH118",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "Đường Số 24 GC",
        "street_code": "ĐS24GC",
        "street_2": "KĐT Golden City",
        "street_type": null,
        "price": null
      },
      {
        "code": "MH119",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "Chung Cư GOLDEN",
        "street_code": "CCGOLDEN",
        "street_2": "Các căn hộ trong Chung cư Golden City",
        "street_type": null,
        "price": null
      },
      {
        "code": "MH120",
        "ward_code": "MH",
        "ward": "Mỹ Hòa",
        "street": "Đường Tránh Long Xuyên - Mỹ Hòa",
        "street_code": "ĐTLXMH",
        "street_2": "Đường Tránh Long Xuyên đoạn qua phường Mỹ Hòa",
        "street_type": null,
        "price": null
      },
      {
        "code": "MQ1",
        "ward_code": "MQ",
        "ward": "Mỹ Quý",
        "street": "Trần Hưng Đạo",
        "street_code": "THĐ",
        "street_2": "Suốt đường",
        "street_type": 2,
        "price": 15
      },
      {
        "code": "MQ2",
        "ward_code": "MQ",
        "ward": "Mỹ Quý",
        "street": "Phạm Cự Lượng",
        "street_code": "PCL",
        "street_2": "Suốt đường",
        "street_type": 2,
        "price": 10
      },
      {
        "code": "MQ3",
        "ward_code": "MQ",
        "ward": "Mỹ Quý",
        "street": "Hồ Nguyên Trừng",
        "street_code": "HNT",
        "street_2": "Hồ Quý Ly - Trụ sở UBND phường",
        "street_type": 3,
        "price": 8
      },
      {
        "code": "MQ4",
        "ward_code": "MQ",
        "ward": "Mỹ Quý",
        "street": "Đinh Lễ",
        "street_code": "ĐL",
        "street_2": "Đào Duy Từ - Hồ Quý Ly",
        "street_type": 3,
        "price": 8
      },
      {
        "code": "MQ5",
        "ward_code": "MQ",
        "ward": "Mỹ Quý",
        "street": "Đào Duy Từ",
        "street_code": "ĐDT",
        "street_2": "Hồ Nguyên Trừng - Lê Chân",
        "street_type": 3,
        "price": 8
      },
      {
        "code": "MQ6",
        "ward_code": "MQ",
        "ward": "Mỹ Quý",
        "street": "Hồ Quý Ly",
        "street_code": "HQL",
        "street_2": "Phạm Cự Lượng - Lê Chân",
        "street_type": 3,
        "price": 8
      },
      {
        "code": "MQ7",
        "ward_code": "MQ",
        "ward": "Mỹ Quý",
        "street": "Đinh Liệt",
        "street_code": "ĐL",
        "street_2": "Suốt đường",
        "street_type": 3,
        "price": 8
      },
      {
        "code": "MQ8",
        "ward_code": "MQ",
        "ward": "Mỹ Quý",
        "street": "Đặng Trần Côn",
        "street_code": "ĐTC",
        "street_2": "Phạm Cự Lượng - Hồ Nguyên Trừng",
        "street_type": 3,
        "price": 8
      },
      {
        "code": "MQ9",
        "ward_code": "MQ",
        "ward": "Mỹ Quý",
        "street": "Châu Mạnh Trinh",
        "street_code": "CMT",
        "street_2": "Suốt đường",
        "street_type": 3,
        "price": 6
      },
      {
        "code": "MQ10",
        "ward_code": "MQ",
        "ward": "Mỹ Quý",
        "street": "Đỗ Nhuận",
        "street_code": "ĐN",
        "street_2": "Suốt đường",
        "street_type": 3,
        "price": 6
      },
      {
        "code": "MQ11",
        "ward_code": "MQ",
        "ward": "Mỹ Quý",
        "street": "Phùng Khắc Khoan",
        "street_code": "PKK",
        "street_2": "Suốt đường",
        "street_type": 3,
        "price": 6
      },
      {
        "code": "MQ12",
        "ward_code": "MQ",
        "ward": "Mỹ Quý",
        "street": "Đoàn Thị Điểm",
        "street_code": "ĐTĐ",
        "street_2": "Trần Hưng Đạo - Công ty Nam Việt",
        "street_type": 3,
        "price": 6
      },
      {
        "code": "MQ13",
        "ward_code": "MQ",
        "ward": "Mỹ Quý",
        "street": "Đường Cặp Kho Mai Hưng",
        "street_code": "ĐCKMH",
        "street_2": "Suốt đường",
        "street_type": 3,
        "price": 6
      },
      {
        "code": "MQ14",
        "ward_code": "MQ",
        "ward": "Mỹ Quý",
        "street": "Hùng Vương (nối dài)",
        "street_code": "HV",
        "street_2": "Suốt đường",
        "street_type": 4,
        "price": 3
      },
      {
        "code": "MQ15",
        "ward_code": "MQ",
        "ward": "Mỹ Quý",
        "street": "Dương Diên Nghệ",
        "street_code": "DDN",
        "street_2": "Trần Hưng Đạo - Khu đô thị mới Tây Sông Hậu",
        "street_type": 4,
        "price": 7
      },
      {
        "code": "MQ16A",
        "ward_code": "MQ",
        "ward": "Mỹ Quý",
        "street": "Lê Chân",
        "street_code": "LC",
        "street_2": "Trần Hưng Đạo - Ngã 4 khu dân cư trại cá giống",
        "street_type": 4,
        "price": 6
      },
      {
        "code": "MQ17",
        "ward_code": "MQ",
        "ward": "Mỹ Quý",
        "street": "Thánh Thiên",
        "street_code": "TT",
        "street_2": "Suốt đường",
        "street_type": 4,
        "price": 5
      },
      {
        "code": "MQ18",
        "ward_code": "MQ",
        "ward": "Mỹ Quý",
        "street": "Hồ Quý Ly",
        "street_code": "HQL",
        "street_2": "Lê Chân - Cầm Bá Thước",
        "street_type": 4,
        "price": 3
      },
      {
        "code": "MQ19",
        "ward_code": "MQ",
        "ward": "Mỹ Quý",
        "street": "Giang Văn Minh",
        "street_code": "GVM",
        "street_2": "Suốt đường",
        "street_type": 4,
        "price": 3
      },
      {
        "code": "MQ20",
        "ward_code": "MQ",
        "ward": "Mỹ Quý",
        "street": "Hồ Bá OÔn",
        "street_code": "HBO",
        "street_2": "Suốt đường",
        "street_type": 4,
        "price": 3
      },
      {
        "code": "MQ21",
        "ward_code": "MQ",
        "ward": "Mỹ Quý",
        "street": "Hồ Bá Kiện",
        "street_code": "HBK",
        "street_2": "Suốt đường",
        "street_type": 4,
        "price": 3
      },
      {
        "code": "MQ22",
        "ward_code": "MQ",
        "ward": "Mỹ Quý",
        "street": "Lương Ngọc Quyến",
        "street_code": "LNQ",
        "street_2": "Suốt đường",
        "street_type": 4,
        "price": 3
      },
      {
        "code": "MQ23",
        "ward_code": "MQ",
        "ward": "Mỹ Quý",
        "street": "Cầm Bá Thước",
        "street_code": "CBT",
        "street_2": "Suốt đường",
        "street_type": 4,
        "price": 3
      },
      {
        "code": "MQ24",
        "ward_code": "MQ",
        "ward": "Mỹ Quý",
        "street": "Mạc Đăng Dung",
        "street_code": "MĐD",
        "street_2": "Suốt đường",
        "street_type": 4,
        "price": 4
      },
      {
        "code": "MQ25",
        "ward_code": "MQ",
        "ward": "Mỹ Quý",
        "street": "Đào Tấn",
        "street_code": "ĐT",
        "street_2": "Suốt đường",
        "street_type": 4,
        "price": 4
      },
      {
        "code": "MQ26",
        "ward_code": "MQ",
        "ward": "Mỹ Quý",
        "street": "Ngô Sĩ Liên",
        "street_code": "NSL",
        "street_2": "Suốt đường",
        "street_type": 4,
        "price": 4
      },
      {
        "code": "MQ27",
        "ward_code": "MQ",
        "ward": "Mỹ Quý",
        "street": "Ngô Thời Sĩ",
        "street_code": "NTS",
        "street_2": "Suốt đường",
        "street_type": 4,
        "price": 6
      },
      {
        "code": "MQ28",
        "ward_code": "MQ",
        "ward": "Mỹ Quý",
        "street": "Phan Huy IÍch",
        "street_code": "PHI",
        "street_2": "Suốt đường",
        "street_type": 4,
        "price": 5
      },
      {
        "code": "MQ29",
        "ward_code": "MQ",
        "ward": "Mỹ Quý",
        "street": "Lý Trần Quán",
        "street_code": "LTQ",
        "street_2": "Suốt đường",
        "street_type": 4,
        "price": 4
      },
      {
        "code": "MQ30",
        "ward_code": "MQ",
        "ward": "Mỹ Quý",
        "street": "Đường Liên Khóm Tân Phú",
        "street_code": "ĐLKTP",
        "street_2": "Phạm Cự Lượng - Cầu Đôi",
        "street_type": 4,
        "price": 3
      },
      {
        "code": "MQ31",
        "ward_code": "MQ",
        "ward": "Mỹ Quý",
        "street": "Thoại Ngọc Hầu",
        "street_code": "TNH",
        "street_2": "Cầu rạch Gừa - ngã 3 Dương Diên Nghệ",
        "street_type": 4,
        "price": 3
      },
      {
        "code": "MQ32A",
        "ward_code": "MQ",
        "ward": "Mỹ Quý",
        "street": "Đường Cặp Rạch Gòi Lớn",
        "street_code": "ĐCRGL",
        "street_2": "Đình Mỹ Quý - Trần Hưng Đạo - giáp Mỹ Hòa",
        "street_type": 4,
        "price": 3
      },
      {
        "code": "MQ33",
        "ward_code": "MQ",
        "ward": "Mỹ Quý",
        "street": "Hẻm Cặp Xí Nghiệp Cơ Khí",
        "street_code": "HCXNCK",
        "street_2": "Trần Hưng Đạo - Cầu Rạch Gừa",
        "street_type": 4,
        "price": 3
      },
      {
        "code": "MQ34",
        "ward_code": "MQ",
        "ward": "Mỹ Quý",
        "street": "Nguyễn Gia Thiều",
        "street_code": "NGT",
        "street_2": "Suốt đường (đường Chùa Hiếu Nghĩa)",
        "street_type": 4,
        "price": 3
      },
      {
        "code": "MQ35",
        "ward_code": "MQ",
        "ward": "Mỹ Quý",
        "street": "Đường Ngã Cạy",
        "street_code": "ĐNC",
        "street_2": "Suốt đường",
        "street_type": 4,
        "price": 3
      },
      {
        "code": "MQ36",
        "ward_code": "MQ",
        "ward": "Mỹ Quý",
        "street": "Hẻm Cặp Rạch Gừa",
        "street_code": "HCRG",
        "street_2": "Trần Hưng Đạo - Hẻm Cơ khí",
        "street_type": 4,
        "price": 2
      },
      {
        "code": "MQ37",
        "ward_code": "MQ",
        "ward": "Mỹ Quý",
        "street": "Đường Cặp Rạch Bà Ngọ",
        "street_code": "ĐCRBN",
        "street_2": "Hai bên trái, phải",
        "street_type": 4,
        "price": 2
      },
      {
        "code": "MQ38",
        "ward_code": "MQ",
        "ward": "Mỹ Quý",
        "street": "Đường Cặp Kênh Đào",
        "street_code": "ĐCKĐ",
        "street_2": "Khu dân cư Xẻo Trôm 4 - Mương Chùa",
        "street_type": 4,
        "price": 1.5
      },
      {
        "code": "MQ39",
        "ward_code": "MQ",
        "ward": "Mỹ Quý",
        "street": "Đường Cặp Rạch Mương Khai",
        "street_code": "ĐCRMK",
        "street_2": "Giáp phường Mỹ Hòa",
        "street_type": 4,
        "price": 1
      },
      {
        "code": "MQ40",
        "ward_code": "MQ",
        "ward": "Mỹ Quý",
        "street": "các Đường Không Tên trong kdc Trại Cá Giống",
        "street_code": "ĐKTTCG",
        "street_2": "Các đường chưa đặt tên khu Trại Cá giống Mỹ Quý",
        "street_type": 4,
        "price": 6
      },
      {
        "code": "MQ41",
        "ward_code": "MQ",
        "ward": "Mỹ Quý",
        "street": "Kdc Cặp Rạch Xẻo Thoại",
        "street_code": "KCRXT",
        "street_2": "Các đường trong KDC",
        "street_type": 4,
        "price": 2
      },
      {
        "code": "MQ42",
        "ward_code": "MQ",
        "ward": "Mỹ Quý",
        "street": "Kdc Cặp Rạch Cây Lựu",
        "street_code": "KCRCL",
        "street_2": "Các đường trong KDC",
        "street_type": 4,
        "price": 2
      },
      {
        "code": "MQ43",
        "ward_code": "MQ",
        "ward": "Mỹ Quý",
        "street": "Kdc Văn Phòng ĐKĐ Long Xuyên",
        "street_code": "KVPĐKĐLX",
        "street_2": "Các đường trong KDC",
        "street_type": 4,
        "price": 2
      },
      {
        "code": "MQ44",
        "ward_code": "MQ",
        "ward": "Mỹ Quý",
        "street": "Kdc Rạch Bà Ngọ",
        "street_code": "KRBN",
        "street_2": "Các đường trong KDC",
        "street_type": 4,
        "price": 2
      },
      {
        "code": "MQ45",
        "ward_code": "MQ",
        "ward": "Mỹ Quý",
        "street": "Kdc Võ Bá Tòng",
        "street_code": "KVBT",
        "street_2": "Các đường trong KDC",
        "street_type": 4,
        "price": 1.5
      },
      {
        "code": "MQ46",
        "ward_code": "MQ",
        "ward": "Mỹ Quý",
        "street": "Kdc Que Lớn",
        "street_code": "KQL",
        "street_2": "Các đường trong KDC",
        "street_type": 4,
        "price": 2
      },
      {
        "code": "MQ47",
        "ward_code": "MQ",
        "ward": "Mỹ Quý",
        "street": "Kdc Lê Chân",
        "street_code": "KLC",
        "street_2": "Các đường trong KDC Lê Chân",
        "street_type": 4,
        "price": null
      },
      {
        "code": "MQ48",
        "ward_code": "MQ",
        "ward": "Mỹ Quý",
        "street": "Đường Tránh Long Xuyên - Mỹ Quý",
        "street_code": "ĐTLXMQ",
        "street_2": "Đường Tránh Long Xuyên đoạn qua phường Mỹ Quý",
        "street_type": 4,
        "price": null
      },
      {
        "code": "MX1",
        "ward_code": "MX",
        "ward": "Mỹ Xuyên",
        "street": "Lý Thái Tổ",
        "street_code": "LTT",
        "street_2": "Suốt đường",
        "street_type": 1,
        "price": 28
      },
      {
        "code": "MX2",
        "ward_code": "MX",
        "ward": "Mỹ Xuyên",
        "street": "Hà Hoàng Hổ",
        "street_code": "HHH",
        "street_2": "Trần Hưng Đạo - Phan Tôn",
        "street_type": 1,
        "price": 26
      },
      {
        "code": "MX3",
        "ward_code": "MX",
        "ward": "Mỹ Xuyên",
        "street": "Trần Hưng Đạo",
        "street_code": "THĐ",
        "street_2": "Cầu Cái Sơn - Cầu Hoàng Diệu",
        "street_type": 1,
        "price": 30
      },
      {
        "code": "MX4",
        "ward_code": "MX",
        "ward": "Mỹ Xuyên",
        "street": "Trần Bình Trọng",
        "street_code": "TBT",
        "street_2": "Suốt đường",
        "street_type": 1,
        "price": 17
      },
      {
        "code": "MX5",
        "ward_code": "MX",
        "ward": "Mỹ Xuyên",
        "street": "Trần Khánh Dư",
        "street_code": "TKD",
        "street_2": "Hà Hoàng Hổ - Trần Bình Trọng",
        "street_type": 2,
        "price": 11
      },
      {
        "code": "MX6",
        "ward_code": "MX",
        "ward": "Mỹ Xuyên",
        "street": "Bùi Thị Xuân",
        "street_code": "BTX",
        "street_2": "Suốt đường",
        "street_type": 2,
        "price": 13
      },
      {
        "code": "MX7",
        "ward_code": "MX",
        "ward": "Mỹ Xuyên",
        "street": "Võ Thị Sáu",
        "street_code": "VTS",
        "street_2": "Hà Hoàng Hổ - Ngã 3 Võ Thị Sáu",
        "street_type": 2,
        "price": 11
      },
      {
        "code": "MX8",
        "ward_code": "MX",
        "ward": "Mỹ Xuyên",
        "street": "Bùi Văn Danh",
        "street_code": "BVD",
        "street_2": "Trần Hưng Đạo - Phan Tôn",
        "street_type": 2,
        "price": 9
      },
      {
        "code": "MX9",
        "ward_code": "MX",
        "ward": "Mỹ Xuyên",
        "street": "Võ Thị Sáu",
        "street_code": "VTS",
        "street_2": "Ngã 3 Võ Thị Sáu - Hết ranh Đại học An Giang",
        "street_type": 3,
        "price": 7.5
      },
      {
        "code": "MX10",
        "ward_code": "MX",
        "ward": "Mỹ Xuyên",
        "street": "Trần Khánh Dư",
        "street_code": "TKD",
        "street_2": "Trần Bình Trọng - Cuối đường",
        "street_type": 3,
        "price": 7
      },
      {
        "code": "MX11",
        "ward_code": "MX",
        "ward": "Mỹ Xuyên",
        "street": "Phan Liêm",
        "street_code": "PL",
        "street_2": "Suốt đường",
        "street_type": 3,
        "price": 6
      },
      {
        "code": "MX12",
        "ward_code": "MX",
        "ward": "Mỹ Xuyên",
        "street": "Hải Thượng Lãn OÔng",
        "street_code": "HTLO",
        "street_2": "Trần Hưng Đạo - Bệnh viện Long Xuyên",
        "street_type": 3,
        "price": 6
      },
      {
        "code": "MX13",
        "ward_code": "MX",
        "ward": "Mỹ Xuyên",
        "street": "Trần Quang Diệu",
        "street_code": "TQD",
        "street_2": "Suốt đường",
        "street_type": 3,
        "price": 7.8
      },
      {
        "code": "MX14",
        "ward_code": "MX",
        "ward": "Mỹ Xuyên",
        "street": "Hẻm Sông Hồng",
        "street_code": "HSH",
        "street_2": "Trần Hưng Đạo - Cuối hẻm",
        "street_type": 3,
        "price": 5
      },
      {
        "code": "MX15",
        "ward_code": "MX",
        "ward": "Mỹ Xuyên",
        "street": "Hẻm 12 Mỹ Xuyên",
        "street_code": "H12MX",
        "street_2": "Bệnh viện Long Xuyên - Võ Thị Sáu [đường này nối ra Trần Bình Trọng]",
        "street_type": 3,
        "price": 8
      },
      {
        "code": "MX16",
        "ward_code": "MX",
        "ward": "Mỹ Xuyên",
        "street": "Hẻm 7 Mỹ Xuyên",
        "street_code": "H7MX",
        "street_2": "Trần Hưng Đạo - Hẻm 12 [đối diện cây xăng Mỹ long đi vào]",
        "street_type": 3,
        "price": 6
      },
      {
        "code": "MX17",
        "ward_code": "MX",
        "ward": "Mỹ Xuyên",
        "street": "Hẻm 8 Mỹ Xuyên",
        "street_code": "H8MX",
        "street_2": "đường karaoke T3",
        "street_type": 3,
        "price": null
      },
      {
        "code": "MX18",
        "ward_code": "MX",
        "ward": "Mỹ Xuyên",
        "street": "Phan Tôn",
        "street_code": "PT",
        "street_2": "Lê Thiện Tứ - Bùi Văn Danh",
        "street_type": 3,
        "price": 6.5
      },
      {
        "code": "MX19",
        "ward_code": "MX",
        "ward": "Mỹ Xuyên",
        "street": "Hẻm 9 Mỹ Xuyên",
        "street_code": "H9MX",
        "street_2": "Trần Hưng Đạo - Hẻm 12 [cửa hàng Vietel đi vào]",
        "street_type": 3,
        "price": 5
      },
      {
        "code": "MX20",
        "ward_code": "MX",
        "ward": "Mỹ Xuyên",
        "street": "Hẻm 3 (khóm Đông An 5)",
        "street_code": "H3ĐA5",
        "street_2": "",
        "street_type": 3,
        "price": null
      },
      {
        "code": "MX21",
        "ward_code": "MX",
        "ward": "Mỹ Xuyên",
        "street": "Hẻm 4 (khóm Đông An 5)",
        "street_code": "H4ĐA5",
        "street_2": "Trần Hưng Đạo - Cuối hẻm",
        "street_type": 3,
        "price": 5
      },
      {
        "code": "MX22",
        "ward_code": "MX",
        "ward": "Mỹ Xuyên",
        "street": "Hẻm 5 (khóm Đông An 5)",
        "street_code": "H5ĐA5",
        "street_2": "Trần Hưng Đạo - Cuối hẻm",
        "street_type": 3,
        "price": null
      },
      {
        "code": "MX23",
        "ward_code": "MX",
        "ward": "Mỹ Xuyên",
        "street": "Hẻm 6 (khóm Đông An 5)",
        "street_code": "H6ĐA5",
        "street_2": "",
        "street_type": 3,
        "price": null
      },
      {
        "code": "MX24",
        "ward_code": "MX",
        "ward": "Mỹ Xuyên",
        "street": "Hẻm 1 (khóm Đông An 1)",
        "street_code": "H1ĐA1",
        "street_2": "Trần Hưng Đạo - Cuối hẻm",
        "street_type": 3,
        "price": 4.5
      },
      {
        "code": "MX25",
        "ward_code": "MX",
        "ward": "Mỹ Xuyên",
        "street": "Hẻm 2 (khóm Đông An 1)",
        "street_code": "H2ĐA1",
        "street_2": "",
        "street_type": 3,
        "price": null
      },
      {
        "code": "MX26",
        "ward_code": "MX",
        "ward": "Mỹ Xuyên",
        "street": "Hẻm 3 (khóm Đông An 1)",
        "street_code": "H3ĐA1",
        "street_2": "",
        "street_type": 3,
        "price": null
      },
      {
        "code": "MX27",
        "ward_code": "MX",
        "ward": "Mỹ Xuyên",
        "street": "Hẻm 4 (khóm Đông An 1)",
        "street_code": "H4ĐA1",
        "street_2": "",
        "street_type": 3,
        "price": null
      },
      {
        "code": "MX28",
        "ward_code": "MX",
        "ward": "Mỹ Xuyên",
        "street": "Hẻm 5 (khóm Đông An 1)",
        "street_code": "H5ĐA1",
        "street_2": "",
        "street_type": 3,
        "price": null
      },
      {
        "code": "MX29A",
        "ward_code": "MX",
        "ward": "Mỹ Xuyên",
        "street": "Võ Thị Sáu",
        "street_code": "VTS",
        "street_2": "Ngã 3 Võ Thị Sáu - Khu B Trường Đại Học AG",
        "street_type": 3,
        "price": 5
      },
      {
        "code": "MX30",
        "ward_code": "MX",
        "ward": "Mỹ Xuyên",
        "street": "Hẻm 2 Mỹ Xuyên",
        "street_code": "H2MX",
        "street_2": "[hẻm kế đường Hải Thượng Lãn Ông] Trần Hưng Đạo - Cuối hẻm",
        "street_type": 4,
        "price": 2
      },
      {
        "code": "MX31",
        "ward_code": "MX",
        "ward": "Mỹ Xuyên",
        "street": "Hẻm Bệnh Viện Bình Dân",
        "street_code": "HBVBD",
        "street_2": "[ngay chân cầu Cái sơn] Cặp Bệnh viện Bình Dân - Bảo Việt (Khóm Đông An 5)",
        "street_type": 4,
        "price": 2
      },
      {
        "code": "MX32",
        "ward_code": "MX",
        "ward": "Mỹ Xuyên",
        "street": "Hẻm 1 Rạch Cái Sơn",
        "street_code": "H1RCS",
        "street_2": "[đường cặp BV Bình dân] Trần Hưng Đạo - Cuối hẻm",
        "street_type": 4,
        "price": 2
      },
      {
        "code": "MX33",
        "ward_code": "MX",
        "ward": "Mỹ Xuyên",
        "street": "Hẻm Cặp TT Y Tế phường Mỹ Xuyên",
        "street_code": "HCTTYTMX",
        "street_2": "Trần Quang Diệu - Cuối hẻm",
        "street_type": 4,
        "price": 3
      },
      {
        "code": "MX34",
        "ward_code": "MX",
        "ward": "Mỹ Xuyên",
        "street": "Hẻm đối diện UBND phường Mỹ Xuyên",
        "street_code": "HUBNDMX",
        "street_2": "Hà Hoàng Hổ - Trần Quang Diệu",
        "street_type": 4,
        "price": 3
      },
      {
        "code": "ĐX1A",
        "ward_code": "ĐX",
        "ward": "Đông Xuyên",
        "street": "Hà Hoàng Hổ",
        "street_code": "HHH",
        "street_2": "Phan Tôn - Cầu Bà Bầu - Cầu Ông Mạnh",
        "street_type": 1,
        "price": 26
      },
      {
        "code": "ĐX2",
        "ward_code": "ĐX",
        "ward": "Đông Xuyên",
        "street": "Trần Nguyên Đán",
        "street_code": "TNĐ",
        "street_2": "Hà Hoàng Hổ - Cuối khu dân cư (đường chính của khu dân cư Bà Bầu)",
        "street_type": 2,
        "price": 9
      },
      {
        "code": "ĐX3",
        "ward_code": "ĐX",
        "ward": "Đông Xuyên",
        "street": "Bùi Văn Danh",
        "street_code": "BVD",
        "street_2": "Phan Tôn - Cầu ông Mạnh",
        "street_type": 2,
        "price": 9
      },
      {
        "code": "ĐX4",
        "ward_code": "ĐX",
        "ward": "Đông Xuyên",
        "street": "Võ Thị Sáu",
        "street_code": "VTS",
        "street_2": "Ngã 3 Võ Thị Sáu - Khu B Trường Đại học An Giang",
        "street_type": 3,
        "price": 5
      },
      {
        "code": "ĐX5",
        "ward_code": "ĐX",
        "ward": "Đông Xuyên",
        "street": "Phan Tôn",
        "street_code": "PT",
        "street_2": "Bùi Văn Danh - Lê Thiện Tứ",
        "street_type": 3,
        "price": 5
      },
      {
        "code": "ĐX6",
        "ward_code": "ĐX",
        "ward": "Đông Xuyên",
        "street": "Ung Văn Khiêm",
        "street_code": "UVK",
        "street_2": "Hà Hoàng Hổ - hết ranh địa giới hành chính",
        "street_type": 3,
        "price": 12
      },
      {
        "code": "ĐX7",
        "ward_code": "ĐX",
        "ward": "Đông Xuyên",
        "street": "Trần Quốc Tảng",
        "street_code": "TQT",
        "street_2": "Suốt đường",
        "street_type": 3,
        "price": 5
      },
      {
        "code": "ĐX8",
        "ward_code": "ĐX",
        "ward": "Đông Xuyên",
        "street": "Nguyễn Biểu",
        "street_code": "NB",
        "street_2": "Suốt đường",
        "street_type": 3,
        "price": 5
      },
      {
        "code": "ĐX9",
        "ward_code": "ĐX",
        "ward": "Đông Xuyên",
        "street": "Trần Khắc Chân",
        "street_code": "TKC",
        "street_2": "Nguyễn Biểu – Khu dân cư",
        "street_type": 3,
        "price": 5
      },
      {
        "code": "ĐX10",
        "ward_code": "ĐX",
        "ward": "Đông Xuyên",
        "street": "Trương Hán Siêu",
        "street_code": "THS",
        "street_2": "Suốt đường",
        "street_type": 3,
        "price": 4
      },
      {
        "code": "ĐX11",
        "ward_code": "ĐX",
        "ward": "Đông Xuyên",
        "street": "Nguyễn Hiền",
        "street_code": "NH",
        "street_2": "Suốt đường",
        "street_type": 3,
        "price": 4
      },
      {
        "code": "ĐX12",
        "ward_code": "ĐX",
        "ward": "Đông Xuyên",
        "street": "Trần Khắc Chung",
        "street_code": "TKC",
        "street_2": "Suốt đường",
        "street_type": 3,
        "price": 4
      },
      {
        "code": "ĐX13",
        "ward_code": "ĐX",
        "ward": "Đông Xuyên",
        "street": "Lê Quát",
        "street_code": "LQ",
        "street_2": "Suốt đường",
        "street_type": 3,
        "price": 4
      },
      {
        "code": "ĐX14",
        "ward_code": "ĐX",
        "ward": "Đông Xuyên",
        "street": "Đoàn Nhữ Hài",
        "street_code": "ĐNH",
        "street_2": "Suốt đường",
        "street_type": 3,
        "price": 4
      },
      {
        "code": "ĐX15",
        "ward_code": "ĐX",
        "ward": "Đông Xuyên",
        "street": "Trương Hống",
        "street_code": "TH",
        "street_2": "Suốt đường",
        "street_type": 3,
        "price": 4
      },
      {
        "code": "ĐX16",
        "ward_code": "ĐX",
        "ward": "Đông Xuyên",
        "street": "Trịnh Văn AẤn",
        "street_code": "TVA",
        "street_2": "Suốt đường",
        "street_type": 3,
        "price": 5
      },
      {
        "code": "ĐX17",
        "ward_code": "ĐX",
        "ward": "Đông Xuyên",
        "street": "Trần Văn Thạnh",
        "street_code": "TVT",
        "street_2": "Suốt đường",
        "street_type": 3,
        "price": 5
      },
      {
        "code": "ĐX18",
        "ward_code": "ĐX",
        "ward": "Đông Xuyên",
        "street": "Trần Văn Lẫm",
        "street_code": "TVL",
        "street_2": "Suốt đường",
        "street_type": 3,
        "price": 5
      },
      {
        "code": "ĐX19",
        "ward_code": "ĐX",
        "ward": "Đông Xuyên",
        "street": "Đinh Trường Sanh",
        "street_code": "ĐTS",
        "street_2": "Suốt đường",
        "street_type": 3,
        "price": 5
      },
      {
        "code": "ĐX20",
        "ward_code": "ĐX",
        "ward": "Đông Xuyên",
        "street": "Lê Thiện Tứ",
        "street_code": "LTT",
        "street_2": "Suốt đường Lê Thiện Tứ",
        "street_type": 3,
        "price": 5
      },
      {
        "code": "ĐX21",
        "ward_code": "ĐX",
        "ward": "Đông Xuyên",
        "street": "Nguyễn Ngọc Ba",
        "street_code": "NNB",
        "street_2": "Suốt đường",
        "street_type": 3,
        "price": 5
      },
      {
        "code": "ĐX22",
        "ward_code": "ĐX",
        "ward": "Đông Xuyên",
        "street": "Trịnh Đình Thước",
        "street_code": "TĐT",
        "street_2": "Suốt đường",
        "street_type": 3,
        "price": 5
      },
      {
        "code": "ĐX23",
        "ward_code": "ĐX",
        "ward": "Đông Xuyên",
        "street": "Lý Thái Tổ Nối Dài",
        "street_code": "LTTND",
        "street_2": "Ung Văn Khiêm - Đường nhựa hiện hữu [đoạn Bệnh viện MẮT]",
        "street_type": 3,
        "price": 5
      },
      {
        "code": "ĐX24",
        "ward_code": "ĐX",
        "ward": "Đông Xuyên",
        "street": "Đường Số 3 Đông Xuyên",
        "street_code": "ĐS3ĐX",
        "street_2": "Đinh Trường Sanh - Trần Văn Lẫm cuối ranh quy hoạch dân cư",
        "street_type": 3,
        "price": 5
      },
      {
        "code": "ĐX25",
        "ward_code": "ĐX",
        "ward": "Đông Xuyên",
        "street": "các Đường còn lại trong Kdc Bà Bầu",
        "street_code": "ĐKBB",
        "street_2": "(Kể cả KDC Bà bầu mở rộng)",
        "street_type": 3,
        "price": 4
      },
      {
        "code": "ĐX26",
        "ward_code": "ĐX",
        "ward": "Đông Xuyên",
        "street": "Đường Số 1 kdc Nam Kinh",
        "street_code": "ĐS1NK",
        "street_2": "Đường số 1",
        "street_type": 3,
        "price": 9
      },
      {
        "code": "ĐX27",
        "ward_code": "ĐX",
        "ward": "Đông Xuyên",
        "street": "Đường Số 2 kdc Nam Kinh",
        "street_code": "ĐS2NK",
        "street_2": "Đường số 2",
        "street_type": 3,
        "price": 9
      },
      {
        "code": "ĐX28",
        "ward_code": "ĐX",
        "ward": "Đông Xuyên",
        "street": "Đường Cặp Rạch Bà Bầu",
        "street_code": "ĐCRBB",
        "street_2": "",
        "street_type": 4,
        "price": 1.6
      },
      {
        "code": "ĐX29",
        "ward_code": "ĐX",
        "ward": "Đông Xuyên",
        "street": "Đường Cặp Rạch OÔng Mạnh",
        "street_code": "ĐCROM",
        "street_2": "",
        "street_type": 4,
        "price": 1.6
      },
      {
        "code": "ĐX30",
        "ward_code": "ĐX",
        "ward": "Đông Xuyên",
        "street": "Hẻm Kênh 3 Đông Xuyên",
        "street_code": "HK3ĐX",
        "street_2": "Suốt hẻm",
        "street_type": 4,
        "price": 1.5
      },
      {
        "code": "ĐX31",
        "ward_code": "ĐX",
        "ward": "Đông Xuyên",
        "street": "Trần Quý Khoáng",
        "street_code": "TQK",
        "street_2": "Hà Hoàng Hổ - Cuối đường",
        "street_type": 4,
        "price": 2.4
      },
      {
        "code": "ĐX32A",
        "ward_code": "ĐX",
        "ward": "Đông Xuyên",
        "street": "Trần Khắc Chân",
        "street_code": "TKC",
        "street_2": "Hà Hoàng Hổ - cổng trường Hùng Vương",
        "street_type": 4,
        "price": 4.5
      },
      {
        "code": "ĐX33",
        "ward_code": "ĐX",
        "ward": "Đông Xuyên",
        "street": "Đường Nhánh Võ Thị Sáu",
        "street_code": "ĐNVTS",
        "street_2": "Các đường nhánh và hẻm của Võ Thị Sáu",
        "street_type": 4,
        "price": 3.5
      },
      {
        "code": "ĐX35",
        "ward_code": "ĐX",
        "ward": "Đông Xuyên",
        "street": "Đường tổ 8  khóm Đông Thành",
        "street_code": "Đ8ĐT",
        "street_2": "Lý Thái Tổ nối dài - Khu cán bộ",
        "street_type": 4,
        "price": 3
      },
      {
        "code": "ĐX36",
        "ward_code": "ĐX",
        "ward": "Đông Xuyên",
        "street": "Nguyễn Hữu Tiến",
        "street_code": "NHT",
        "street_2": "Suốt đường",
        "street_type": 4,
        "price": 3
      },
      {
        "code": "ĐX37",
        "ward_code": "ĐX",
        "ward": "Đông Xuyên",
        "street": "Trần Cảnh",
        "street_code": "TC",
        "street_2": "Suốt đường",
        "street_type": 4,
        "price": 3
      },
      {
        "code": "ĐX38",
        "ward_code": "ĐX",
        "ward": "Đông Xuyên",
        "street": "Nguyễn Chánh Nhì",
        "street_code": "NCN",
        "street_2": "Suốt đường",
        "street_type": 4,
        "price": 3
      },
      {
        "code": "ĐX39",
        "ward_code": "ĐX",
        "ward": "Đông Xuyên",
        "street": "Trần Thủ Độ",
        "street_code": "TTĐ",
        "street_2": "Suốt đường",
        "street_type": 4,
        "price": 3
      },
      {
        "code": "ĐX40",
        "ward_code": "ĐX",
        "ward": "Đông Xuyên",
        "street": "Ngô Văn Sở",
        "street_code": "NVS",
        "street_2": "Suốt đường",
        "street_type": 4,
        "price": 3.5
      },
      {
        "code": "ĐX41A",
        "ward_code": "ĐX",
        "ward": "Đông Xuyên",
        "street": "Trần Bình Trọng",
        "street_code": "TBT",
        "street_2": "Phan Tôn - Ung Văn Khiêm",
        "street_type": 4,
        "price": 2
      },
      {
        "code": "ĐX42",
        "ward_code": "ĐX",
        "ward": "Đông Xuyên",
        "street": "Đường Cặp Rạch Cái Sơn",
        "street_code": "ĐCRCS",
        "street_2": "Ung Văn Khiêm - Ranh Mỹ Phước, Mỹ Xuyên",
        "street_type": 4,
        "price": 1.5
      },
      {
        "code": "ĐX43",
        "ward_code": "ĐX",
        "ward": "Đông Xuyên",
        "street": "Đường Kdc Phú Quý",
        "street_code": "ĐKPQ",
        "street_2": "Các đường trong KDC Phú Quý",
        "street_type": null,
        "price": null
      },
      {
        "code": "BK1A",
        "ward_code": "BK",
        "ward": "Bình Khánh",
        "street": "Trần Hưng Đạo",
        "street_code": "THĐ",
        "street_2": "Cầu Nguyễn Trung Trực – mương Cơ khí - Cầu Trà Ôn",
        "street_type": 2,
        "price": 11
      },
      {
        "code": "BK2",
        "ward_code": "BK",
        "ward": "Bình Khánh",
        "street": "Quản Cơ Thành",
        "street_code": "QCT",
        "street_2": "Suốt đường",
        "street_type": 3,
        "price": 7.2
      },
      {
        "code": "BK3",
        "ward_code": "BK",
        "ward": "Bình Khánh",
        "street": "Tôn Thất Thuyết",
        "street_code": "TTT",
        "street_2": "Suốt đường",
        "street_type": 3,
        "price": 5.4
      },
      {
        "code": "BK4",
        "ward_code": "BK",
        "ward": "Bình Khánh",
        "street": "Hàm Nghi",
        "street_code": "HN",
        "street_2": "Suốt đường",
        "street_type": 3,
        "price": 7.2
      },
      {
        "code": "BK5A",
        "ward_code": "BK",
        "ward": "Bình Khánh",
        "street": "Nguyễn Trường Tộ",
        "street_code": "NTT",
        "street_2": "Trần Hưng Đạo - Đề Thám",
        "street_type": 3,
        "price": 5.4
      },
      {
        "code": "BK6",
        "ward_code": "BK",
        "ward": "Bình Khánh",
        "street": "Thành Thái",
        "street_code": "TT",
        "street_2": "Cầu Tôn Đức Thắng - Thiên Hộ Dương",
        "street_type": 3,
        "price": 4.8
      },
      {
        "code": "BK7",
        "ward_code": "BK",
        "ward": "Bình Khánh",
        "street": "Đề Thám",
        "street_code": "ĐT",
        "street_2": "Thiên Hộ Dương - Cuối đường",
        "street_type": 3,
        "price": 4.8
      },
      {
        "code": "BK8",
        "ward_code": "BK",
        "ward": "Bình Khánh",
        "street": "Nguyễn Khuyến",
        "street_code": "NK",
        "street_2": "Suốt đường",
        "street_type": 4,
        "price": 2.5
      },
      {
        "code": "BK9",
        "ward_code": "BK",
        "ward": "Bình Khánh",
        "street": "Tú Xương",
        "street_code": "TX",
        "street_2": "Suốt đường",
        "street_type": 4,
        "price": 2.5
      },
      {
        "code": "BK10",
        "ward_code": "BK",
        "ward": "Bình Khánh",
        "street": "Trần Cao Vân",
        "street_code": "TCV",
        "street_2": "Suốt đường",
        "street_type": 4,
        "price": 2.5
      },
      {
        "code": "BK11",
        "ward_code": "BK",
        "ward": "Bình Khánh",
        "street": "Đường Kdc Cán Bộ Bình Khánh",
        "street_code": "ĐKCBBK",
        "street_2": "Đường Số 1, 2 Kdc Cán Bộ Bình Khánh",
        "street_type": 4,
        "price": 2.1
      },
      {
        "code": "BK12",
        "ward_code": "BK",
        "ward": "Bình Khánh",
        "street": "Ngô Lợi",
        "street_code": "NL",
        "street_2": "Suốt đường",
        "street_type": 4,
        "price": 3.6
      },
      {
        "code": "BK13",
        "ward_code": "BK",
        "ward": "Bình Khánh",
        "street": "Trương Định",
        "street_code": "TĐ",
        "street_2": "Suốt đường",
        "street_type": 4,
        "price": 3
      },
      {
        "code": "BK14",
        "ward_code": "BK",
        "ward": "Bình Khánh",
        "street": "Huỳnh Thúc Kháng",
        "street_code": "HTK",
        "street_2": "Suốt đường",
        "street_type": 4,
        "price": 3
      },
      {
        "code": "BK15",
        "ward_code": "BK",
        "ward": "Bình Khánh",
        "street": "Đinh Công Tráng",
        "street_code": "ĐCT",
        "street_2": "Suốt đường",
        "street_type": 4,
        "price": 3
      },
      {
        "code": "BK16",
        "ward_code": "BK",
        "ward": "Bình Khánh",
        "street": "Cao Thắng",
        "street_code": "CT",
        "street_2": "Suốt đường",
        "street_type": 4,
        "price": 3
      },
      {
        "code": "BK17A",
        "ward_code": "BK",
        "ward": "Bình Khánh",
        "street": "Phan Bội Châu",
        "street_code": "PBC",
        "street_2": "Trần Hưng Đạo - Bến phà Mỹ Hòa Hưng",
        "street_type": 4,
        "price": 3.6
      },
      {
        "code": "BK18",
        "ward_code": "BK",
        "ward": "Bình Khánh",
        "street": "Nguyễn Thanh Sơn",
        "street_code": "NTS",
        "street_2": "Suốt đường",
        "street_type": 4,
        "price": 3.6
      },
      {
        "code": "BK19A",
        "ward_code": "BK",
        "ward": "Bình Khánh",
        "street": "Võ Văn Hoài",
        "street_code": "VVH",
        "street_2": "Cầu Nguyễn Trung Trực - Cầu Tôn Đức Thắng - cầu Thông Lưu",
        "street_type": 4,
        "price": 3
      },
      {
        "code": "BK20",
        "ward_code": "BK",
        "ward": "Bình Khánh",
        "street": "Thiên Hộ Dương",
        "street_code": "THD",
        "street_2": "Suốt đường",
        "street_type": 4,
        "price": 2.5
      },
      {
        "code": "BK21",
        "ward_code": "BK",
        "ward": "Bình Khánh",
        "street": "Phan Văn Trị",
        "street_code": "PVT",
        "street_2": "Nguyễn Khắc Nhu - Thiên Hộ Dương",
        "street_type": 4,
        "price": 3
      },
      {
        "code": "BK22",
        "ward_code": "BK",
        "ward": "Bình Khánh",
        "street": "Lương Văn Can",
        "street_code": "LVC",
        "street_2": "Suốt đường",
        "street_type": 4,
        "price": 3
      },
      {
        "code": "BK23",
        "ward_code": "BK",
        "ward": "Bình Khánh",
        "street": "Phó Đức Chính",
        "street_code": "PĐC",
        "street_2": "Suốt đường",
        "street_type": 4,
        "price": 3
      },
      {
        "code": "BK24",
        "ward_code": "BK",
        "ward": "Bình Khánh",
        "street": "Nguyễn Khắc Nhu",
        "street_code": "NKN",
        "street_2": "Suốt đường",
        "street_type": 4,
        "price": 3.6
      },
      {
        "code": "BK25",
        "ward_code": "BK",
        "ward": "Bình Khánh",
        "street": "Tống Duy Tân",
        "street_code": "TDT",
        "street_2": "Suốt đường",
        "street_type": 4,
        "price": 3
      },
      {
        "code": "BK26",
        "ward_code": "BK",
        "ward": "Bình Khánh",
        "street": "Nguyễn Tri Phương",
        "street_code": "NTP",
        "street_2": "Suốt đường",
        "street_type": 4,
        "price": 3
      },
      {
        "code": "BK27",
        "ward_code": "BK",
        "ward": "Bình Khánh",
        "street": "Nguyễn Thượng Hiền",
        "street_code": "NTH",
        "street_2": "Suốt đường",
        "street_type": 4,
        "price": 3
      },
      {
        "code": "BK28",
        "ward_code": "BK",
        "ward": "Bình Khánh",
        "street": "Thái Phiên",
        "street_code": "TP",
        "street_2": "Suốt đường",
        "street_type": 4,
        "price": 3
      },
      {
        "code": "BK29",
        "ward_code": "BK",
        "ward": "Bình Khánh",
        "street": "Đốc Binh Kiều",
        "street_code": "ĐBK",
        "street_2": "Suốt đường",
        "street_type": 4,
        "price": 3
      },
      {
        "code": "BK30",
        "ward_code": "BK",
        "ward": "Bình Khánh",
        "street": "Nguyễn An Ninh",
        "street_code": "NAN",
        "street_2": "Suốt đường",
        "street_type": 4,
        "price": 3
      },
      {
        "code": "BK31",
        "ward_code": "BK",
        "ward": "Bình Khánh",
        "street": "Đội Cấn",
        "street_code": "ĐC",
        "street_2": "Suốt đường",
        "street_type": 4,
        "price": 3
      },
      {
        "code": "BK32",
        "ward_code": "BK",
        "ward": "Bình Khánh",
        "street": "Phạm Thế Hiển",
        "street_code": "PTH",
        "street_2": "Suốt đường",
        "street_type": 4,
        "price": 2.5
      },
      {
        "code": "BK33",
        "ward_code": "BK",
        "ward": "Bình Khánh",
        "street": "Võ Trường Toản",
        "street_code": "VTT",
        "street_2": "Suốt đường",
        "street_type": 4,
        "price": 3.2
      },
      {
        "code": "BK34",
        "ward_code": "BK",
        "ward": "Bình Khánh",
        "street": "Nguyễn Thiện Thuật",
        "street_code": "NTT",
        "street_2": "Suốt đường",
        "street_type": 4,
        "price": 3
      },
      {
        "code": "BK35",
        "ward_code": "BK",
        "ward": "Bình Khánh",
        "street": "Nguyễn Văn Trỗi",
        "street_code": "NVT",
        "street_2": "Suốt đường",
        "street_type": 4,
        "price": 2.1
      },
      {
        "code": "BK36",
        "ward_code": "BK",
        "ward": "Bình Khánh",
        "street": "Nguyễn Thái Bình",
        "street_code": "NTB",
        "street_2": "Suốt đường",
        "street_type": 4,
        "price": 2.5
      },
      {
        "code": "BK37",
        "ward_code": "BK",
        "ward": "Bình Khánh",
        "street": "Lê Thị Hồng Gấm",
        "street_code": "LTHG",
        "street_2": "Suốt đường",
        "street_type": 4,
        "price": 2.5
      },
      {
        "code": "BK38",
        "ward_code": "BK",
        "ward": "Bình Khánh",
        "street": "Quách Thị Trang",
        "street_code": "QTT",
        "street_2": "Suốt đường",
        "street_type": 4,
        "price": 2.5
      },
      {
        "code": "BK39",
        "ward_code": "BK",
        "ward": "Bình Khánh",
        "street": "Nguyễn Địa Lô",
        "street_code": "NĐL",
        "street_2": "Suốt đường",
        "street_type": 4,
        "price": 2.5
      },
      {
        "code": "BK40",
        "ward_code": "BK",
        "ward": "Bình Khánh",
        "street": "Lê Ngã",
        "street_code": "LN",
        "street_2": "Suốt đường",
        "street_type": 4,
        "price": 2.5
      },
      {
        "code": "BK41",
        "ward_code": "BK",
        "ward": "Bình Khánh",
        "street": "Dã Tượng",
        "street_code": "DT",
        "street_2": "Suốt đường",
        "street_type": 4,
        "price": 2.1
      },
      {
        "code": "BK42",
        "ward_code": "BK",
        "ward": "Bình Khánh",
        "street": "Nguyễn Chích",
        "street_code": "NC",
        "street_2": "Suốt đường",
        "street_type": 4,
        "price": 2.5
      },
      {
        "code": "BK43",
        "ward_code": "BK",
        "ward": "Bình Khánh",
        "street": "Thục Phán",
        "street_code": "TP",
        "street_2": "Đường số 7 (Đường Thục Phán nối dài) Bình Khánh 5",
        "street_type": 4,
        "price": 5
      },
      {
        "code": "BK44",
        "ward_code": "BK",
        "ward": "Bình Khánh",
        "street": "các Đường Không Tên trong kdc Bình Khánh 5",
        "street_code": "ĐKTBK5",
        "street_2": "Các đường chưa đặt tên trong và ngoài KDC Bình Khánh 5",
        "street_type": 4,
        "price": 4
      },
      {
        "code": "BK45",
        "ward_code": "BK",
        "ward": "Bình Khánh",
        "street": "Bùi Viện",
        "street_code": "BV",
        "street_2": "Đường trong Khu dân cư Bình Khánh 5",
        "street_type": 4,
        "price": 2.5
      },
      {
        "code": "BK46",
        "ward_code": "BK",
        "ward": "Bình Khánh",
        "street": "Lý Văn Phức",
        "street_code": "LVP",
        "street_2": "Đường trong Khu dân cư Bình Khánh 5",
        "street_type": 4,
        "price": 2.5
      },
      {
        "code": "BK47",
        "ward_code": "BK",
        "ward": "Bình Khánh",
        "street": "Nguyễn Lữ",
        "street_code": "NL",
        "street_2": "Đường trong Khu dân cư Bình Khánh 5",
        "street_type": 4,
        "price": 2.5
      },
      {
        "code": "BK48",
        "ward_code": "BK",
        "ward": "Bình Khánh",
        "street": "Trịnh Hoài Đức",
        "street_code": "THĐ",
        "street_2": "Đường trong Khu dân cư Bình Khánh 5",
        "street_type": 4,
        "price": 2.5
      },
      {
        "code": "BK49",
        "ward_code": "BK",
        "ward": "Bình Khánh",
        "street": "Lê Quang Định",
        "street_code": "LQĐ",
        "street_2": "Đường trong Khu dân cư Bình Khánh 5",
        "street_type": 4,
        "price": 2.5
      },
      {
        "code": "BK50",
        "ward_code": "BK",
        "ward": "Bình Khánh",
        "street": "Nguyễn Nhạc",
        "street_code": "NN",
        "street_2": "Đường trong Khu dân cư Bình Khánh 5",
        "street_type": 4,
        "price": 2.5
      },
      {
        "code": "BK51",
        "ward_code": "BK",
        "ward": "Bình Khánh",
        "street": "Phan Kế Bính",
        "street_code": "PKB",
        "street_2": "Đường trong Khu dân cư Bình Khánh 5",
        "street_type": 4,
        "price": 2.5
      },
      {
        "code": "BK52",
        "ward_code": "BK",
        "ward": "Bình Khánh",
        "street": "Hồ Biểu Chánh",
        "street_code": "HBC",
        "street_2": "Đường trong Khu dân cư Bình Khánh 5",
        "street_type": 4,
        "price": 2.5
      },
      {
        "code": "BK53",
        "ward_code": "BK",
        "ward": "Bình Khánh",
        "street": "Cường Để",
        "street_code": "CĐ",
        "street_2": "Đường trong Khu dân cư Bình Khánh 5",
        "street_type": 4,
        "price": 2.5
      },
      {
        "code": "BK54A",
        "ward_code": "BK",
        "ward": "Bình Khánh",
        "street": "Đường Trà OÔn",
        "street_code": "ĐTO",
        "street_2": "Cầu Trà Ôn - Trạm Y tế - Chợ Tầm Vu",
        "street_type": 4,
        "price": 2.5
      },
      {
        "code": "BK55A",
        "ward_code": "BK",
        "ward": "Bình Khánh",
        "street": "Đường Dự Định - Bình Khánh",
        "street_code": "ĐDĐBK",
        "street_2": "Tôn Thất Thuyết - Trương Định (sau Thánh thất Cao Đài)",
        "street_type": 4,
        "price": 2.1
      },
      {
        "code": "BK56",
        "ward_code": "BK",
        "ward": "Bình Khánh",
        "street": "Đường Thông Lưu - Tổng Hợi",
        "street_code": "ĐTLTH",
        "street_2": "Bờ hướng đông khu vực đô thị",
        "street_type": 4,
        "price": 1.5
      },
      {
        "code": "BK57",
        "ward_code": "BK",
        "ward": "Bình Khánh",
        "street": "Lạc Long Quân",
        "street_code": "LLQ",
        "street_2": "ĐƯỜNG KDC SAO MAI BÌNH KHÁNH 3",
        "street_type": 4,
        "price": 3.5
      },
      {
        "code": "BK58",
        "ward_code": "BK",
        "ward": "Bình Khánh",
        "street": "Lý Bôn",
        "street_code": "LB",
        "street_2": "ĐƯỜNG KDC SAO MAI BÌNH KHÁNH 3",
        "street_type": 4,
        "price": 3.5
      },
      {
        "code": "BK59",
        "ward_code": "BK",
        "ward": "Bình Khánh",
        "street": "Triệu Thị Trinh",
        "street_code": "TTT",
        "street_2": "ĐƯỜNG KDC SAO MAI BÌNH KHÁNH 3",
        "street_type": 4,
        "price": 3.5
      },
      {
        "code": "BK60",
        "ward_code": "BK",
        "ward": "Bình Khánh",
        "street": "Mai Hắc Đế",
        "street_code": "MHĐ",
        "street_2": "ĐƯỜNG KDC SAO MAI BÌNH KHÁNH 3",
        "street_type": 4,
        "price": 3.5
      },
      {
        "code": "BK61",
        "ward_code": "BK",
        "ward": "Bình Khánh",
        "street": "Thục Phán",
        "street_code": "TP",
        "street_2": "ĐƯỜNG KDC SAO MAI BÌNH KHÁNH 3",
        "street_type": 4,
        "price": 3.5
      },
      {
        "code": "BK62",
        "ward_code": "BK",
        "ward": "Bình Khánh",
        "street": "Sư Vạn Hạnh",
        "street_code": "SVH",
        "street_2": "ĐƯỜNG KDC SAO MAI BÌNH KHÁNH 3",
        "street_type": 4,
        "price": 3.5
      },
      {
        "code": "BK63",
        "ward_code": "BK",
        "ward": "Bình Khánh",
        "street": "Lê Hoàn",
        "street_code": "LH",
        "street_2": "ĐƯỜNG KDC SAO MAI BÌNH KHÁNH 3",
        "street_type": 4,
        "price": 3.5
      },
      {
        "code": "BK64",
        "ward_code": "BK",
        "ward": "Bình Khánh",
        "street": "Lý Đạo Thành",
        "street_code": "LĐT",
        "street_2": "ĐƯỜNG KDC SAO MAI BÌNH KHÁNH 3",
        "street_type": 4,
        "price": 3.5
      },
      {
        "code": "BK65",
        "ward_code": "BK",
        "ward": "Bình Khánh",
        "street": "Lê Phụng Hiểu",
        "street_code": "LPH",
        "street_2": "ĐƯỜNG KDC SAO MAI BÌNH KHÁNH 3",
        "street_type": 4,
        "price": 3.5
      },
      {
        "code": "BK66",
        "ward_code": "BK",
        "ward": "Bình Khánh",
        "street": "Đinh Công Trứ",
        "street_code": "ĐCT",
        "street_2": "ĐƯỜNG KDC SAO MAI BÌNH KHÁNH 3",
        "street_type": 4,
        "price": 3.5
      },
      {
        "code": "BK67",
        "ward_code": "BK",
        "ward": "Bình Khánh",
        "street": "Lý Phật Mã",
        "street_code": "LPM",
        "street_2": "ĐƯỜNG KDC SAO MAI BÌNH KHÁNH 3",
        "street_type": 4,
        "price": 3.5
      },
      {
        "code": "BK68",
        "ward_code": "BK",
        "ward": "Bình Khánh",
        "street": "Lý Công Uẩn",
        "street_code": "LCU",
        "street_2": "ĐƯỜNG KDC SAO MAI BÌNH KHÁNH 3",
        "street_type": 4,
        "price": 3.5
      },
      {
        "code": "BK69",
        "ward_code": "BK",
        "ward": "Bình Khánh",
        "street": "AÂu Cơ",
        "street_code": "AC",
        "street_2": "ĐƯỜNG KDC SAO MAI BÌNH KHÁNH 3",
        "street_type": 4,
        "price": 3.5
      },
      {
        "code": "BK70",
        "ward_code": "BK",
        "ward": "Bình Khánh",
        "street": "YỶ Lan",
        "street_code": "YL",
        "street_2": "ĐƯỜNG KDC SAO MAI BÌNH KHÁNH 3",
        "street_type": 4,
        "price": 3.5
      },
      {
        "code": "BK71",
        "ward_code": "BK",
        "ward": "Bình Khánh",
        "street": "Nguyễn Cảnh Dị",
        "street_code": "NCD",
        "street_2": "ĐƯỜNG KDC SAO MAI BÌNH KHÁNH 3",
        "street_type": 4,
        "price": 2.1
      },
      {
        "code": "BK72",
        "ward_code": "BK",
        "ward": "Bình Khánh",
        "street": "Hẻm tổ 21, 23 Bình Khánh",
        "street_code": "H2123BK",
        "street_2": "Khóm Bình Thới 3",
        "street_type": 4,
        "price": 2
      },
      {
        "code": "BK73",
        "ward_code": "BK",
        "ward": "Bình Khánh",
        "street": "Đường Cặp Sở Tài Nguyên và Môi Trường",
        "street_code": "ĐCSTNMT",
        "street_2": "",
        "street_type": 4,
        "price": 4.3
      },
      {
        "code": "BK74",
        "ward_code": "BK",
        "ward": "Bình Khánh",
        "street": "Hẻm Cặp Trung Tâm Quan Trắc",
        "street_code": "HCTTQT",
        "street_2": "Hẻm Cặp Trung Tâm Quan Trắc và kỹ thuật tài nguyên môi trường",
        "street_type": 4,
        "price": 2
      },
      {
        "code": "BK75",
        "ward_code": "BK",
        "ward": "Bình Khánh",
        "street": "Mai Xuân Thưởng",
        "street_code": "MXT",
        "street_2": "",
        "street_type": 4,
        "price": 1.5
      },
      {
        "code": "BK76",
        "ward_code": "BK",
        "ward": "Bình Khánh",
        "street": "các Đường Nhánh Mai Xuân Thưởng",
        "street_code": "ĐNMXT",
        "street_2": "",
        "street_type": 4,
        "price": 1
      },
      {
        "code": "BK77",
        "ward_code": "BK",
        "ward": "Bình Khánh",
        "street": "Khu Biệt Thự Sao Mai",
        "street_code": "KBTSM",
        "street_2": "Khu dân cư Sao Mai (Khu biệt thự còn một số chưa có tên đường)",
        "street_type": 4,
        "price": 3
      },
      {
        "code": "BK78",
        "ward_code": "BK",
        "ward": "Bình Khánh",
        "street": "Kdc Tỉnh Đội Bình Khánh",
        "street_code": "KTĐBK",
        "street_2": "Các đường trong KDC (Sau cây xăng Hòa Bình)",
        "street_type": 4,
        "price": 4
      },
      {
        "code": "BK79",
        "ward_code": "BK",
        "ward": "Bình Khánh",
        "street": "Phạm Phú Thứ",
        "street_code": "PPT",
        "street_2": "KDC TỔNG HỢI",
        "street_type": 4,
        "price": 1
      },
      {
        "code": "BK80",
        "ward_code": "BK",
        "ward": "Bình Khánh",
        "street": "Dương Khuê",
        "street_code": "DK",
        "street_2": "KDC TỔNG HỢI",
        "street_type": 4,
        "price": 1
      },
      {
        "code": "BK81",
        "ward_code": "BK",
        "ward": "Bình Khánh",
        "street": "Phạm Đình Hổ",
        "street_code": "PĐH",
        "street_2": "KDC TỔNG HỢI",
        "street_type": 4,
        "price": 1
      },
      {
        "code": "BK82",
        "ward_code": "BK",
        "ward": "Bình Khánh",
        "street": "Nguyễn Siêu",
        "street_code": "NS",
        "street_2": "KDC TỔNG HỢI",
        "street_type": 4,
        "price": 1
      },
      {
        "code": "BK83",
        "ward_code": "BK",
        "ward": "Bình Khánh",
        "street": "Phạm Đình Toái",
        "street_code": "PĐT",
        "street_2": "KDC TỔNG HỢI",
        "street_type": 4,
        "price": 1
      },
      {
        "code": "BK84",
        "ward_code": "BK",
        "ward": "Bình Khánh",
        "street": "Bà Huyện Thanh Quan",
        "street_code": "BHTQ",
        "street_2": "KDC TỔNG HỢI",
        "street_type": 4,
        "price": 1
      },
      {
        "code": "BK85",
        "ward_code": "BK",
        "ward": "Bình Khánh",
        "street": "các Đường Còn Lại trong khóm Bình Khánh 4",
        "street_code": "ĐCLBK4",
        "street_2": "Các đường chưa đặt tên trong Khóm BK4 - BK",
        "street_type": 4,
        "price": 700
      },
      {
        "code": "BK86",
        "ward_code": "BK",
        "ward": "Bình Khánh",
        "street": "Đường Thông Lưu - Tổng Hợi",
        "street_code": "ĐTLTH",
        "street_2": "Cầu rạch Dứa - Rạch Trà Ôn",
        "street_type": 4,
        "price": 1.1
      },
      {
        "code": "BK87",
        "ward_code": "BK",
        "ward": "Bình Khánh",
        "street": "Đường Nhánh số 1 Lê Hoàn",
        "street_code": "ĐN1LH",
        "street_2": "ĐƯỜNG KDC SAO MAI BÌNH KHÁNH 3",
        "street_type": 4,
        "price": 3.5
      },
      {
        "code": "BK88",
        "ward_code": "BK",
        "ward": "Bình Khánh",
        "street": "Đường Nhánh số 2 Lê Hoàn",
        "street_code": "ĐN2LH",
        "street_2": "ĐƯỜNG KDC SAO MAI BÌNH KHÁNH 3",
        "street_type": 4,
        "price": null
      },
      {
        "code": "BK89",
        "ward_code": "BK",
        "ward": "Bình Khánh",
        "street": "Đường Nhánh số 3 Lê Hoàn",
        "street_code": "ĐN3LH",
        "street_2": "ĐƯỜNG KDC SAO MAI BÌNH KHÁNH 3",
        "street_type": 4,
        "price": null
      },
      {
        "code": "BK90",
        "ward_code": "BK",
        "ward": "Bình Khánh",
        "street": "Đường Nhánh số 4 Lê Hoàn",
        "street_code": "ĐN4LH",
        "street_2": "ĐƯỜNG KDC SAO MAI BÌNH KHÁNH 3",
        "street_type": 4,
        "price": null
      },
      {
        "code": "BK91",
        "ward_code": "BK",
        "ward": "Bình Khánh",
        "street": "Đường Nhánh số 5 Lê Hoàn",
        "street_code": "ĐN5LH",
        "street_2": "ĐƯỜNG KDC SAO MAI BÌNH KHÁNH 3",
        "street_type": 4,
        "price": null
      },
      {
        "code": "BK91A",
        "ward_code": "BK",
        "ward": "Bình Khánh",
        "street": "Đường Nhánh số 6 Lê Hoàn",
        "street_code": "ĐN6LH",
        "street_2": "ĐƯỜNG KDC SAO MAI BÌNH KHÁNH 3",
        "street_type": 4,
        "price": null
      },
      {
        "code": "BK92",
        "ward_code": "BK",
        "ward": "Bình Khánh",
        "street": "Đường trên Mương tổ 29",
        "street_code": "ĐM29",
        "street_2": "Trần Hưng Đạo - Ngô Lợi",
        "street_type": 4,
        "price": 3.6
      },
      {
        "code": "BK93",
        "ward_code": "BK",
        "ward": "Bình Khánh",
        "street": "Đường Nối Quản Cơ Thành và Nguyễn Thanh Sơn",
        "street_code": "ĐNQCTNTS",
        "street_2": "(Đường vào VP Khóm Bình Thới 3)",
        "street_type": 4,
        "price": 3
      },
      {
        "code": "BK94",
        "ward_code": "BK",
        "ward": "Bình Khánh",
        "street": "Đường Số 1 BK5",
        "street_code": "ĐS1BK5",
        "street_2": "KDC BÌNH KHÁNH 5",
        "street_type": 4,
        "price": null
      },
      {
        "code": "BK95",
        "ward_code": "BK",
        "ward": "Bình Khánh",
        "street": "Đường Số 2 BK5",
        "street_code": "ĐS2BK5",
        "street_2": "KDC BÌNH KHÁNH 5",
        "street_type": 4,
        "price": null
      },
      {
        "code": "BK96",
        "ward_code": "BK",
        "ward": "Bình Khánh",
        "street": "Đường Số 3 BK5",
        "street_code": "ĐS3BK5",
        "street_2": "KDC BÌNH KHÁNH 5",
        "street_type": 4,
        "price": null
      },
      {
        "code": "BK97",
        "ward_code": "BK",
        "ward": "Bình Khánh",
        "street": "Đường Số 4 BK5",
        "street_code": "ĐS4BK5",
        "street_2": "KDC BÌNH KHÁNH 5",
        "street_type": 4,
        "price": null
      },
      {
        "code": "BK98",
        "ward_code": "BK",
        "ward": "Bình Khánh",
        "street": "Đường Số 5 BK5",
        "street_code": "ĐS5BK5",
        "street_2": "KDC BÌNH KHÁNH 5",
        "street_type": 4,
        "price": null
      },
      {
        "code": "BK99",
        "ward_code": "BK",
        "ward": "Bình Khánh",
        "street": "Đường Số 6 BK5",
        "street_code": "ĐS6BK5",
        "street_2": "KDC BÌNH KHÁNH 5",
        "street_type": 4,
        "price": null
      },
      {
        "code": "BK100",
        "ward_code": "BK",
        "ward": "Bình Khánh",
        "street": "Đường Số 8 BK5",
        "street_code": "ĐS8BK5",
        "street_2": "KDC BÌNH KHÁNH 5",
        "street_type": 4,
        "price": null
      },
      {
        "code": "BK101",
        "ward_code": "BK",
        "ward": "Bình Khánh",
        "street": "Đường Số 9 BK5",
        "street_code": "ĐS9BK5",
        "street_2": "KDC BÌNH KHÁNH 5",
        "street_type": 4,
        "price": null
      },
      {
        "code": "BK102",
        "ward_code": "BK",
        "ward": "Bình Khánh",
        "street": "Đường Số 10 BK5",
        "street_code": "ĐS10BK5",
        "street_2": "KDC BÌNH KHÁNH 5",
        "street_type": 4,
        "price": null
      },
      {
        "code": "BK103",
        "ward_code": "BK",
        "ward": "Bình Khánh",
        "street": "Đường Số 11 BK5",
        "street_code": "ĐS11BK5",
        "street_2": "KDC BÌNH KHÁNH 5",
        "street_type": 4,
        "price": null
      },
      {
        "code": "BK104",
        "ward_code": "BK",
        "ward": "Bình Khánh",
        "street": "Đường Số 12 BK5",
        "street_code": "ĐS12BK5",
        "street_2": "KDC BÌNH KHÁNH 5",
        "street_type": 4,
        "price": null
      },
      {
        "code": "BK105",
        "ward_code": "BK",
        "ward": "Bình Khánh",
        "street": "Đường Số 13 BK5",
        "street_code": "ĐS13BK5",
        "street_2": "KDC BÌNH KHÁNH 5",
        "street_type": 4,
        "price": null
      },
      {
        "code": "BK106",
        "ward_code": "BK",
        "ward": "Bình Khánh",
        "street": "Đường Số 14 BK5",
        "street_code": "ĐS14BK5",
        "street_2": "KDC BÌNH KHÁNH 5",
        "street_type": 4,
        "price": null
      },
      {
        "code": "BK107",
        "ward_code": "BK",
        "ward": "Bình Khánh",
        "street": "Đường Số 15 BK5",
        "street_code": "ĐS15BK5",
        "street_2": "KDC BÌNH KHÁNH 5",
        "street_type": 4,
        "price": null
      },
      {
        "code": "BK108",
        "ward_code": "BK",
        "ward": "Bình Khánh",
        "street": "Đường Số 16 BK5",
        "street_code": "ĐS16BK5",
        "street_2": "KDC BÌNH KHÁNH 5",
        "street_type": 4,
        "price": null
      },
      {
        "code": "BK109",
        "ward_code": "BK",
        "ward": "Bình Khánh",
        "street": "Đường Số 17 BK5",
        "street_code": "ĐS17BK5",
        "street_2": "KDC BÌNH KHÁNH 5",
        "street_type": 4,
        "price": null
      },
      {
        "code": "BK110",
        "ward_code": "BK",
        "ward": "Bình Khánh",
        "street": "Đường Số 18 BK5",
        "street_code": "ĐS18BK5",
        "street_2": "KDC BÌNH KHÁNH 5",
        "street_type": 4,
        "price": null
      },
      {
        "code": "BK111",
        "ward_code": "BK",
        "ward": "Bình Khánh",
        "street": "Đường Số 19 BK5",
        "street_code": "ĐS19BK5",
        "street_2": "KDC BÌNH KHÁNH 5",
        "street_type": 4,
        "price": null
      },
      {
        "code": "BK112",
        "ward_code": "BK",
        "ward": "Bình Khánh",
        "street": "Đường Số 20 BK5",
        "street_code": "ĐS20BK5",
        "street_2": "KDC BÌNH KHÁNH 5",
        "street_type": 4,
        "price": null
      },
      {
        "code": "BK113",
        "ward_code": "BK",
        "ward": "Bình Khánh",
        "street": "Đường Số 21 BK5",
        "street_code": "ĐS21BK5",
        "street_2": "KDC BÌNH KHÁNH 5",
        "street_type": 4,
        "price": null
      },
      {
        "code": "BK114",
        "ward_code": "BK",
        "ward": "Bình Khánh",
        "street": "Đường Số 22 BK5",
        "street_code": "ĐS22BK5",
        "street_2": "KDC BÌNH KHÁNH 5",
        "street_type": 4,
        "price": null
      },
      {
        "code": "BK115",
        "ward_code": "BK",
        "ward": "Bình Khánh",
        "street": "Đường Số 23 BK5",
        "street_code": "ĐS23BK5",
        "street_2": "KDC BÌNH KHÁNH 5",
        "street_type": 4,
        "price": null
      },
      {
        "code": "BK116",
        "ward_code": "BK",
        "ward": "Bình Khánh",
        "street": "Đường Số 24 BK5",
        "street_code": "ĐS24BK5",
        "street_2": "KDC BÌNH KHÁNH 5",
        "street_type": 4,
        "price": null
      },
      {
        "code": "BK117",
        "ward_code": "BK",
        "ward": "Bình Khánh",
        "street": "Đường Số 25 BK5",
        "street_code": "ĐS25BK5",
        "street_2": "KDC BÌNH KHÁNH 5",
        "street_type": 4,
        "price": null
      },
      {
        "code": "BK118",
        "ward_code": "BK",
        "ward": "Bình Khánh",
        "street": "Kdc AN BINH Riverside",
        "street_code": "KANBINHR",
        "street_2": "Dự án An Bình Riverside",
        "street_type": null,
        "price": null
      },
      {
        "code": "BK119",
        "ward_code": "BK",
        "ward": "Bình Khánh",
        "street": "Đường Tránh Long Xuyên - Bình Khánh",
        "street_code": "ĐTLXBK",
        "street_2": "Đường Tránh Long Xuyên đoạn qua phường Bình Khánh",
        "street_type": null,
        "price": null
      },
      {
        "code": "BĐ1A",
        "ward_code": "BĐ",
        "ward": "Bình Đức",
        "street": "Trần Hưng Đạo",
        "street_code": "THĐ",
        "street_2": "Cầu Trà Ôn - - Cầu Xếp Bà Lý",
        "street_type": 3,
        "price": 6.5
      },
      {
        "code": "BĐ2",
        "ward_code": "BĐ",
        "ward": "Bình Đức",
        "street": "Đường xung quanh Chợ Trà OÔn",
        "street_code": "ĐCTO",
        "street_2": "Các đường xung quanh khu chợ Trà Ôn",
        "street_type": 3,
        "price": 4
      },
      {
        "code": "BĐ3",
        "ward_code": "BĐ",
        "ward": "Bình Đức",
        "street": "Đường Chùa OÔng",
        "street_code": "ĐCO",
        "street_2": "Cầu Trà Ôn - Kè Sông Hậu",
        "street_type": 4,
        "price": 2
      },
      {
        "code": "BĐ4",
        "ward_code": "BĐ",
        "ward": "Bình Đức",
        "street": "Đường Kè Sông Hậu",
        "street_code": "ĐKSH",
        "street_2": "Suốt tuyến",
        "street_type": 4,
        "price": 2.5
      },
      {
        "code": "BĐ5A",
        "ward_code": "BĐ",
        "ward": "Bình Đức",
        "street": "Đường Aấp Chiến Lược - Bình Đức",
        "street_code": "ĐACLBĐ",
        "street_2": "Trần Hưng Đạo - Kè Sông Hậu",
        "street_type": 4,
        "price": 3
      },
      {
        "code": "BĐ7A",
        "ward_code": "BĐ",
        "ward": "Bình Đức",
        "street": "Đường Trà OÔn",
        "street_code": "ĐTO",
        "street_2": "Cầu Trà Ôn - Cầu rạch Dầu",
        "street_type": 4,
        "price": 2
      },
      {
        "code": "BĐ8",
        "ward_code": "BĐ",
        "ward": "Bình Đức",
        "street": "Đường Rạch Dầu",
        "street_code": "ĐRD",
        "street_2": "Suốt tuyến",
        "street_type": 4,
        "price": 1.5
      },
      {
        "code": "BĐ9",
        "ward_code": "BĐ",
        "ward": "Bình Đức",
        "street": "Đường Cặp Nhà Máy Nước",
        "street_code": "ĐCNMN",
        "street_2": "Suốt đường",
        "street_type": 4,
        "price": 2
      },
      {
        "code": "BĐ10A",
        "ward_code": "BĐ",
        "ward": "Bình Đức",
        "street": "Đường Cặp Rạch Cần Xây",
        "street_code": "ĐCRCX",
        "street_2": "Chân lộ Trần Hưng Đạo - Cầu Liên Khóm",
        "street_type": 4,
        "price": 2
      },
      {
        "code": "BĐ11A",
        "ward_code": "BĐ",
        "ward": "Bình Đức",
        "street": "Đường Cặp Rạch Xếp Bà Lý",
        "street_code": "ĐCRXBL",
        "street_2": "Chân lộ Trần Hưng Đạo - Sông Hậu",
        "street_type": 4,
        "price": 1.5
      },
      {
        "code": "BĐ12",
        "ward_code": "BĐ",
        "ward": "Bình Đức",
        "street": "Đường Cặp Rạch Ngã Cái",
        "street_code": "ĐCRNC",
        "street_2": "Suốt đường",
        "street_type": 4,
        "price": 1
      },
      {
        "code": "BĐ13",
        "ward_code": "BĐ",
        "ward": "Bình Đức",
        "street": "Đường đối diện Nhà Máy Gạch Long Xuyên",
        "street_code": "ĐNMGLX",
        "street_2": "Trần Hưng Đạo - Sông Hậu",
        "street_type": 4,
        "price": 2
      },
      {
        "code": "BĐ14",
        "ward_code": "BĐ",
        "ward": "Bình Đức",
        "street": "Đường Sau Chợ Trà OÔn",
        "street_code": "ĐSCTO",
        "street_2": "Rạch Trà Ôn - Chợ Trà Ôn",
        "street_type": 4,
        "price": 3
      },
      {
        "code": "BĐ15",
        "ward_code": "BĐ",
        "ward": "Bình Đức",
        "street": "Khu dân cư Tỉnh Uủy Bình Đức",
        "street_code": "KTUBĐ",
        "street_2": "Trần Hưng Đạo - Giáp KDC Bình Đức 1",
        "street_type": 4,
        "price": 3
      },
      {
        "code": "BĐ16",
        "ward_code": "BĐ",
        "ward": "Bình Đức",
        "street": "Khu dân cư Tỉnh Đội Bình Đức",
        "street_code": "KTĐBĐ",
        "street_2": "Các đường trong KDC",
        "street_type": 4,
        "price": 2.5
      },
      {
        "code": "BĐ17A",
        "ward_code": "BĐ",
        "ward": "Bình Đức",
        "street": "các Đường Kdc Bình Đức",
        "street_code": "ĐKBĐ",
        "street_2": "Các đường trong KDC",
        "street_type": 4,
        "price": 4
      },
      {
        "code": "BĐ18",
        "ward_code": "BĐ",
        "ward": "Bình Đức",
        "street": "Đường vào Bãi Rác - Bình Đức",
        "street_code": "ĐBRBĐ",
        "street_2": "Suốt đường",
        "street_type": 4,
        "price": 2.5
      },
      {
        "code": "BĐ19",
        "ward_code": "BĐ",
        "ward": "Bình Đức",
        "street": "Đường Cặp Kênh Cây Dong",
        "street_code": "ĐCKCD",
        "street_2": "Suốt đường",
        "street_type": 4,
        "price": 1
      },
      {
        "code": "BĐ20",
        "ward_code": "BĐ",
        "ward": "Bình Đức",
        "street": "Khu Tái Định Cư Bình Đức",
        "street_code": "KTĐCBĐ",
        "street_2": "Các đường trong khu tái định cư",
        "street_type": 4,
        "price": 2
      },
      {
        "code": "BĐ21",
        "ward_code": "BĐ",
        "ward": "Bình Đức",
        "street": "Đường D1 BLX",
        "street_code": "ĐD1BLX",
        "street_2": "Khu dân cư Bắc Long Xuyên",
        "street_type": null,
        "price": null
      },
      {
        "code": "BĐ22",
        "ward_code": "BĐ",
        "ward": "Bình Đức",
        "street": "Đường D2 BLX",
        "street_code": "ĐD2BLX",
        "street_2": "Khu dân cư Bắc Long Xuyên",
        "street_type": null,
        "price": null
      },
      {
        "code": "BĐ23",
        "ward_code": "BĐ",
        "ward": "Bình Đức",
        "street": "Đường D3 BLX",
        "street_code": "ĐD3BLX",
        "street_2": "Khu dân cư Bắc Long Xuyên",
        "street_type": null,
        "price": null
      },
      {
        "code": "BĐ24",
        "ward_code": "BĐ",
        "ward": "Bình Đức",
        "street": "Đường D4 BLX",
        "street_code": "ĐD4BLX",
        "street_2": "Khu dân cư Bắc Long Xuyên",
        "street_type": null,
        "price": null
      },
      {
        "code": "BĐ25",
        "ward_code": "BĐ",
        "ward": "Bình Đức",
        "street": "Đường D5 BLX",
        "street_code": "ĐD5BLX",
        "street_2": "Khu dân cư Bắc Long Xuyên",
        "street_type": null,
        "price": null
      },
      {
        "code": "BĐ26",
        "ward_code": "BĐ",
        "ward": "Bình Đức",
        "street": "Đường D6 BLX",
        "street_code": "ĐD6BLX",
        "street_2": "Khu dân cư Bắc Long Xuyên",
        "street_type": null,
        "price": null
      },
      {
        "code": "BĐ27",
        "ward_code": "BĐ",
        "ward": "Bình Đức",
        "street": "Đường D7 BLX",
        "street_code": "ĐD7BLX",
        "street_2": "Khu dân cư Bắc Long Xuyên",
        "street_type": null,
        "price": null
      },
      {
        "code": "BĐ28",
        "ward_code": "BĐ",
        "ward": "Bình Đức",
        "street": "Đường N1 BLX",
        "street_code": "ĐN1BLX",
        "street_2": "Khu dân cư Bắc Long Xuyên",
        "street_type": null,
        "price": null
      },
      {
        "code": "BĐ29",
        "ward_code": "BĐ",
        "ward": "Bình Đức",
        "street": "Đường N2 BLX",
        "street_code": "ĐN2BLX",
        "street_2": "Khu dân cư Bắc Long Xuyên",
        "street_type": null,
        "price": null
      },
      {
        "code": "BĐ30",
        "ward_code": "BĐ",
        "ward": "Bình Đức",
        "street": "Đường N3 BLX",
        "street_code": "ĐN3BLX",
        "street_2": "Khu dân cư Bắc Long Xuyên",
        "street_type": null,
        "price": null
      },
      {
        "code": "BĐ31",
        "ward_code": "BĐ",
        "ward": "Bình Đức",
        "street": "Đường N4 BLX",
        "street_code": "ĐN4BLX",
        "street_2": "Khu dân cư Bắc Long Xuyên",
        "street_type": null,
        "price": null
      },
      {
        "code": "BĐ32",
        "ward_code": "BĐ",
        "ward": "Bình Đức",
        "street": "Đường N5 BLX",
        "street_code": "ĐN5BLX",
        "street_2": "Khu dân cư Bắc Long Xuyên",
        "street_type": null,
        "price": null
      },
      {
        "code": "BĐ33",
        "ward_code": "BĐ",
        "ward": "Bình Đức",
        "street": "Đường N6 BLX",
        "street_code": "ĐN6BLX",
        "street_2": "Khu dân cư Bắc Long Xuyên",
        "street_type": null,
        "price": null
      },
      {
        "code": "BĐ34",
        "ward_code": "BĐ",
        "ward": "Bình Đức",
        "street": "Đường N7 BLX",
        "street_code": "ĐN7BLX",
        "street_2": "Khu dân cư Bắc Long Xuyên",
        "street_type": null,
        "price": null
      },
      {
        "code": "BĐ35",
        "ward_code": "BĐ",
        "ward": "Bình Đức",
        "street": "Đường Tránh Long Xuyên - Bình Đức",
        "street_code": "ĐTLXBĐ",
        "street_2": "Đường Tránh Long Xuyên đoạn qua phường Bình Đức",
        "street_type": null,
        "price": null
      },
      {
        "code": "MN1",
        "ward_code": "MN",
        "ward": "Mỹ Thạnh",
        "street": "Chưởng Binh Lễ",
        "street_code": "CBL",
        "street_2": "Trần Hưng Đạo - Bến phà Vàm Cống",
        "street_type": 3,
        "price": 5
      },
      {
        "code": "MN2",
        "ward_code": "MN",
        "ward": "Mỹ Thạnh",
        "street": "Trần Hưng Đạo",
        "street_code": "THĐ",
        "street_2": "Nhà máy Gạch ACERA - Cầu Cái Sắn",
        "street_type": 3,
        "price": 7
      },
      {
        "code": "MN3",
        "ward_code": "MN",
        "ward": "Mỹ Thạnh",
        "street": "Phan Xích Long",
        "street_code": "PXL",
        "street_2": "Trần Hưng Đạo vào 150 mét",
        "street_type": 4,
        "price": 1.5
      },
      {
        "code": "MN4",
        "ward_code": "MN",
        "ward": "Mỹ Thạnh",
        "street": "Hồ Huấn Nghiệp",
        "street_code": "HHN",
        "street_2": "Trần Hưng Đạo - Cầu Sáu Bá",
        "street_type": 4,
        "price": 2
      },
      {
        "code": "MN5",
        "ward_code": "MN",
        "ward": "Mỹ Thạnh",
        "street": "Tăng Bạt Hổ",
        "street_code": "TBH",
        "street_2": "Trần Hưng Đạo - Cầu Lộ Xã",
        "street_type": 4,
        "price": 2
      },
      {
        "code": "MN6",
        "ward_code": "MN",
        "ward": "Mỹ Thạnh",
        "street": "Hẻm 1 khóm Thới An",
        "street_code": "H1TA",
        "street_2": "Chưởng Binh Lễ - Nhà máy thức ăn gia súc",
        "street_type": 4,
        "price": 1.5
      },
      {
        "code": "MN7",
        "ward_code": "MN",
        "ward": "Mỹ Thạnh",
        "street": "Hẻm 2 khóm Thới An",
        "street_code": "H2TA",
        "street_2": "Từ Chưởng Binh Lễ - Cầu Củi",
        "street_type": 4,
        "price": 1.5
      },
      {
        "code": "MN8A",
        "ward_code": "MN",
        "ward": "Mỹ Thạnh",
        "street": "Đường Cặp Rạch Cái Dung",
        "street_code": "ĐCRCD",
        "street_2": "Cầu Cái Dung - đi vào",
        "street_type": 4,
        "price": 1.5
      },
      {
        "code": "MN9",
        "ward_code": "MN",
        "ward": "Mỹ Thạnh",
        "street": "Đường Cặp Sông Hậu",
        "street_code": "ĐCSH",
        "street_2": "Cầu Củi - Cty DL Miền Núi An Giang",
        "street_type": 4,
        "price": 1.5
      },
      {
        "code": "MN10",
        "ward_code": "MN",
        "ward": "Mỹ Thạnh",
        "street": "Đường Cặp UBND phường Mỹ Thạnh",
        "street_code": "ĐCUBNDMT",
        "street_2": "Trần Hưng Đạo - Sông Hậu",
        "street_type": 4,
        "price": 1.5
      },
      {
        "code": "MN11",
        "ward_code": "MN",
        "ward": "Mỹ Thạnh",
        "street": "Đường vào Sở Giao Thông cũ",
        "street_code": "ĐSGT",
        "street_2": "Suốt đường",
        "street_type": 4,
        "price": 1.5
      },
      {
        "code": "MN12",
        "ward_code": "MN",
        "ward": "Mỹ Thạnh",
        "street": "Đường cầu Cái Sắn Nhỏ - kênh sân bay",
        "street_code": "ĐCSN",
        "street_2": "",
        "street_type": 4,
        "price": 1.5
      },
      {
        "code": "MN13",
        "ward_code": "MN",
        "ward": "Mỹ Thạnh",
        "street": "Đường lộ mới Hòa Thạnh",
        "street_code": "ĐHT",
        "street_2": "Trần Hưng Đạo - Cầu Mương Thơm Mới (trừ khu dân cư Hòa Thạnh)",
        "street_type": 4,
        "price": 1.8
      },
      {
        "code": "MN15",
        "ward_code": "MN",
        "ward": "Mỹ Thạnh",
        "street": "Đường Rạch Cái Sắn Sâu",
        "street_code": "ĐRCSS",
        "street_2": "Cầu Sáu Nhờ (Năm Sú) - Tờ bản đồ 51 thửa 63",
        "street_type": 4,
        "price": 1.5
      },
      {
        "code": "MN16",
        "ward_code": "MN",
        "ward": "Mỹ Thạnh",
        "street": "Đường cầu Sáu Bá - cầu Mương Thơm mới",
        "street_code": "ĐSBMT",
        "street_2": "",
        "street_type": 4,
        "price": 1.5
      },
      {
        "code": "MN17A",
        "ward_code": "MN",
        "ward": "Mỹ Thạnh",
        "street": "Đường Nhà Máy Gạch Acera",
        "street_code": "ĐNMGA",
        "street_2": "Trần Hưng Đạo - ranh Mỹ Thới - Cầu Bờ Hồ",
        "street_type": 4,
        "price": 1.5
      },
      {
        "code": "MN18",
        "ward_code": "MN",
        "ward": "Mỹ Thạnh",
        "street": "Đường Kdc Hòa Thạnh",
        "street_code": "ĐKHT",
        "street_2": "Các đường trong Khu dân cư Hòa Thạnh",
        "street_type": 4,
        "price": 3
      },
      {
        "code": "MN19",
        "ward_code": "MN",
        "ward": "Mỹ Thạnh",
        "street": "Đường Trục Đông Thạnh A",
        "street_code": "ĐTĐTA",
        "street_2": "Suốt đường",
        "street_type": 4,
        "price": 2.4
      },
      {
        "code": "MN20",
        "ward_code": "MN",
        "ward": "Mỹ Thạnh",
        "street": "Đường bến phụ Phà Vàm Cống",
        "street_code": "ĐPVC",
        "street_2": "Trần Hưng Đạo - Sông Hậu",
        "street_type": 4,
        "price": 2.4
      },
      {
        "code": "MN21",
        "ward_code": "MN",
        "ward": "Mỹ Thạnh",
        "street": "Đường Cặp Rạch Cái Sắn Nhỏ",
        "street_code": "ĐCRCSN",
        "street_2": "Từ cầu Tám The (Tờ BĐ 34 thửa 202)  - Tờ bản đồ 35 thửa 24",
        "street_type": 4,
        "price": 1.5
      },
      {
        "code": "MN22A",
        "ward_code": "MN",
        "ward": "Mỹ Thạnh",
        "street": "Đường Mương Thơm",
        "street_code": "ĐMT",
        "street_2": "cầu Đình - Cầu Tám Bổ - khu dân cư Ba Khuỳnh",
        "street_type": 4,
        "price": 420
      },
      {
        "code": "MN23",
        "ward_code": "MN",
        "ward": "Mỹ Thạnh",
        "street": "Đường cầu Tám Bổ - giáp ranh Vĩnh Trinh",
        "street_code": "ĐTBVT",
        "street_2": "",
        "street_type": 4,
        "price": 300
      },
      {
        "code": "MN24",
        "ward_code": "MN",
        "ward": "Mỹ Thạnh",
        "street": "Đường Ba Khấu - cầu Tư Bọ",
        "street_code": "ĐBKTB",
        "street_2": "",
        "street_type": 4,
        "price": 1
      },
      {
        "code": "MN25",
        "ward_code": "MN",
        "ward": "Mỹ Thạnh",
        "street": "Đường từ ranh Trung Đoàn 3 - cầu kdc Ba Khuỳnh",
        "street_code": "ĐTĐ3BK",
        "street_2": "",
        "street_type": 4,
        "price": 300
      },
      {
        "code": "MN26",
        "ward_code": "MN",
        "ward": "Mỹ Thạnh",
        "street": "Đường cầu Bờ Hồ - cầu Phú Thuận",
        "street_code": "ĐBHPT",
        "street_2": "",
        "street_type": 4,
        "price": 300
      },
      {
        "code": "MN27",
        "ward_code": "MN",
        "ward": "Mỹ Thạnh",
        "street": "Đường cầu Bờ Hồ - cầu Vĩnh Trinh",
        "street_code": "ĐBHVT",
        "street_2": "",
        "street_type": 4,
        "price": 300
      },
      {
        "code": "MN28",
        "ward_code": "MN",
        "ward": "Mỹ Thạnh",
        "street": "Đường Cầu Đình - giáp Vĩnh Trinh",
        "street_code": "ĐCĐVT",
        "street_2": "",
        "street_type": 4,
        "price": 350
      },
      {
        "code": "MN29",
        "ward_code": "MN",
        "ward": "Mỹ Thạnh",
        "street": "Khu vực Cồn Thới Hòa",
        "street_code": "KCTH",
        "street_2": "",
        "street_type": 4,
        "price": 300
      },
      {
        "code": "MN30",
        "ward_code": "MN",
        "ward": "Mỹ Thạnh",
        "street": "Khu dân cư khóm Hưng Thạnh (Khu Vượt Lũ)",
        "street_code": "KHTKVL",
        "street_2": "",
        "street_type": 4,
        "price": 1
      },
      {
        "code": "MN31",
        "ward_code": "MN",
        "ward": "Mỹ Thạnh",
        "street": "Kdc Chợ Cái SAN",
        "street_code": "KCCSAN",
        "street_2": "KDC Hòa Thạnh 1 (giai đoạn 2) - Chợ Cái Sắn",
        "street_type": 4,
        "price": 4
      },
      {
        "code": "MN32",
        "ward_code": "MN",
        "ward": "Mỹ Thạnh",
        "street": "Đường Cặp Rạch Cái Sắn Nhỏ",
        "street_code": "ĐCRCSN",
        "street_2": "Đoạn từ Cầu Cái Sắn nhỏ đến thửa đất số 47, tờ bản đồ số 35",
        "street_type": 4,
        "price": 1.5
      },
      {
        "code": "MN33",
        "ward_code": "MN",
        "ward": "Mỹ Thạnh",
        "street": "Khu dân cư Lê Văn Ngọc",
        "street_code": "KLVN",
        "street_2": "Các đường trong KDC",
        "street_type": 4,
        "price": 1
      },
      {
        "code": "MN34",
        "ward_code": "MN",
        "ward": "Mỹ Thạnh",
        "street": "Khu dân cư Phùng Minh Tăng",
        "street_code": "KPMT",
        "street_2": "Các đường trong KDC",
        "street_type": 4,
        "price": 1
      },
      {
        "code": "MN35",
        "ward_code": "MN",
        "ward": "Mỹ Thạnh",
        "street": "Khu dân cư Phan Văn Lấn",
        "street_code": "KPVL",
        "street_2": "Các đường trong KDC",
        "street_type": 4,
        "price": 1
      },
      {
        "code": "MN36",
        "ward_code": "MN",
        "ward": "Mỹ Thạnh",
        "street": "Khu dân cư Nguyễn Ngọc Trung",
        "street_code": "KNNT",
        "street_2": "Các đường trong KDC",
        "street_type": 4,
        "price": 500
      },
      {
        "code": "MN37",
        "ward_code": "MN",
        "ward": "Mỹ Thạnh",
        "street": "Khu dân cư Mai Chí Hỷ",
        "street_code": "KMCH",
        "street_2": "Các đường trong KDC",
        "street_type": 4,
        "price": 1.2
      },
      {
        "code": "MN38",
        "ward_code": "MN",
        "ward": "Mỹ Thạnh",
        "street": "Khu dân cư Nguyễn Văn Lờ",
        "street_code": "KNVL",
        "street_2": "Các đường trong KDC",
        "street_type": 4,
        "price": 500
      },
      {
        "code": "MN39",
        "ward_code": "MN",
        "ward": "Mỹ Thạnh",
        "street": "Khu dân cư Trung Đoàn 3",
        "street_code": "KTĐ3",
        "street_2": "Các đường trong KDC",
        "street_type": 4,
        "price": 1.5
      },
      {
        "code": "MN40",
        "ward_code": "MN",
        "ward": "Mỹ Thạnh",
        "street": "Khu dân cư Mai Thanh Minh",
        "street_code": "KMTM",
        "street_2": "Các đường trong KDC",
        "street_type": 4,
        "price": 600
      },
      {
        "code": "MN41",
        "ward_code": "MN",
        "ward": "Mỹ Thạnh",
        "street": "Đường Tránh Long Xuyên - Mỹ THạnh",
        "street_code": "ĐTLXMTH",
        "street_2": "Đường Tránh Long Xuyên đoạn qua phường Mỹ Thạnh",
        "street_type": null,
        "price": null
      },
      {
        "code": "MT1",
        "ward_code": "MT",
        "ward": "Mỹ Thới",
        "street": "Trần Hưng Đạo",
        "street_code": "THĐ",
        "street_2": "Nhà máy Gạch ACERA - Cầu rạch Gòi Lớn",
        "street_type": 3,
        "price": 8
      },
      {
        "code": "MT2",
        "ward_code": "MT",
        "ward": "Mỹ Thới",
        "street": "Trần Quang Khải",
        "street_code": "TQK",
        "street_2": "Suốt đường",
        "street_type": 4,
        "price": 6
      },
      {
        "code": "MT3",
        "ward_code": "MT",
        "ward": "Mỹ Thới",
        "street": "Trần Quý Cáp",
        "street_code": "TQC",
        "street_2": "Trần Hưng Đạo - Cầu Đình",
        "street_type": 4,
        "price": 3.5
      },
      {
        "code": "MT4",
        "ward_code": "MT",
        "ward": "Mỹ Thới",
        "street": "Trần Văn OƠn",
        "street_code": "TVO",
        "street_2": "Suốt đường",
        "street_type": 4,
        "price": 2
      },
      {
        "code": "MT5",
        "ward_code": "MT",
        "ward": "Mỹ Thới",
        "street": "Đặng Thúc Liêng",
        "street_code": "ĐTL",
        "street_2": "Suốt đường",
        "street_type": 4,
        "price": 1.6
      },
      {
        "code": "MT6",
        "ward_code": "MT",
        "ward": "Mỹ Thới",
        "street": "Phan Văn Trị",
        "street_code": "PVT",
        "street_2": "Suốt đường",
        "street_type": 4,
        "price": 1.9
      },
      {
        "code": "MT7A",
        "ward_code": "MT",
        "ward": "Mỹ Thới",
        "street": "Đường Cặp Rạch Cái Sao",
        "street_code": "ĐCRCS",
        "street_2": "Vàm sông Hậu - Kênh Bằng Tăng",
        "street_type": 4,
        "price": 1.5
      },
      {
        "code": "MT8A",
        "ward_code": "MT",
        "ward": "Mỹ Thới",
        "street": "Đường Cặp Rạch Gòi Lớn",
        "street_code": "ĐCRGL",
        "street_2": "Vàm rạch Gòi Lớn - Cầu Ngã Cái",
        "street_type": 4,
        "price": 1.5
      },
      {
        "code": "MT9A",
        "ward_code": "MT",
        "ward": "Mỹ Thới",
        "street": "Đường Cặp Rạch Gòi Bé",
        "street_code": "ĐCRGB",
        "street_2": "Trần Hưng Đạo - Cầu Ba Miễu",
        "street_type": 4,
        "price": 1.5
      },
      {
        "code": "MT10",
        "ward_code": "MT",
        "ward": "Mỹ Thới",
        "street": "Đường Cặp Công Viên Mỹ Thới",
        "street_code": "ĐCCVMT",
        "street_2": "Trần Hưng Đạo-Hết ranh công viên Mỹ Thới",
        "street_type": 4,
        "price": 2
      },
      {
        "code": "MT11",
        "ward_code": "MT",
        "ward": "Mỹ Thới",
        "street": "Đường Ba Miễu Trong",
        "street_code": "ĐBMT",
        "street_2": "Suốt đường",
        "street_type": 4,
        "price": 1.5
      },
      {
        "code": "MT12",
        "ward_code": "MT",
        "ward": "Mỹ Thới",
        "street": "Đường Cặp Sông Hậu",
        "street_code": "ĐCSH",
        "street_2": "Rạch Gòi Bé - ranh Mỹ Thạnh",
        "street_type": 4,
        "price": 1.5
      },
      {
        "code": "MT13A",
        "ward_code": "MT",
        "ward": "Mỹ Thới",
        "street": "Đường Cặp Cống Bà Thứ",
        "street_code": "ĐCCBT",
        "street_2": "Trần Hưng Đạo - Cầu Út Cọp",
        "street_type": 4,
        "price": 1.5
      },
      {
        "code": "MT14A",
        "ward_code": "MT",
        "ward": "Mỹ Thới",
        "street": "Đường Cặp Nhà Máy Acera",
        "street_code": "ĐCNMA",
        "street_2": "Trần Hưng Đạo vô",
        "street_type": 4,
        "price": 1.5
      },
      {
        "code": "MT15",
        "ward_code": "MT",
        "ward": "Mỹ Thới",
        "street": "các Đường Dự Định trong Khu Tỉnh Đội",
        "street_code": "ĐDĐKTĐ",
        "street_2": "",
        "street_type": 4,
        "price": 1.6
      },
      {
        "code": "MT16",
        "ward_code": "MT",
        "ward": "Mỹ Thới",
        "street": "Hàn Mạc Tử",
        "street_code": "HMT",
        "street_2": "ĐƯỜNG TRONG KDC TRẦN QUANG KHẢI",
        "street_type": 4,
        "price": 2.5
      },
      {
        "code": "MT17",
        "ward_code": "MT",
        "ward": "Mỹ Thới",
        "street": "Đông Hồ",
        "street_code": "ĐH",
        "street_2": "ĐƯỜNG TRONG KDC TRẦN QUANG KHẢI",
        "street_type": 4,
        "price": 2.5
      },
      {
        "code": "MT18",
        "ward_code": "MT",
        "ward": "Mỹ Thới",
        "street": "Ngô Tất Tố",
        "street_code": "NTT",
        "street_2": "ĐƯỜNG TRONG KDC TRẦN QUANG KHẢI",
        "street_type": 4,
        "price": 2.5
      },
      {
        "code": "MT19",
        "ward_code": "MT",
        "ward": "Mỹ Thới",
        "street": "Vũ Ngọc Phan",
        "street_code": "VNP",
        "street_2": "ĐƯỜNG TRONG KDC TRẦN QUANG KHẢI",
        "street_type": 4,
        "price": 2.5
      },
      {
        "code": "MT20",
        "ward_code": "MT",
        "ward": "Mỹ Thới",
        "street": "Hoàng Ngọc Phách",
        "street_code": "HNP",
        "street_2": "ĐƯỜNG TRONG KDC TRẦN QUANG KHẢI",
        "street_type": 4,
        "price": 2.5
      },
      {
        "code": "MT21",
        "ward_code": "MT",
        "ward": "Mỹ Thới",
        "street": "Nguyễn Hiến Lê",
        "street_code": "NHL",
        "street_2": "ĐƯỜNG TRONG KDC TRẦN QUANG KHẢI",
        "street_type": 4,
        "price": 2.5
      },
      {
        "code": "MT22",
        "ward_code": "MT",
        "ward": "Mỹ Thới",
        "street": "Xuân Diệu",
        "street_code": "XD",
        "street_2": "ĐƯỜNG TRONG KDC TRẦN QUANG KHẢI",
        "street_type": 4,
        "price": 2.5
      },
      {
        "code": "MT23",
        "ward_code": "MT",
        "ward": "Mỹ Thới",
        "street": "Tô Ngọc Vân",
        "street_code": "TNV",
        "street_2": "ĐƯỜNG TRONG KDC TRẦN QUANG KHẢI",
        "street_type": 4,
        "price": 2.5
      },
      {
        "code": "MT24",
        "ward_code": "MT",
        "ward": "Mỹ Thới",
        "street": "Bảo Định Giang",
        "street_code": "BĐG",
        "street_2": "ĐƯỜNG TRONG KDC TRẦN QUANG KHẢI",
        "street_type": 4,
        "price": 2.5
      },
      {
        "code": "MT25",
        "ward_code": "MT",
        "ward": "Mỹ Thới",
        "street": "Nguyên Hồng",
        "street_code": "NH",
        "street_2": "ĐƯỜNG TRONG KDC TRẦN QUANG KHẢI",
        "street_type": 4,
        "price": 2.5
      },
      {
        "code": "MT26",
        "ward_code": "MT",
        "ward": "Mỹ Thới",
        "street": "Nguyễn Trọng Quyền",
        "street_code": "NTQ",
        "street_2": "ĐƯỜNG TRONG KDC TRẦN QUANG KHẢI",
        "street_type": 4,
        "price": 2.5
      },
      {
        "code": "MT27",
        "ward_code": "MT",
        "ward": "Mỹ Thới",
        "street": "Cao Văn Lầu",
        "street_code": "CVL",
        "street_2": "ĐƯỜNG TRONG KDC TRẦN QUANG KHẢI",
        "street_type": 4,
        "price": 2.5
      },
      {
        "code": "MT28",
        "ward_code": "MT",
        "ward": "Mỹ Thới",
        "street": "các Đường Còn Lại Khu Trần Quang Khải",
        "street_code": "ĐCLKTQK",
        "street_2": "ĐƯỜNG TRONG KDC TRẦN QUANG KHẢI Các đường còn lại (Hàn Mạc Tử - Nguyễn Hiến Lê)",
        "street_type": 4,
        "price": 2.5
      },
      {
        "code": "MT29",
        "ward_code": "MT",
        "ward": "Mỹ Thới",
        "street": "Nam Cao",
        "street_code": "NC",
        "street_2": "ĐƯỜNG NỘI BỘ TRONG KDC THẠNH AN (AFIEX)",
        "street_type": 4,
        "price": 2.5
      },
      {
        "code": "MT30",
        "ward_code": "MT",
        "ward": "Mỹ Thới",
        "street": "Nguyễn Công Hoan",
        "street_code": "NCH",
        "street_2": "ĐƯỜNG NỘI BỘ TRONG KDC THẠNH AN (AFIEX)",
        "street_type": 4,
        "price": 2.5
      },
      {
        "code": "MT31",
        "ward_code": "MT",
        "ward": "Mỹ Thới",
        "street": "Vũ Trọng Phụng",
        "street_code": "VTP",
        "street_2": "ĐƯỜNG NỘI BỘ TRONG KDC THẠNH AN (AFIEX)",
        "street_type": 4,
        "price": 2.5
      },
      {
        "code": "MT32",
        "ward_code": "MT",
        "ward": "Mỹ Thới",
        "street": "các Đường Còn Lại Kdc Thạnh An",
        "street_code": "ĐCLKTA",
        "street_2": "ĐƯỜNG NỘI BỘ TRONG KDC THẠNH AN (AFIEX)",
        "street_type": 4,
        "price": 2.5
      },
      {
        "code": "MT33A",
        "ward_code": "MT",
        "ward": "Mỹ Thới",
        "street": "Đường Lộ Cũ Mỹ Thới",
        "street_code": "ĐLCMT",
        "street_2": "Trần Hưng Đạo - cầu Hai Tựu - Khu Lò bún",
        "street_type": 4,
        "price": 2
      },
      {
        "code": "MT34",
        "ward_code": "MT",
        "ward": "Mỹ Thới",
        "street": "Đường vào Trường THPT Mỹ Thới",
        "street_code": "ĐTTHPTMT",
        "street_2": "Suốt đường",
        "street_type": 4,
        "price": 1
      },
      {
        "code": "MT35",
        "ward_code": "MT",
        "ward": "Mỹ Thới",
        "street": "Đường Cái Sao Bờ Hồ",
        "street_code": "ĐCSBH",
        "street_2": "Đường bờ Hồ",
        "street_type": 4,
        "price": 300
      },
      {
        "code": "MT36",
        "ward_code": "MT",
        "ward": "Mỹ Thới",
        "street": "Kdc Đức Thành",
        "street_code": "KĐT",
        "street_2": "Các đường trong KDC",
        "street_type": 4,
        "price": 1.5
      },
      {
        "code": "MT37",
        "ward_code": "MT",
        "ward": "Mỹ Thới",
        "street": "Kdc Chợ Cái SAO",
        "street_code": "KCCSAO",
        "street_2": "Các đường trong KDC Chợ Cái Sao mới",
        "street_type": 4,
        "price": 4
      },
      {
        "code": "MT38",
        "ward_code": "MT",
        "ward": "Mỹ Thới",
        "street": "Kdc UÚt Cọp + Vũ Thị Lếnh",
        "street_code": "KUCVTL",
        "street_2": "Các đường trong KDC",
        "street_type": 4,
        "price": 1
      },
      {
        "code": "MT39",
        "ward_code": "MT",
        "ward": "Mỹ Thới",
        "street": "Kdc Trương Công Hiệu",
        "street_code": "KTCH",
        "street_2": "Các đường trong KDC",
        "street_type": 4,
        "price": 800
      },
      {
        "code": "MT40",
        "ward_code": "MT",
        "ward": "Mỹ Thới",
        "street": "Kdc Khâu Hữu Tầm",
        "street_code": "KKHT",
        "street_2": "Các đường trong KDC",
        "street_type": 4,
        "price": 800
      },
      {
        "code": "MT41",
        "ward_code": "MT",
        "ward": "Mỹ Thới",
        "street": "Đường Tây An Bờ Hồ",
        "street_code": "ĐTABH",
        "street_2": "Đường đối diện NH Đông Á đi vào",
        "street_type": 4,
        "price": 800
      },
      {
        "code": "MT42",
        "ward_code": "MT",
        "ward": "Mỹ Thới",
        "street": "Đường Tránh Long Xuyên - Mỹ Thới",
        "street_code": "ĐTLXMT",
        "street_2": "Đường Tránh Long Xuyên đoạn qua phường Mỹ Thới",
        "street_type": null,
        "price": null
      },
      {
        "code": "MK1",
        "ward_code": "MK",
        "ward": "Mỹ Khánh",
        "street": "Đường Liên Xã Mỹ Khánh",
        "street_code": "ĐLXMK",
        "street_2": "Các đường chính và nhánh",
        "street_type": null,
        "price": 1800
      },
      {
        "code": "MK2",
        "ward_code": "MK",
        "ward": "Mỹ Khánh",
        "street": "Đường Cặp Rạch Thông Lưu",
        "street_code": "ĐCRTL",
        "street_2": "Suốt đường",
        "street_type": null,
        "price": 1100
      },
      {
        "code": "MK3",
        "ward_code": "MK",
        "ward": "Mỹ Khánh",
        "street": "Kdc Trung Tâm Xã Mỹ Khánh",
        "street_code": "KTTXMK",
        "street_2": "Các đường trong KDC",
        "street_type": null,
        "price": 2000
      },
      {
        "code": "MK4",
        "ward_code": "MK",
        "ward": "Mỹ Khánh",
        "street": "Kdc Rạch Thông Lưu",
        "street_code": "KRTL",
        "street_2": "Các đường trong KDC",
        "street_type": null,
        "price": 1000
      },
      {
        "code": "MK5",
        "ward_code": "MK",
        "ward": "Mỹ Khánh",
        "street": "Đường Tránh Long Xuyên - Mỹ Khánh",
        "street_code": "ĐTLXMK",
        "street_2": "Đường Tránh Long Xuyên đoạn qua phường Mỹ Khánh",
        "street_type": null,
        "price": null
      },
      {
        "code": "MHH1",
        "ward_code": "MHH",
        "ward": "Mỹ Hòa Hưng",
        "street": "Kdc Chợ Trà Mơn",
        "street_code": "KCTM",
        "street_2": "Các đường trong KDC",
        "street_type": null,
        "price": 5000
      },
      {
        "code": "MHH2",
        "ward_code": "MHH",
        "ward": "Mỹ Hòa Hưng",
        "street": "Đường liên Xã Mỹ Hòa Hưng",
        "street_code": "ĐXMHH",
        "street_2": "Các đường chính và nhánh qua TTHC xã",
        "street_type": null,
        "price": 1200
      },
      {
        "code": "TS1",
        "ward_code": "TS",
        "ward": "Thoại Sơn",
        "street": "Tỉnh Lộ 943 Thoại Sơn",
        "street_code": "TL943TS",
        "street_2": "Mặt tiền và nhánh đường Tỉnh lộ 943 Thoại Sơn",
        "street_type": null,
        "price": null
      },
      {
        "code": "TS2",
        "ward_code": "TS",
        "ward": "Thoại Sơn",
        "street": "Đường trong huyện THOAI SON",
        "street_code": "ĐTHOAISON",
        "street_2": "Các đường trong Huyện Thoại Sơn (dùng chung)",
        "street_type": null,
        "price": null
      },
      {
        "code": "CT1",
        "ward_code": "CT",
        "ward": "Châu Thành",
        "street": "Quốc Lộ 91 Châu Thành",
        "street_code": "QL91CT",
        "street_2": "Mặt tiền và nhánh đường Quốc lộ 91 Châu Thành",
        "street_type": null,
        "price": null
      },
      {
        "code": "CT2",
        "ward_code": "CT",
        "ward": "Châu Thành",
        "street": "Tỉnh Lộ 941 Châu Thành",
        "street_code": "TL941CT",
        "street_2": "Mặt tiền và nhánh đường Tỉnh lộ 941 Châu Thành",
        "street_type": null,
        "price": null
      },
      {
        "code": "CT3",
        "ward_code": "CT",
        "ward": "Châu Thành",
        "street": "Đường trong huyện CHAU THANH",
        "street_code": "ĐCHAUTHANH",
        "street_2": "Các đường trong Huyện Châu Thành (dùng chung)",
        "street_type": null,
        "price": null
      },
      {
        "code": "NLX1",
        "ward_code": "NLX",
        "ward": "Ngoài Long Xuyên",
        "street": "Đường Ngoài Long Xuyên",
        "street_code": "ĐNLX",
        "street_2": "CHƯA CÓ TÊN ĐƯỜNG (dùng tạm)",
        "street_type": null,
        "price": null
      },
      {
        "code": "CM1",
        "ward_code": "CM",
        "ward": "Chợ Mới",
        "street": "Tỉnh Lộ 944 Chợ Mới",
        "street_code": "TL944CM",
        "street_2": "Mặt tiền và nhánh đường Tỉnh lộ 944 Chợ Mới",
        "street_type": null,
        "price": null
      },
      {
        "code": "CM2",
        "ward_code": "CM",
        "ward": "Chợ Mới",
        "street": "Tỉnh Lộ 946 Chợ Mới",
        "street_code": "TL946CM",
        "street_2": "Mặt tiền và nhánh đường Tỉnh lộ 946 Chợ Mới",
        "street_type": null,
        "price": null
      },
      {
        "code": "CM3",
        "ward_code": "CM",
        "ward": "Chợ Mới",
        "street": "Đường trong huyện CHO MOI",
        "street_code": "ĐCHOMOI",
        "street_2": "Các đường trong Huyện Chợ Mới (dùng chung)",
        "street_type": null,
        "price": null
      },
      {
        "code": "TT1",
        "ward_code": "TT",
        "ward": "Tri Tôn",
        "street": "Tỉnh Lộ 941 Tri Tôn",
        "street_code": "TL941TT",
        "street_2": "Mặt tiền và nhánh đường Tỉnh lộ 941 Tri Tôn",
        "street_type": null,
        "price": null
      },
      {
        "code": "TT2",
        "ward_code": "TT",
        "ward": "Tri Tôn",
        "street": "Tỉnh Lộ 948 Tri Tôn",
        "street_code": "TL948TT",
        "street_2": "Mặt tiền và nhánh đường Tỉnh lộ 948 Tri Tôn",
        "street_type": null,
        "price": null
      },
      {
        "code": "TT3",
        "ward_code": "TT",
        "ward": "Tri Tôn",
        "street": "Đường trong huyện TRI TON",
        "street_code": "ĐTRITON",
        "street_2": "Các đường trong Huyện Tri Tôn (dùng chung)",
        "street_type": null,
        "price": null
      },
      {
        "code": "TN1",
        "ward_code": "TN",
        "ward": "Thốt Nốt",
        "street": "Đường trong phường THOT NOT",
        "street_code": "ĐTHOTNOT",
        "street_2": "Các đường trong Phường Thốt Nốt (dùng chung)",
        "street_type": null,
        "price": null
      },
      {
        "code": "RG1",
        "ward_code": "RG",
        "ward": "Rạch Giá",
        "street": "Đường trong phường RACH GIA",
        "street_code": "ĐRACHGIA",
        "street_2": "Các đường trong Phường Rạch Giá (dùng chung)",
        "street_type": null,
        "price": null
      },
      {
        "code": "CD1",
        "ward_code": "CD",
        "ward": "Châu Đốc",
        "street": "Đường trong phường CHAU DOC",
        "street_code": "ĐCHAUDOC",
        "street_2": "Các đường trong Phường Châu Đốc (dùng chung)",
        "street_type": null,
        "price": null
      }
     ]
}